import React, { useEffect, useState, useCallback, useRef } from "react";
import * as signalR from "@microsoft/signalr";
import qs from "qs";
import { LogLevel, HttpTransportType } from "@microsoft/signalr";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';
//import { useBlocker } from 'react-router-dom';
import { Link as RouterLink } from "react-router-dom"; 
import {
    Box,
    Typography,
    Link as MuiLink,   
    Button,
    TextField,
    Menu,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Checkbox,
    FormControlLabel,
    Dialog, DialogActions, DialogContent, DialogTitle,
    InputAdornment, IconButton, Tooltip, Chip,
    Grid, ListItemText,
    Autocomplete, 
    //OutlinedInput,
    Badge,
    //ToggleButton, ToggleButtonGroup,
} from "@mui/material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { BarChart } from '@mui/x-charts/BarChart';
import { useSearchParams } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ListItemIcon } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import SortIcon from "@mui/icons-material/Sort";
import ChartIcon from "@mui/icons-material/BarChart";
import CloseIcon from "@mui/icons-material/Close";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive"
//import CompareArrowsIcon from "@mui/icons-material/SwapHoriz";
import { SelectChangeEvent } from "@mui/material";
import OrderTable from "../components/OrderTable";
import ViewListIcon from "@mui/icons-material/ViewList";
import GridViewIcon from "@mui/icons-material/GridView";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SaveIcon from "@mui/icons-material/Save";
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import { Delete } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
//import AddIcon from "@mui/icons-material/Add";

import MailIcon from "@mui/icons-material/Mail"; 
/*import OrderDetailsGrid from "./OrderDetailsGrid.tsx";*/
/*import EmailConversation from "./EmailConversation";*/
import { Order, Customer, User, OrderState, OrderService, Service, OrderDetail, Contact, DetailState, OrdersCount, Invoice, OrderInvoice, InvoiceKind, OrderDetailsTaxAssessment, TaxRow, SatisfactionSurveyResult } from "../types";
import { OrderPriority, Reminder, TaxTypeMapping } from "../types";

import Layout from "../components/Layout";
import { usePrompt }  from "../components/Prompt";
import EmailConversation from "../components/EmailConversation.tsx"
import { API_BASE_URL } from "../config.ts";

import { CreatedOnFilter, getCreatedOnRange, getPaymentColor, getPaymentCaption } from "../utils/helpers.ts";
import { loadCache, saveCache } from "../utils/helpers.ts";

import axiosExt, { extractErrorMessage } from '../axios';


import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/pl';
import 'dayjs/locale/ro';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/zh-cn';
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { useTranslation } from "react-i18next";

/*interface MergeOrderRequest {
    mergedToOrderId: string;
}*/

// Generate hour options (0 to 23)
const hourOptions = Array.from({ length: 24 }, (_, i) => i);

// Generate minute options (0, 5, 10, ..., 55)
const minuteOptions = Array.from({ length: 12 }, (_, i) => i * 5);

type Locales = ['en', 'en-gb', 'zh-cn', 'de', 'pl','ro'];
type LocaleKey = Locales[number];

import type { EditableOrderField } from "../types/index"; // adjust path

const createDefaultDetail = (orderId: string, defaultStateId: string, lineNumber: number): OrderDetail => ({
    id: crypto.randomUUID(),
    stateId: defaultStateId ?? "",
    declarantCustomerId: null,
    orderId,
    lineNumber,
    missingInfo:"",
    customerNumber: "",
    containerNumber: "",
    customsReferenceNumber: "",
    ata: "",
    atc: "",
    mrn:"",
    etaDate: null,
    etaIntervalStart: null,
    etaIntervalEnd: null,
    sentToCustoms: false,
    positionsNumber: 0,
    documentsAttached: false,
    notes: "",
    orderDetailsTaxAssessments: null,
    isValidated: false,
    draftServiceInvoiceCreated: false,
    draftServiceInvoiceValidated: false,
    invoiced:false,
    invoiceSent: false,
    invoiceSentAt: null,
    accountingServiceInvoiceId: null,
    accountingServiceInvoiceUrl: null,  
});

const OrderDetailPage = () => {
    const token = localStorage.getItem("token");

    const navigate = useNavigate();
    //const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);
    const { t } = useTranslation();

    const [searchParams, setSearchParams] = useSearchParams();
    const view = searchParams.get("view") === "grid" ? "grid" : "list"; // default to "list"
    const hasFetched = useRef(false);

    const userId = localStorage.getItem("userId");

    
    //const { orderId, orderDetailId } = useParams();
    const location = useLocation();

    // pathParts = ["orderdetailspage", "orderId", "orderDetailId?view=..."]
    //const pathParts = location.pathname.split("/").filter(Boolean); // removes empty parts
    //const orderId = pathParts[1] || undefined;
    //const orderDetailId = pathParts[2] || undefined;

    const [orderId, setOrderId] = useState<string | undefined>();
    const [orderDetailId, setOrderDetailId] = useState<string | undefined>();
    const [viewers, setViewers] = useState<string[]>([]);

    useEffect(() => {
        const parts = location.pathname.split("/").filter(Boolean);
        setOrderId(parts[1]);
        setOrderDetailId(parts[2]);
    }, [location.pathname]);

    const [order, setOrder] = useState<Order>();
    const [orderDetails, setOrderDetails] = useState<OrderDetail[]>([]);
    const [orders, setOrders] = useState<Order[]>([]);
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [unassignedContacts, setUnassignedContacts] = useState<Contact[]>([]);
    const [contacts, setContacts] = useState<Contact[]>([]);
    //const [contactsLoading, setContactsLoading] = useState<boolean>(true);
    const [user, setUser] = useState<User>();
    //const [loading, setLoading] = useState(false);
    const [ordersLoading, setOrdersLoading] = useState(false);
    //const [orderDetailsLoading, setOrderDetailsLoading] = useState(false);

    const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
    const selectedOrderRef = useRef<Order | null>(null);
    //const [compactDetailsView, setCompactDetailsView] = useState(false);
    const [visibleDetailLine, setVisibleDetailLine] = useState<number | null>(null);

    const [users, setUsers] = useState<User[]>([]);
    //const [orderTypes, setOrderTypes] = useState<OrderType[]>([]);
    const [orderStates, setOrderStates] = useState<OrderState[]>([]);
    const [detailStates, setDetailStates] = useState<DetailState[]>([]);
    const [services, setServices] = useState<Service[]>([]);
    const [taxTypeMappings, setTaxTypeMappings] = useState<TaxTypeMapping[]>([]);

    const [tempOrderInvoices, setTempOrderInvoices] = useState<OrderInvoice[]>([]);

    const [linkInvoiceKind, setLinkInvoiceKind] = useState<InvoiceKind>("Services");
    const [linkTaxAssessmentId, setLinkTaxAssessmentId] = useState<string | null>(null);

    const [invoiceBusy, setInvoiceBusy] = useState(false);
    //const [taxesDirty, setTaxesDirty] = useState(false);

    const [confirmUnlinkOpen, setConfirmUnlinkOpen] = useState(false);
    const [invoiceToUnlink, setInvoiceToUnlink] = useState<string | null>(null);

    const [locale, setLocale] = React.useState<LocaleKey>('de');

    const [isDirty, setIsDirty] = useState(false);
    const currentView = searchParams.get("view") || "list";

    const [showEditSubjectDialog, setShowEditSubjectDialog] = useState(false);
    const [tempShortenSubject, setTempShortenSubject] = useState("");

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
        
    const [openDialog, setOpenDialog] = useState(false);
    const [nextPath, setNextPath] = useState<string | null>(null);
    
    const [mergeDialogOpen, setMergeDialogOpen] = useState(false);
    const [customerOrders, setCustomerOrders] = useState<Order[]>([]);
    const [selectedMergeOrder, setSelectedMergeOrder] = useState<Order | null>(null);
    //const [selectedOrderDetail, setSelectedOrderDetail] = useState<OrderDetail | null>(null);
    const [hoveredCustomer, setHoveredCustomer] = useState<Customer | null>(null);
    //const [hoveredDeclarant, setHoveredDeclarant] = useState<Customer | null>(null);
    const contactsForCustomer = contacts.filter(c => c.customerId === selectedOrder?.customerId);

    const customerToShow = hoveredCustomer || customers.find(c => c.id === selectedOrder?.customerId);
    //const declarantCustomerToShow = hoveredDeclarant || customers.find(c => c.id === selectedOrder?.declarantCustomerId);

    const [mergedStateId, setMergedStateId] = React.useState<string>();
    const [mergedToOrderNumber, setMergedToOrderNumber] = React.useState<string>();
    const [mergeSearchText, setMergeSearchText] = useState("");
    const filteredMergeOptions = [...customerOrders]
        .sort((a, b) => (a.internalNumber || "").localeCompare(b.internalNumber || ""))
        .filter(o =>
        (o.internalNumber?.toLowerCase().includes(mergeSearchText.toLowerCase()) ||
            o.initialEmailSubject?.toLowerCase().includes(mergeSearchText.toLowerCase()))
    );

    const [availableInvoices, setAvailableInvoices] = useState<Invoice[]>([]);
    const [linkDialogOpen, setLinkDialogOpen] = useState(false);
    const [linkingInvoice2DetailId, setLinkingInvoice2DetailId] = useState<string | null>(null);
    const [selectedInvoiceId, setSelectedInvoiceId] = useState<string | null>(null);

    //const [editingAssessmentId, setEditingAssessmentId] = useState<string | null>(null);

    const [surveyResults, setSurveyResults] = useState<SatisfactionSurveyResult[]>([]);
    const [surveyDialogOpen, setSurveyDialogOpen] = useState(false);

    const avgRating = surveyResults.length > 0
        ? (surveyResults.reduce((sum, s) => sum + s.score, 0) / surveyResults.length).toFixed(1)
        : null;

    const [priorityAnchorEl, setPriorityAnchorEl] = React.useState<null | HTMLElement>(null);
    const handlePriorityClick = (event: React.MouseEvent<HTMLElement>) => {
        setPriorityAnchorEl(event.currentTarget);
    };

    const handlePriorityClose = () => {
        setPriorityAnchorEl(null);
    };

    const handlePriorityChange = async (newPriority: OrderPriority) => {
        if (!selectedOrder) return;

        setSelectedOrder((prev) =>
            prev ? { ...prev, priority: newPriority } : null
        );
        setPriorityAnchorEl(null);

        if (selectedOrder?.id) {
            try {
                
                const res = await axiosExt.put(
                    `${API_BASE_URL}/orders/${orderId}/priority`,
                    { priority: newPriority },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setOrders(prevOrders =>
                    prevOrders.map(o =>
                        o.id === selectedOrder.id ? { ...o, priority: newPriority } : o
                    )
                );
                return (res.data);
            } catch (err) {
                console.error("Failed to update priority", err);
            }
        }
    };

    const fetchSurveys = async (orderId: string) => {
        try {
            
            const res = await axiosExt.get(`${API_BASE_URL}/orders/${orderId}/surveys`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSurveyResults(res.data);
        } catch (err) {
            console.error("Failed to fetch surveys", err);
        }
    };

    // Reminders state
    const [reminders, setReminders] = useState<Reminder[]>([]);
    const [reminderDialogOpen, setReminderDialogOpen] = useState(false);
    const [editingReminder, setEditingReminder] = useState<Reminder | null>(null);
    const [reminderDate, setReminderDate] = useState<dayjs.Dayjs | null>(null);
    const [reminderNote, setReminderNote] = useState("");
    const [reminderListDialogOpen, setReminderListDialogOpen] = useState(false);

    //const localString = new Date(reminderTimeFromApi).toLocaleString();

    // Popup for due reminders
    const [activeReminder, setActiveReminder] = useState<Reminder | null>(null);

    const fetchReminders = async (orderId: string) => {
        try {
            
            const res = await axiosExt.get(`${API_BASE_URL}/orderreminders/order/${orderId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setReminders(res.data);
        } catch (err) {
            console.error("Failed to load reminders", err);
        }
    };

    const saveReminder = async () => {
        if (!selectedOrder?.id || !reminderDate) return;

        try {
            
            if (editingReminder) {
                await axiosExt.put(`${API_BASE_URL}/orderreminders/${editingReminder.id}`, {
                    reminderDateTimeLocal: reminderDate.toISOString(),
                    note: reminderNote,
                }, { headers: { Authorization: `Bearer ${token}` } });
            } else {
                await axiosExt.post(`${API_BASE_URL}/orderreminders/order/${selectedOrder.id}`, {
                    reminderDateTimeLocal: reminderDate.toISOString(),
                    note: reminderNote,
                }, { headers: { Authorization: `Bearer ${token}` } });
            }

            setReminderDialogOpen(false);
            setEditingReminder(null);
            fetchReminders(selectedOrder.id);
        } catch (err) {
            console.error("Failed to save reminder", err);
        }
    };

    const snoozeReminder = async (id: string, minutes: number) => {
        
        await axiosExt.put(`${API_BASE_URL}/orderreminders/${id}/snooze`, { minutes }, {
            headers: { Authorization: `Bearer ${token}` },
        });
        setActiveReminder(null);
    };

    const dismissReminder = async (id: string) => {
        
        await axiosExt.put(`${API_BASE_URL}/orderreminders/${id}/dismiss`, {}, {
            headers: { Authorization: `Bearer ${token}` },
        });
        setActiveReminder(null);
    };

    const showCustomerNotes = async (notes: string) => {
        enqueueSnackbar(`${t("Notes")}: ${notes}`,
            {
                variant: "error",
                autoHideDuration: 12000, // 12 seconds, adjust as needed
                action: (snackbarId) => (
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={() => closeSnackbar(snackbarId)}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                ),
            }
    )};

   
    function formatUtcToLocal(utcString?: string): string {
        if (!utcString) return "";

        // Ensure we treat it as UTC (append 'Z' if backend didn't include it)
        const isoString = utcString.endsWith("Z") ? utcString : `${utcString}Z`;
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return "";

        return new Intl.DateTimeFormat(undefined, {
            dateStyle: "medium",
            timeStyle: "short",
        }).format(date);
    }

    //to notify users who is viewing the order
    useEffect(() => {
        if (!signalRConnectionRef.current || !selectedOrder || !user) return;

        const connection = signalRConnectionRef.current;

        connection.invoke("joinorder", selectedOrder.id, user.userName).catch(console.error);

        connection.on("orderviewersupdated", (orderId: string, userList: string[]) => {
            if (orderId === selectedOrder.id) {
                setViewers(userList);
            }
        });
        return () => {
            if (selectedOrder && user) {
                connection.invoke("leaveorder", selectedOrder.id, user.userName).catch(console.error);
            }
        };
    }, [selectedOrder?.id, user?.userName]);

    useEffect(() => {
        // Ensure both are available
        if (!selectedOrder?.customerId || !customers || customers.length === 0) return;

        // Try to find the matching customer
        const foundCustomer = customers.find(c => c.id === selectedOrder.customerId);

        if (foundCustomer) {
            // Customer found locally
            if (foundCustomer.notes)
                showCustomerNotes(foundCustomer.notes);
        } else {
            // Not found in local list — fetch it from API
            (async () => {
                try {
                    
                    const response = await axiosExt.get(`${API_BASE_URL}/customers/${selectedOrder.customerId}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    if (response.data?.notes) {
                        showCustomerNotes(response.data.notes);
                    }
                } catch (error) {
                    console.error("Failed to load customer for notes:", error);
                }
            })();
        }
    }, [selectedOrder?.customerId, customers]);


    useEffect(() => {
        if (!user) return;

        if (viewers.length > 1) {
            const others = viewers.filter(v => v !== user.userName);
            const message =
                others.length > 0
                    ? `${t("Warning")}: ${others.join(", ")} ${t("is also viewing this order. Your changes may overwrite theirs.")}`
                    : `${t("Warning")}: ${viewers.join(", ")} ${t("are viewing this order. Your changes may overwrite theirs.")}`;

            enqueueSnackbar(message, { variant: "warning", autoHideDuration: 4000 });
        }
    }, [viewers, user?.userName]);


    //Poll for Due Reminders
    useEffect(() => {
        const interval = setInterval(async () => {
            try {
                
                const res = await axiosExt.get(`${API_BASE_URL}/orderreminders/mine`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (res.data.length > 0) {
                    setActiveReminder(res.data[0]); // show first due
                }
            } catch (err) {
                console.error("Failed to check reminders", err);
            }
        }, 60000); // check every 60s

        return () => clearInterval(interval);
    }, []);

    const handleTaxRowChange = (assessmentId: string, rowId: string, field: string, value: any) => {
        setSelectedOrder((prev) => {
            if (!prev) return prev;

            const updatedAssessments = prev.orderDetailsTaxAssessments?.map((a) => {
                if (a.id !== assessmentId) return a;

                // Update row value
                const updatedRows = (a.taxRows ?? []).map((r) =>
                    r.id === rowId ? { ...r, [field]: value } : r
                );

                // Recalculate total amount
                const total = updatedRows.reduce(
                    (sum, r) => sum + parseFloat(String(r.amount || 0)),
                    0
                );
                //setTaxesDirty(true);
                return { ...a, taxRows: updatedRows, taxAmount: total };
            });

            return { ...prev, orderDetailsTaxAssessments: updatedAssessments };
        });

        setIsDirty(true);
    };

    const handleAddTaxRow = (assessmentId: string) => {
        const newRow: TaxRow = {
            id: crypto.randomUUID(),
            taxTypeMappingId:null,
            taxAssessmentId: assessmentId,
            taxType: "",
            amount: 0,
        };


        setSelectedOrder((prev) => {
            if (!prev) return prev;
            const updatedAssessments = prev.orderDetailsTaxAssessments?.map((a) => {
                if (a.id !== assessmentId) return a;

                const newRows = [...(a.taxRows ?? []), newRow];
                const total = newRows.reduce(
                    (sum, r) => sum + parseFloat(String(r.amount || 0)),
                    0
                );

                return { ...a, taxRows: newRows, taxAmount: total };
            });
            return { ...prev, orderDetailsTaxAssessments: updatedAssessments };
        });

        setIsDirty(true);
    };

    const handleDeleteTaxRow = (assessmentId: string, rowId: string) => {
        setSelectedOrder((prev) => {
            if (!prev) return prev;

            const updatedAssessments = prev.orderDetailsTaxAssessments?.map((a) => {
                if (a.id !== assessmentId) return a;

                const newRows = (a.taxRows ?? []).filter((r) => r.id !== rowId);
                const total = newRows.reduce(
                    (sum, r) => sum + parseFloat(String(r.amount || 0)),
                    0
                );
                //setTaxesDirty(true);
                return { ...a, taxRows: newRows, taxAmount: total };
            });
            return { ...prev, orderDetailsTaxAssessments: updatedAssessments };
        });


        setIsDirty(true);
    };

    const handleDeleteServiceDraft = async (orderDetailId: string) => {
        setInvoiceBusy(true);

        try {
            const detailToDelete = selectedOrder?.orderDetails?.find(d => d.id === orderDetailId);
            const deletedInvoiceId = detailToDelete?.accountingServiceInvoiceId;

            await axiosExt.post(
                `${API_BASE_URL}/orders/${selectedOrder?.id}/detail/${orderDetailId}/delete-draft`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setSelectedOrder(prev => {
                if (!prev) return prev;

                return {
                    ...prev,
                    orderDetails: prev.orderDetails
                        ? prev.orderDetails.map(detail => {
                            const shouldClear =
                                deletedInvoiceId &&
                                detail.accountingServiceInvoiceId === deletedInvoiceId;

                            return shouldClear
                                ? {
                                    ...detail,
                                    draftServiceInvoiceCreated: false,
                                    accountingServiceInvoiceId: null,
                                    accountingServiceInvoiceUrl: null,
                                }
                                : detail;
                        })
                        : null,
                };
            });

            enqueueSnackbar("Draft deleted.", { variant: "success" });
        } catch (err) {
            console.error(err);
            enqueueSnackbar("Unable to delete draft.", { variant: "error" });
        } finally {
            setInvoiceBusy(false);
        }
    };


    const handleServiceInvoice = async () => {
        const token = localStorage.getItem("token");

        try {
            if (!selectedOrder) {
                enqueueSnackbar("Please select at least one order.", { variant: "warning" });
                return;
            }

            const orderId = selectedOrder.id;
            const orderIds = orderId ? [orderId] : [];

            const response = await axiosExt.post(
                `${API_BASE_URL}/orders/create-service-draft-multiple-orders`,
                { orderIds },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const createdDetailIds: string[] = response.data?.orderDetailIds ?? [];
            const invoices = response.data?.invoices ?? [];

            setSelectedOrder(prev => {
                if (!prev) return prev;

                return {
                    ...prev,
                    orderDetails: prev.orderDetails?.map(detail => {
                        if (!detail.id || !createdDetailIds.includes(detail.id)) {
                            return detail;
                        }

                        const matchingInvoice = invoices.find((inv: any) =>
                            Array.isArray(inv.orderDetailIds) &&
                            inv.orderDetailIds.includes(detail.id)
                        );

                        return {
                            ...detail,
                            draftServiceInvoiceCreated: true,
                            accountingServiceInvoiceId: matchingInvoice?.invoiceId ?? detail.accountingServiceInvoiceId,
                            accountingServiceInvoiceUrl: matchingInvoice?.pdfUrl ?? detail.accountingServiceInvoiceUrl,
                        };
                    }) ?? null,
                };
            });

            enqueueSnackbar("Service invoice draft created successfully.", {
                variant: "success",
            });
        } catch (error: any) {
            console.error("Error generating service invoice:", error);

            enqueueSnackbar(
                error?.response?.data || "Failed to create service invoice draft.",
                { variant: "error" }
            );
        }
    };
    const handleDeleteDraft = async (assessmentId: string) => {
        setInvoiceBusy(true);

        try {
            await axiosExt.post(
                `${API_BASE_URL}/orders/${selectedOrder?.id}/tax-assessment/${assessmentId}/delete-draft`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // optimistic UI ONLY AFTER success
            setSelectedOrder(prev => {
                if (!prev) return prev;
                return {
                    ...prev,
                    orderDetailsTaxAssessments: prev.orderDetailsTaxAssessments?.map(a =>
                        a.id === assessmentId
                            ? { ...a, draftCreated: false }
                            : a
                    )
                };
            });

            enqueueSnackbar("Draft deleted.", { variant: "success" });
        }
        catch (err) {
            console.error(err);
            alert("Unable to delete draft.");
        }
        finally {
            setInvoiceBusy(false);
        }
    };


    //filtering 
    const [filterCustomer, setFilterCustomer] = useState<string>("");
    const [filterAssignedTo, setFilterAssignedTo] = useState<string[]>([]); // Default to none
    //const [filterType, setFilterType] = useState<string>("all");
    const [filterState, setFilterState] = useState<string[]>([]);
    const [filterCreatedOn, setFilterCreatedOn] = useState<string>("last_90_days");
    const [filterLastEmailReceivedAt, setFilterLastEmailReceivedAt] = useState<string>("last_90_days");
    const [filterInvoiceStatus, setFilterInvoiceStatus] = useState<string>("last_90_days");
    //const [filterDueDate, setFilterDueDate] = useState<string>("");
    //const [filterNewEmail, setFilterNewEmail] = useState<string>("all");
    // Sorting states

    const sortOptions = [
        { field: "createdDateTime", label: t("Created On") },
        { field: "internalNumber", label: t("Order Number") },
        { field: "lastEmailReceivedAt", label: t("Last Email Received") },
        { field: "etaDate", label: t("ETA Date") },
        { field: "priority", label: t("Priority") },
    ];
    const sortOrders = [
        { value: "asc", label: "Ascending" },
        { value: "desc", label: "Descending" },
    ];
    const [sortMenuAnchor, setSortMenuAnchor] = useState<null | HTMLElement>(null);
    const openSortMenu = Boolean(sortMenuAnchor);

    const [sortField, setSortField] = useState<string>("createdDateTime");
    const [sortOrder, setSortOrder] = useState<string>("desc");
    const [customFilterField, setCustomFilterField] = useState<string>("orderNumber");
    const [customFilterValue, setCustomFilterValue] = useState<string>("");
    const [filterResetTrigger, setFilterResetTrigger] = useState(0);

    const [orderPage, setOrderPage] = useState<number>(0);
    const [hasMoreOrders, setHasMoreOrders] = useState<boolean>(true);

    //order statistics
    const [statisticData, setStatisticData] = React.useState<OrdersCount[]>([]);

    const [showSidebar, setShowSidebar] = useState(true);
    const [hoverSidebar, setHoverSidebar] = useState(false);
    const [emailWidth, setEmailWidth] = useState<number>(50);
    const allowedWidths = [0, 50, 75];

    const increaseEmailWidth = () => {
        setEmailWidth((prev) => {
            const index = allowedWidths.indexOf(prev);
            return index < allowedWidths.length - 1 ? allowedWidths[index + 1] : prev;
        });
    };

    const decreaseEmailWidth = () => {
        setEmailWidth((prev) => {
            const index = allowedWidths.indexOf(prev);
            return index > 0 ? allowedWidths[index - 1] : prev;
        });
    };
    const getGridSize = (emailWidth: number): 3 | 4 | 6 | 12 => {
        switch (emailWidth) {
            case 0:
                return 3;
            case 25:
                return 4;
            case 50:
                return 6;
            case 75:
            default:
                return 12;
        }
    };

    const fieldGridSize = getGridSize(emailWidth);
    /*const emailWidths = [40, 60, 20, 0];

    const increaseEmailWidth = () => {
        const currentIndex = emailWidths.indexOf(emailWidth);
        const nextIndex = (currentIndex + 1) % emailWidths.length;
        setEmailWidth(emailWidths[nextIndex]);
    };

    const decreaseEmailWidth = () => {
        const currentIndex = emailWidths.indexOf(emailWidth);
        const prevIndex = (currentIndex - 1 + emailWidths.length) % emailWidths.length;
        setEmailWidth(emailWidths[prevIndex]);
    };*/

    const handleSortButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setSortMenuAnchor(event.currentTarget);
    };

    const handleCloseSortMenu = () => {
        setSortMenuAnchor(null);
    };

    const handleUpdateOrder = async(customerId: string) => {
        if (!selectedOrder) return;
        //selectedOrder.customerId = customerId;
        setSelectedOrder((prev) => prev ? { ...prev, customerId:customerId} : null);

        try {
            
            const response = await axiosExt.put(
                `${API_BASE_URL}/orders/${selectedOrder.id}/updateCustomer`,
                JSON.stringify(customerId),
                { headers: { "Authorization": `Bearer ${token}` } }
            );

            if (response.status == 401) {
                throw new Error("Unauthorized. Please log in again.");

            }

            // Update sidebar
            //setOrders(prev =>
            //    prev.map(o => (o.id === fullOrder.id ? fullOrder : o))
            //);


        } catch (error) {
            console.error("Error updating customer for order:", error);
            alert("Error updating customer for order.");
        }
    };

    const handleDownloadInvoicePdf = async (invoiceId: string, invoiceNumber: string) => {
        try {
            
            const response = await axiosExt.get(`${API_BASE_URL}/invoices/${invoiceId}/pdf`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: "blob",
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = `${invoiceNumber}.pdf`;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Failed to download invoice PDF", error);
            alert("Could not download invoice PDF.");
        }
    };

    //const handleDownloadTaxDocument = async (attachmentId: string) => {
    //    try {

    //        
    //        const response = await axiosExt.get(`/api/attachments/${attachmentId}`, {
    //            headers: { Authorization: `Bearer ${token}` },
    //            responseType: "blob",
    //        });

    //        const blob = new Blob([response.data]);
    //        const url = window.URL.createObjectURL(blob);

    //        const link = document.createElement("a");
    //        link.href = url;
    //        link.download = "tax-assessment.pdf";
    //        document.body.appendChild(link);
    //        link.click();
    //        link.remove();
    //        window.URL.revokeObjectURL(url);
    //    } catch (error) {
    //        console.error("Download failed:", error);
    //    }
    //};

    const handleDownloadAttachment = async (fileId: string) => {
        try {
            


            // Step 1: Get the file URL from your backend
            const response = await axiosExt.get(`${API_BASE_URL}/emails/download/${fileId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const fileUrl = response.data.fileUrl;
            const downloadAsFileName = response.data.fileName;

            // Step 2: Download file as blob from Azure Blob Storage
            const fileResponse = await axiosExt.get(fileUrl, { responseType: 'blob' });

            const blob = new Blob([fileResponse.data]);
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = downloadAsFileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading the file:", error);
            alert("Failed to download the file.");
        }
    };


    const handleSortChange = (field: string, order: string) => {
        setSortField(field);
        setSortOrder(order);
        const updatedFilters = {
            filterCustomer,
            filterAssignedTo,
            filterState,
            filterCreatedOn,
            filterLastEmailReceivedAt,
            filterInvoiceStatus,
            sortField: field,
            sortOrder: order,
            customFilterField,
            customFilterValue,
        };
        localStorage.setItem("orderFilters", JSON.stringify(updatedFilters));

        setSortMenuAnchor(null);
        setOrders([]);
        setOrderPage(0);
        setHasMoreOrders(true);
        fetchOrders(0, currentView === "grid");
    };
    
    //const handleUnlinkInvoice = async (invoiceId: string) => {
    //    try {
    //        
    //        if (!token || !selectedOrder?.id) return;

    //        await axiosExt.delete(
    //            `${API_BASE_URL}/orders/${selectedOrder.id}/unlinkInvoice/${invoiceId}`,
    //            {
    //                headers: {
    //                    Authorization: `Bearer ${token}`,
    //                },
    //            }
    //        );
    //        // Refresh or remove from local state:
    //        //setOrder((prev) => {
    //        //    if (!prev) return prev; // If prev is undefined, return as-is

    //        //    return {
    //        //        ...prev,
    //        //        invoices: (prev.orderInvoices || []).filter(inv => inv.id !== invoiceId)
    //        //    };
    //        //});
    //        setSelectedOrder(prev => prev ? {
    //            ...prev,
    //            orderInvoices: (prev.orderInvoices || []).filter(oi => oi.invoiceId !== invoiceId)
    //        } : prev);
    //    } catch (err) {
    //        console.error("Error unlinking invoice", err);
    //    }
    //};

    //const handleLinkInvoice = async () => {
    //    if (!selectedInvoiceId || !selectedOrder?.id) return;

    //    try {
    //        
    //        if (!token ) return;

    //        await axiosExt.post(`${API_BASE_URL}/orders/${selectedOrder.id}/linkInvoice`, selectedInvoiceId, {
    //            headers: {
    //                "Content-Type": "application/json",
    //                Authorization: `Bearer ${token}`
    //            }
    //        });

    //        // Update local state
    //        const linkedInvoice = availableInvoices.find(inv => inv.id === selectedInvoiceId);
    //        if (linkedInvoice) {
    //            setSelectedOrder(prev => prev ? ({
    //                ...prev,
    //                orderInvoices: [
    //                    ...(prev.orderInvoices || []),
    //                    {
    //                        orderId: prev.id,
    //                        invoiceId: linkedInvoice.id,
    //                        invoice: linkedInvoice
    //                    }
    //                ]
    //            }) : prev);
    //        }
    //        setLinkDialogOpen(false);
    //        setSelectedInvoiceId(null);
    //    } catch (err) {
    //        console.error("Failed to link invoice", err);
    //    }
    //};

    const handleLinkInvoice = (detailId?:string | null) => {
        if (!selectedInvoiceId || !selectedOrder?.id) return;
        const linkedInvoice = availableInvoices.find(inv => inv.id === selectedInvoiceId);
        if (linkedInvoice?.id) {
        setTempOrderInvoices(prev => [
            ...prev,
            {
                orderId: selectedOrder.id,
                invoiceId: linkedInvoice.id,
                orderDetailId: detailId,
                invoice: {
                    ...linkedInvoice,
                    kind: linkInvoiceKind, // set kind
                    orderDetailsTaxAssessmentId: linkInvoiceKind === "Tax" ? linkTaxAssessmentId : null
                }
            }
        ]);
            setIsDirty(true);
        }

        setLinkDialogOpen(false);
        setSelectedInvoiceId(null);
    };

    const handleUnlinkInvoice = (invoiceId: string) => {
        setTempOrderInvoices(prev => prev.filter(oi => oi.invoiceId !== invoiceId));
        setIsDirty(true);
    };

    const handleOpenLinkDialog = async (kind: InvoiceKind, taxAssessmentId: string | null = null, detailId: string | null) => {
        setLinkingInvoice2DetailId(detailId);

        try {
            
            if (!token) return;

            const normalize = (v: string | number | null | undefined) =>
                v ? String(v).trim() : "";

            const selectedOrderCustomer = customers.find(c => c.id === selectedOrder?.customerId);
            const selectedOrderDeclarant = customers.find(c => c.id === (selectedOrder?.orderDetails?.find((od) => od.id === detailId)?.declarantCustomerId));

            const customerNumber = normalize(selectedOrderCustomer?.accountingCustomerNumber);
            const declarantNumber = normalize(selectedOrderDeclarant?.accountingCustomerNumber);

            const response = await axiosExt.get(
                `${API_BASE_URL}/orders/${selectedOrder?.id}/availableInvoices?customerAccountingNo=${customerNumber}&declarantAccountingNo=${declarantNumber}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const filteredInvoices = response.data;

            //const invNumber = normalize(inv.accountingCustomerNumber);
            //const orderNumber = normalize(selectedOrderCustomer?.accountingCustomerNumber);

            //const filteredInvoices = allInvoices.filter((inv: Invoice) => {
            //    normalize(inv.accountingCustomerNumber), normalize(selectedOrderCustomer?.accountingCustomerNumber) , declarantNumber
            //});

            //// Apply filter based on accountingCustomerId
            //const filteredInvoices = allInvoices.filter((inv: Invoice) =>
            //    inv.accountingCustomerNumber &&
            //    selectedOrderCustomer?.accountingCustomerNumber &&
            //    ((inv.accountingCustomerNumber === selectedOrderCustomer?.accountingCustomerNumber)
            //        || (inv.accountingCustomerNumber === selectedOrderDeclarant?.accountingCustomerNumber))
            //);

            setAvailableInvoices(filteredInvoices);
            setLinkInvoiceKind(kind);
            setLinkTaxAssessmentId(taxAssessmentId);
            setLinkDialogOpen(true);
        } catch (err) {
            console.error("Failed to load available invoices", err);
        }
    };


    const [showStatistics, setShowStatistics] = useState(() => {
        const saved = localStorage.getItem("showStatistics");
        return saved !== null ? JSON.parse(saved) : true;
    });

    const [showFilters, setShowFilters] = useState(() => {
        const saved = localStorage.getItem("showFilters");
        return saved !== null ? JSON.parse(saved) : true;
    });

    const handleViewToggle = (newView: "list" | "grid") => {
        const current = searchParams.get("view");
        if (current !== newView) {
            searchParams.set("view", newView);
            setSearchParams(searchParams);
            //fetchOrders(0, newView === "grid"); // fetch with new view mode
            const newSearchParams = new URLSearchParams();
            setSelectedOrder(null);
            //setSelectedOrderDetail(null);
            newSearchParams.set("view", newView);
            
            navigate(`/orderdetailspage?${newSearchParams.toString()}`);
            fetchOrders(0, newView === "grid"); // 🔁 fetch with new view mode
        }     
    };

    const handleSaveDefaultFilters = () => {
        const defaultFilters = {
            filterCustomer,
            filterAssignedTo,
            filterState,
            filterCreatedOn,
            filterLastEmailReceivedAt,
            filterInvoiceStatus,
            sortField,
            sortOrder,
            customFilterField,
            customFilterValue,
        };
        localStorage.setItem("orderFiltersDefault", JSON.stringify(defaultFilters));
        enqueueSnackbar("Default filters saved.", { variant: "success" });
    };

    const handleRestoreDefaultFilters = () => {
        const stored = localStorage.getItem("orderFiltersDefault");
        const defaultValues = stored
            ? JSON.parse(stored)
            : {
                filterCustomer: "",
                filterAssignedTo: [userId],
                filterState: [],
                filterCreatedOn: "last_90_days",
                filterLastEmailReceivedAt: "last_90_days",
                filterInvoiceStatus:"all",
                sortField: "createdDateTime",
                sortOrder: "desc",
                customFilterField: "orderNumber",
                customFilterValue: "",
            };

        setFilterCustomer(defaultValues.filterCustomer);
        setFilterAssignedTo(defaultValues.filterAssignedTo);
        setFilterState(defaultValues.filterState);
        setFilterCreatedOn(defaultValues.filterCreatedOn);
        setFilterLastEmailReceivedAt(defaultValues.filterLastEmailReceivedAt);
        setSortField(defaultValues.sortField);
        setSortOrder(defaultValues.sortOrder);
        setCustomFilterField(defaultValues.customFilterField);
        setCustomFilterValue(defaultValues.customFilterValue);

        setFilterResetTrigger(prev => prev + 1); // force update effect
    };


    useEffect(() => {
        if (selectedOrder?.customerId) {
            if (contacts?.[0]?.customerId !== selectedOrder?.customerId) {
                fetchContacts(selectedOrder.customerId);    
            }
        } else {
            setContacts([]); // clear if no customer
        }
    }, [selectedOrder?.customerId]);

    useEffect(() => {
        if (filterResetTrigger === 0) return;
        fetchFilteredOrders();
        enqueueSnackbar("Filters restored to default.", { variant: "info" });
    }, [filterResetTrigger]);

    /*const handleViewClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };*/

    const toggleBoolean = (key: "showStatistics" | "showFilters") => {
        const newValue = !eval(key); // get current state value
        localStorage.setItem(key, JSON.stringify(newValue));
        if (key === "showStatistics") {
            setShowStatistics(newValue);
            if (newValue) {
                fetchOrdersStatistics(); // re-fetch when enabling statistics
            }
        }
        if (key === "showFilters") setShowFilters(newValue);
        //handleClose();
    };

    const updateSelectedOrder = (changes: Partial<Order>) => {
        setSelectedOrder((prev) => prev ? { ...prev, ...changes } : null);
        setIsDirty(true);
    };

    //const detailAssessments = selectedOrder?.orderDetailsTaxAssessments?.filter(
    //    (a) => a.orderDetailId === orderDetail.id
    //);

    const fetchOrdersStatistics = async () => {
        //setLoading(true);

        try {
            

            const savedFilters = localStorage.getItem("orderFilters");

            let parsedFilters = {
                filterCustomer: "",
                filterAssignedTo: [userId],
                filterState: [],
                filterCreatedOn: "last_90_days",
                filterLastEmailReceivedAt: "",
                filterInvoiceStatus: "all",
                sortField: "createdDateTime",
                sortOrder: "desc",
                customFilterField,
                customFilterValue,
            };

            let sf: string = "createdDateTime";
            let so: string = "desc";

            if (savedFilters) {
                parsedFilters = JSON.parse(savedFilters);
                setFilterCustomer(parsedFilters.filterCustomer);

                //setFilterAssignedTo(parsedFilters.filterAssignedTo);
                const restoredFilterAssignedTo = parsedFilters.filterAssignedTo;
                //setFilterAssignedTo(Array.isArray(restoredFilterAssignedTo) ? restoredFilterAssignedTo : []);
                setFilterAssignedTo(
                    Array.isArray(restoredFilterAssignedTo)
                        ? restoredFilterAssignedTo.filter((v): v is string => typeof v === "string")
                        : []
                );

                //setFilterState(parsedFilters.filterState);
                const restoredFilterState = parsedFilters.filterState;
                setFilterState(Array.isArray(restoredFilterState) ? restoredFilterState : []);

                setFilterCreatedOn(parsedFilters.filterCreatedOn);
                setFilterLastEmailReceivedAt(parsedFilters.filterLastEmailReceivedAt);
                setFilterInvoiceStatus(parsedFilters.filterLastEmailReceivedAt);
                sf = parsedFilters.sortField;
                setSortField(sf);
                so = parsedFilters.sortOrder;
                setSortOrder(so);

                setCustomFilterField(parsedFilters.customFilterField || "orderNumber");
                setCustomFilterValue(parsedFilters.customFilterValue || "");
            };

            const filterFields = [];
            const filterOperations = [];
            const filterValues = [];

            if (parsedFilters.filterCustomer && parsedFilters.filterCustomer !== "all_customers") {
                filterFields.push("CustomerId");
                filterOperations.push("Equals");
                filterValues.push(parsedFilters.filterCustomer);
            }

            //if (parsedFilters.filterAssignedTo && parsedFilters.filterAssignedTo. !== "all_users") {
            if (parsedFilters.filterAssignedTo && parsedFilters.filterAssignedTo.length>0) {
                filterFields.push("AssignedToUserGuid");
                filterOperations.push("In");
                //filterValues.push(parsedFilters.filterAssignedTo);
                filterValues.push(parsedFilters.filterAssignedTo.join(","));
            }

            if (parsedFilters.filterState && parsedFilters.filterState.length > 0) {
                filterFields.push("StateGuid");
                filterOperations.push("In"); // or your API-specific 'Contains', 'In', etc.
                //filterValues.push(parsedFilters.filterState);
                filterValues.push(parsedFilters.filterState.join(","));
            }


            // Handle CreatedOn filter by building a date range
            const createdOnRange = getCreatedOnRange(parsedFilters.filterCreatedOn as CreatedOnFilter);
            if (createdOnRange) {
                const startString = createdOnRange.start.format("YYYY-MM-DDTHH:mm:ss");
                const endString = createdOnRange.end.format("YYYY-MM-DDTHH:mm:ss");

                // CreatedDateTime >= start
                filterFields.push("CreatedDateTime");
                filterOperations.push("OnOrAfter");
                filterValues.push(startString);

                // CreatedDateTime <= end
                filterFields.push("CreatedDateTime");
                filterOperations.push("OnOrBefore");
                filterValues.push(endString);
            }

            // Handle Due Date filter by building a date range
            /*const dueDateRange = getCreatedOnRange(parsedFilters.filterDueDate as CreatedOnFilter);
            if (dueDateRange) {
                const startString = dueDateRange.start.format("YYYY-MM-DDTHH:mm:ss");
                const endString = dueDateRange.end.format("YYYY-MM-DDTHH:mm:ss");

                // DueDate >= start
                filterFields.push("DueDate");
                filterOperations.push("OnOrAfter");
                filterValues.push(startString);

                // DueDate <= end
                filterFields.push("DueDate");
                filterOperations.push("OnOrBefore");
                filterValues.push(endString);
            }*/

            const lastEmailReceivedAt = getCreatedOnRange(parsedFilters.filterLastEmailReceivedAt as CreatedOnFilter);
            if (lastEmailReceivedAt) {
                const startString = lastEmailReceivedAt.start.format("YYYY-MM-DDTHH:mm:ss");
                const endString = lastEmailReceivedAt.end.format("YYYY-MM-DDTHH:mm:ss");

                // lastEmailReceivedAt >= start
                filterFields.push("LastEmailReceivedAt");
                filterOperations.push("OnOrAfter");
                filterValues.push(startString);

                // lastEmailReceivedAt <= end
                filterFields.push("lastEmailReceivedAt");
                filterOperations.push("OnOrBefore");
                filterValues.push(endString);
            }

            if (parsedFilters.filterInvoiceStatus != "all") {
                filterFields.push("invoicestatus");
                filterOperations.push("equal");
                filterValues.push(filterInvoiceStatus);

            }

            if (parsedFilters.customFilterValue && parsedFilters.customFilterValue.trim() !== "") {
                const fieldMap: Record<string, string> = {
                    orderNumber: "InternalNumber",
                    invoiceNumber: "InvoiceNumber",
                    customerReference: "CustomerReferenceNumber",
                    customsReferenceNumber: "CustomsReferenceNumber",
                    containerNumber: "ContainerNumber",
                    ataNumber: "ATA",
                    atc: "ATC",
                    mrn: "MRN",
                    InitialEmailSubject: "InitialEmailSubject"
                };

                const mappedField = fieldMap[parsedFilters.customFilterField];
                if (mappedField) {
                    filterFields.push(mappedField);
                    filterOperations.push("Equals");
                    filterValues.push(parsedFilters.customFilterValue);
                }
            }

            const params = {
                filterFields,
                filterOperations,
                filterValues,
            };

            const response = await axiosExt.get(`${API_BASE_URL}/orders/get-orders-statistics?`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                params: params,
                paramsSerializer: {
                    serialize: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
                },
            });

            setStatisticData(response.data);
        } catch (error) {
            console.error("Error fetching services:", error);
        } finally {
            //setLoading(false);
        }
    }

    const handleDeleteOrder = (id: string) => {
        setOrders((prev) => prev.filter((o) => o.id !== id));
    };

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
        if (isDirty) {
            e.preventDefault(); window.removeEventListener('beforeunload', handleBeforeUnload);
            e.returnValue = ''; // Standard way to trigger a browser confirmation
        }
    };

    const handleValidateAssessment = async (orderId: string , assessmentId: string) => {
        setInvoiceBusy(true);

        try {
            const token = localStorage.getItem("token");

            await axiosExt.post(
                `${API_BASE_URL}/orders/${orderId}/tax-assessment/${assessmentId}/validate-draft`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setSelectedOrder((prev) => {
                if (!prev) return prev;
                const updated = prev.orderDetailsTaxAssessments?.map((a) =>
                    a.id === assessmentId ? { ...a, draftValidated: true } : a
                );
                return { ...prev, orderDetailsTaxAssessments: updated };
            });

            enqueueSnackbar("Tax assessment validated.", { variant: "success" });
        } catch (error: any) {
            console.error("Failed to validate assessment", error);

            enqueueSnackbar(
                error?.response?.data ?? "Failed to validate assessment.",
                { variant: "error" }
            );
        }
        finally {
            setInvoiceBusy(false);
        }
    };

    const handleCreateDraftServiceInvoice = async (orderId: string, detailId: string) => {
        setInvoiceBusy(true);

        try {
            const token = localStorage.getItem("token");

            //check customer has accounting id, if not show an error

            await axiosExt.post(
                `${API_BASE_URL}/orders/${orderId}/detail/${detailId}/create-service-draft`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // optimistic UI ONLY AFTER success
            setSelectedOrder(prev => {
                if (!prev) return prev;

                return {
                    ...prev,
                    orderDetails: prev.orderDetails
                        ? prev.orderDetails.map(a =>
                            a.id === detailId
                                ? { ...a, draftServiceInvoiceCreated: true }
                                : a
                        )
                        : null
                };
            })

            enqueueSnackbar("Service draft invoice created.", { variant: "success" });

        } catch (error: any) {
            console.error("Failed to create draft service invoice", error);

            enqueueSnackbar(
                error?.response?.data ?? "Failed to create draft service invoice.",
                { variant: "error" }
            );
        }
        finally {
            setInvoiceBusy(false);
        }
    };


    const handleCreateDraftTaxInvoice = async (orderId: string, assessmentId: string) => {
        setInvoiceBusy(true);

        try {
            const token = localStorage.getItem("token");

            //check customer has accounting id, if not show an error

            await axiosExt.post(
                `${API_BASE_URL}/orders/${orderId}/tax-assessment/${assessmentId}/create-draft`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // optimistic UI ONLY AFTER success
            setSelectedOrder(prev => {
                if (!prev) return prev;
                return {
                    ...prev,
                    orderDetailsTaxAssessments: prev.orderDetailsTaxAssessments?.map(a =>
                        a.id === assessmentId
                            ? { ...a, draftCreated: true }
                            : a
                    )
                };
            });

            enqueueSnackbar("Tax draft invoice created.", { variant: "success" });

            // optional but recommended
            // await refetchOrder();
            // await refetchInvoices();

        } catch (error: any) {
            console.error("Failed to create tax draft invoice", error);

            enqueueSnackbar(
                error?.response?.data ?? "Failed to create tax draft invoice.",
                { variant: "error" }
            );
        }
        finally {
            setInvoiceBusy(false);
        }
    };

    const handleSendInvoice = async (assessmentId: string) => {

        //const url = `${API_BASE_URL}/${orderId}/tax-assessment/${assessmentId}/pdf/${invoiceId}/pdf`;
        //window.open(url, "_blank");
        setInvoiceBusy(true);
        try {
            await axiosExt.post(
                `${API_BASE_URL}/orders/${selectedOrder?.id}/tax-assessment/${assessmentId}/send-invoice`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );
            enqueueSnackbar("Invoice sent.", { variant: "success" });
        } catch (err) {
            console.error(err);
            alert("Unable to send invoice.");
        }
        finally {
            setInvoiceBusy(false);
        }
    };

    const handleSendServiceInvoice = async (detailId: string) => {

        try {
            await axiosExt.post(
                `${API_BASE_URL}/orders/${selectedOrder?.id}/detail/${detailId}/send-invoice`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );
            enqueueSnackbar("Invoice sent.", { variant: "success" });
        } catch (err) {
            console.error(err);
            alert("Unable to send invoice.");
        }
    };

    //const handleViewDraft = async (orderId: string, assessmentId: string) => {
    //    setInvoiceBusy(true);
    //    try {
    //        const response = await fetch(
    //            `${API_BASE_URL}/orders/${orderId}/tax-assessment/${assessmentId}/draft-pdf/`,
    //            {
    //                method: "GET",
    //                headers: {
    //                    Authorization: `Bearer ${localStorage.getItem("token")}`,
    //                },
    //            }
    //        );

    //        if (!response.ok) {
    //            setInvoiceBusy(false);
    //            throw new Error("Failed to load invoice PDF");
    //        }

    //        const blob = await response.blob();
    //        const blobUrl = URL.createObjectURL(blob);

    //        window.open(blobUrl, "_blank");
    //    } catch (err) {
    //        console.error(err);
    //        alert("Unable to open invoice PDF.");
    //    }
    //    finally {
    //        setInvoiceBusy(false);
    //    }
    //};

    
    const handleViewServiceInvoice = async (detailId: string) : Promise<boolean> => {
        try {
            const response = await fetch(
                `${API_BASE_URL}/orders/${selectedOrder?.id}/detail/${detailId}/service-invoice-pdf/`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            if (!response.ok) {
                setInvoiceBusy(false);
                return(false);
                //throw new Error("Failed to load invoice PDF");
            }

            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, "_blank");
            return true;
        } catch (err) {
            console.error(err);
            alert("Unable to open invoice PDF.");
            return false;
        }
    };

    const handleViewInvoice = async (orderId: string, assessmentId: string) => {
        setInvoiceBusy(true);
        try {
            const response = await fetch(
                `${API_BASE_URL}/orders/${orderId}/tax-assessment/${assessmentId}/pdf/`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            if (!response.ok) {
                setInvoiceBusy(false);
                throw new Error("Failed to load invoice PDF");
            }

            // optimistic UI ONLY AFTER success
            setSelectedOrder(prev => {
                if (!prev) return prev;
                return {
                    ...prev,
                    orderDetailsTaxAssessments: prev.orderDetailsTaxAssessments?.map(a =>
                        a.id === assessmentId
                            ? { ...a, invoiced: true }
                            : a
                    )
                };
            });

            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, "_blank");
        } catch (err) {
            console.error(err);
            alert("Unable to open invoice PDF.");
        }
        finally {
            setInvoiceBusy(false);
        }
    };

    //const handleFinalizeServiceInvoice = async (detailId: string) => {
    //    //console.log("Order detail id", detailId);
    //    try {
    //        const result = await handleViewServiceInvoice(detailId);

    //        // optimistic UI ONLY AFTER success
    //        if (result)
    //            setSelectedOrder(prev => {
    //                if (!prev) return prev;

    //                return {
    //                    ...prev,
    //                    orderDetails: prev.orderDetails
    //                        ? prev.orderDetails.map(a =>
    //                            a.id === detailId
    //                                ? { ...a, invoiced: true }
    //                                : a
    //                        )
    //                        : null // enforce correct type
    //                };
    //            });

    //    } catch (err) {
    //        console.error(err);
    //        alert("Unable to open invoice PDF.");
    //    }
    //};
    const handleFinalizeServiceInvoice = async (detailId: string) => {
        try {
            const detailToFinalize = selectedOrder?.orderDetails?.find(d => d.id === detailId);
            const finalizedInvoiceId = detailToFinalize?.accountingServiceInvoiceId;

            const result = await handleViewServiceInvoice(detailId);

            if (result) {
                setSelectedOrder(prev => {
                    if (!prev) return prev;

                    return {
                        ...prev,
                        orderDetails: prev.orderDetails
                            ? prev.orderDetails.map(detail => {
                                const shouldMarkInvoiced = finalizedInvoiceId
                                    ? detail.accountingServiceInvoiceId === finalizedInvoiceId
                                    : detail.id === detailId;

                                return shouldMarkInvoiced
                                    ? { ...detail, invoiced: true }
                                    : detail;
                            })
                            : null
                    };
                });
            }
        } catch (err) {
            console.error(err);
            alert("Unable to open invoice PDF.");
        }
    };

    
    const fetchOrders = useCallback(async (page = 0, loadAll = false) => {
        //if (page !== 0 && page === orderPage) return; // prevent same page refetch
        setOrdersLoading(true);

        try {
            
            const savedFilters = localStorage.getItem("orderFilters");

            let parsedFilters = {
                filterCustomer: "",
                filterAssignedTo: [userId],
                filterState: [],
                filterCreatedOn: "last_90_days",
                //filterDueDate: "",
                filterLastEmailReceivedAt: "last_90_days",
                filterInvoiceStatus:"all",
                sortField: "createdDateTime",   
                sortOrder: "desc",
                customFilterField,
                customFilterValue,
            };

            let sf: string = "createdDateTime";
            let so: string = "desc";

            if (savedFilters) {
                parsedFilters = JSON.parse(savedFilters);
                setFilterCustomer(parsedFilters.filterCustomer);
                //setFilterAssignedTo(parsedFilters.filterAssignedTo);
                const restoredFilterAssignedTo = parsedFilters.filterAssignedTo;
                //setFilterAssignedTo(Array.isArray(restoredFilterAssignedTo) ? restoredFilterAssignedTo : []);
                setFilterAssignedTo(
                    Array.isArray(restoredFilterAssignedTo)
                        ? restoredFilterAssignedTo.filter((v): v is string => typeof v === "string")
                        : []
                );

                //setFilterState(parsedFilters.filterState);
                const restoredFilterState = parsedFilters.filterState;
                setFilterState(Array.isArray(restoredFilterState) ? restoredFilterState : []);
                
                setFilterCreatedOn(parsedFilters.filterCreatedOn);
                setFilterLastEmailReceivedAt(parsedFilters.filterLastEmailReceivedAt);
                setFilterInvoiceStatus(parsedFilters.filterInvoiceStatus);
                //setFilterDueDate(parsedFilters.filterDueDate);
                sf = parsedFilters.sortField;
                setSortField(sf);
                so = parsedFilters.sortOrder;
                setSortOrder(so);

                setCustomFilterField(parsedFilters.customFilterField || "orderNumber");
                setCustomFilterValue(parsedFilters.customFilterValue || "");
            };

            const filterFields = [];
            const filterOperations = [];
            const filterValues = [];

            if (parsedFilters.filterCustomer && parsedFilters.filterCustomer !== "all_customers") {
                filterFields.push("CustomerId");
                filterOperations.push("Equals");
                filterValues.push(parsedFilters.filterCustomer);
            }

            if (parsedFilters.filterInvoiceStatus && parsedFilters.filterInvoiceStatus !== "all") {
                filterFields.push("invoicestatus");
                filterOperations.push("Equals");
                filterValues.push(parsedFilters.filterInvoiceStatus);
            }

            //if (parsedFilters.filterAssignedTo && parsedFilters.filterAssignedTo !== "all_users") {
            if (parsedFilters.filterAssignedTo && parsedFilters.filterAssignedTo.length > 0) {
                filterFields.push("AssignedToUserGuid");
                //filterOperations.push("Equals");
                filterOperations.push("In");
                //if (parsedFilters.filterAssignedTo === "not_assigned") {
                //    filterValues.push(""); // Empty string means null in API logic
                //} else {
                //    filterValues.push(parsedFilters.filterAssignedTo);
                //}
                filterValues.push(parsedFilters.filterAssignedTo.join(","));
                
            }

            if (parsedFilters.filterState && parsedFilters.filterState.length > 0) {
                filterFields.push("StateGuid");
                filterOperations.push("In"); // or your API-specific 'Contains', 'In', etc.
                //filterValues.push(parsedFilters.filterState);
                filterValues.push(parsedFilters.filterState.join(","));
            }


            // Handle CreatedOn filter by building a date range
            const createdOnRange = getCreatedOnRange(parsedFilters.filterCreatedOn as CreatedOnFilter);
            if (createdOnRange) {
                const startString = createdOnRange.start.format("YYYY-MM-DDTHH:mm:ss");
                const endString = createdOnRange.end.format("YYYY-MM-DDTHH:mm:ss");

                // CreatedDateTime >= start
                filterFields.push("CreatedDateTime");
                filterOperations.push("OnOrAfter");
                filterValues.push(startString);

                // CreatedDateTime <= end
                filterFields.push("CreatedDateTime");
                filterOperations.push("OnOrBefore");
                filterValues.push(endString);
            }

            // Handle LastEmailReceivedAt filter by building a date range
            const lastEmailReceivedAtRange = getCreatedOnRange(parsedFilters.filterLastEmailReceivedAt as CreatedOnFilter);
            if (lastEmailReceivedAtRange) {
                const startString = lastEmailReceivedAtRange.start.format("YYYY-MM-DDTHH:mm:ss");
                const endString = lastEmailReceivedAtRange.end.format("YYYY-MM-DDTHH:mm:ss");

                // LastEmailReceivedAt >= start
                filterFields.push("LastEmailReceivedAt");
                filterOperations.push("OnOrAfter");
                filterValues.push(startString);

                // LastEmailReceivedAt <= end
                filterFields.push("LastEmailReceivedAt");
                filterOperations.push("OnOrBefore");
                filterValues.push(endString);
            }

            if (parsedFilters.customFilterValue && parsedFilters.customFilterValue.trim() !== "") {
                const fieldMap: Record<string, string> = {
                    orderNumber: "InternalNumber",
                    invoiceNumber:"InvoiceNumber",
                    customerReference: "CustomerReferenceNumber",
                    customsReferenceNumber: "CustomsReferenceNumber",
                    containerNumber: "ContainerNumber",
                    ataNumber: "ATA",
                    atc: "ATC", 
                    mrn: "MRN",
                    InitialEmailSubject: "InitialEmailSubject"
                };

                const mappedField = fieldMap[parsedFilters.customFilterField];
                if (mappedField) {
                    const operation = parsedFilters.customFilterField === "InitialEmailSubject" ? "Contains" : "Equals";
                    filterFields.push(mappedField);
                    filterOperations.push(operation);
                    filterValues.push(parsedFilters.customFilterValue);
                }
            }

            const params = {
                page: loadAll ? 0 : page,
                pageSize: loadAll ? 9999 : 25,
                sortField: sf,      
                sortOrder: so,      
                filterFields,
                filterOperations,
                filterValues,
            };

            const response = await axiosExt.get(`${API_BASE_URL}/orders?`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                params: params,
                paramsSerializer: {
                    serialize: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
                },
            });

            //setOrders(response.data.data);
            //setTotalRows(response.data.totalRecords);
            const newOrders = response.data.data;

            /*if (loadAll) {
                setOrders(newOrders);
            } else {
                setOrders(prev => {
                    const existingIds = new Set(prev.map(o => o.id));
                    const filtered = newOrders.filter((o: Order) => !existingIds.has(o.id));
                    let combined = [...prev, ...filtered];

                    if (selectedOrder && !combined.some(o => o.id === selectedOrder.id)) {
                        combined = [selectedOrder, ...combined];
                    }

                    return combined;
                });
            }*/
            if (page === 0 || loadAll) {
                setOrders(newOrders);
            } else {
                setOrders(prev => {
                    const existingIds = new Set(prev.map(o => o.id));
                    const filtered = newOrders.filter((o: Order) => !existingIds.has(o.id));
                    return [...prev, ...filtered];
                });
            }



            // This must be AFTER fetch success
            setOrderPage(page);

            if (newOrders.length < params.pageSize) {
                setHasMoreOrders(false);
            }

            //localStorage.setItem("ordersList", JSON.stringify(newOrders));
            /*localStorage.setItem("ordersList", JSON.stringify({
                timestamp: Date.now(),
                data: newOrders
            }))*/
            saveCache("ordersList", newOrders);
            localStorage.setItem("orderPage", page.toString());
            localStorage.setItem("hasMoreOrders", (newOrders.length < params.pageSize) ? "false" : "true");

        } catch (error) {
            console.error("Error fetching orders:", error);
        } finally {
            setOrdersLoading(false);
        }

    },[]);//, [page, pageSize, sortModel, filterModel]);  // Dependencies to prevent infinite loop

    useEffect(() => {
        //const savedOrdersRaw = localStorage.getItem("ordersList");
        //const savedPage = localStorage.getItem("orderPage");
        //const savedHasMore = localStorage.getItem("hasMoreOrders");

        //let cacheValid = false;

        fetchServices();
        fetchTaxTypeMappings();
        //fetchOrderTypes();
        fetchOrderStates();
        fetchDetailStates();
        fetchCustomers();
        fetchUnassignedContacts();

        /*if (savedOrdersRaw) {
            const savedOrdersParsed = JSON.parse(savedOrdersRaw);

            if (savedOrdersParsed.timestamp && savedOrdersParsed.data) {
                const cacheAgeMinutes = (Date.now() - savedOrdersParsed.timestamp) / 1000 / 60;

                if (cacheAgeMinutes <= 5) {  // ⏰ cache is fresh if <= 5 minutes
                    cacheValid = true;
                    setOrders(savedOrdersParsed.data);
                    if (savedPage) setOrderPage(parseInt(savedPage));
                    if (savedHasMore !== null) setHasMoreOrders(savedHasMore === "true");
                }
            }
        }

        if (!cacheValid) {
            console.log("Cache expired or missing. Fetching fresh orders...");
        } else {
            console.log("Using cached orders...");
        }*/

        fetchUser();
        fetchUsers();
        if (users.length > 0 && (!filterAssignedTo || filterAssignedTo.length === 0)) {
            setFilterAssignedTo(users.map(u => u.id)); // select all users
        }

        const cachedOrders = loadCache<Order[]>("ordersList", 5);

        if (cachedOrders) {
            setOrders(cachedOrders);
            if (showStatistics)
                fetchOrdersStatistics();
        }
        if (!hasFetched.current && (!cachedOrders || currentView === "grid")) {
            hasFetched.current = true;
            fetchOrders(0, currentView === "grid");
            if (showStatistics)
                fetchOrdersStatistics();
        }

        setLocale('de');
        setHasMoreOrders(true); 

    }, []);

    const signalRConnectionRef = useRef<signalR.HubConnection | null>(null);

    useEffect(() => {
        //if (!selectedOrder) return; // Wait until order is shown

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${API_BASE_URL}/orderHub`, {
                transport: HttpTransportType.WebSockets,
                withCredentials: true
            })
            .configureLogging(LogLevel.Debug)
            .withAutomaticReconnect()
            .build();

        connection.serverTimeoutInMilliseconds = 600000;

        signalRConnectionRef.current = connection;

        connection.onreconnected((connectionId) => {
            console.log("Reconnected to SignalR hub with connection ID:", connectionId);
            if (selectedOrder?.id) fetchOrder(selectedOrder.id); // refresh UI on reconnection
        });

        connection.onclose((error) => {
            console.error("SignalR connection closed:", error);
            setTimeout(() => {
                connection.start().catch(err => console.error("Reconnection failed:", err));
            }, 5000);
        });

        async function startConnection() {
            try {
                await connection.start();
                console.log("Connected to SignalR hub");
            } catch (err) {
                console.error("Error connecting to SignalR:", err);
                setTimeout(startConnection, 5000); // Retry if it fails
            }
        }

        startConnection();

        connection.on("orderdeleted", (deletedOrderId) => {
            setOrders(prevOrders =>
                prevOrders.filter(order => order.id !== deletedOrderId)
            );

            // If the deleted order was selected, clear it
            if ((selectedOrder?.id === deletedOrderId) || (orderId === deletedOrderId)) {
                setSelectedOrder(null);
                //setSelectedOrderDetail(null);
                navigate("/orderdetailspage?view=" + currentView); // Clear URL too
                window.dispatchEvent(new CustomEvent("order-deleted", {
                    detail: { orderId: deletedOrderId }
                }));
            }
        });

        connection.on("newordercreated", (newOrderId) => {
            // Handle new order event
            //console.log("New order created:", newOrderId);
            //console.log("New order created:", newOrderId);
            //fetchOrders(0); // Refresh orders without refreshing page
            (async () => {
                try {
                    
                    const response = await axiosExt.get(`${API_BASE_URL}/orders/${newOrderId}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });

                    const newOrder = response.data;

                    setOrders(prev => {
                        const exists = prev.some(o => o.id === newOrder.id);
                        if (exists) return prev;

                        const updated = [newOrder, ...prev];
                        //localStorage.setItem("ordersList", JSON.stringify(updated)); // optional
                        saveCache("ordersList", updated);
                        return updated;
                    });
                } catch (error) {
                    console.error("Error fetching new order:", error);
                }
            })();
        });

        connection.on("orderhasnewemail", ({ updatedOrderId, unreadEmailsNumber }) => {
            // Handle email update event
            //console.log("Order has new email:", orderId);
            //setOrders((prevOrders) =>
            //    prevOrders.map(o =>
            //        o.id === updatedOrderId ? {
            //            ...o,
            //            hasUnreadEmails: true,
            //            unreadEmailsNumber: (o.unreadEmailsNumber ?? 0) + 1,
            //        } : o
            //    )
            //);
            setOrders(prev =>
                prev.map(o =>
                    o.id === updatedOrderId
                        ? { ...o, hasUnreadEmails: true, unreadEmailsNumber }
                        : o
                )
            );


            const selected = selectedOrderRef.current;

            if (selected && selected.id === updatedOrderId) {
                window.dispatchEvent(new CustomEvent("order-email-updated", {
                    detail: { orderId: updatedOrderId }
                }));

                // Optional: trigger refresh
                // fetchOrder(updatedOrderId).then(setSelectedOrder);
            }

            //fetchOrders();
            // If currently selected order got the email, refresh it
            //if (selectedOrder && (selectedOrder?.id === updatedOrderId)) {
            //    selectedOrder.hasUnreadEmails = true;
            //    setOrders(prevOrders =>
            //        prevOrders.map(o =>
            //            o.id === selectedOrder.id ? { ...o, hasUnreadEmails: false } : o
            //        )
            //    );
            //    window.dispatchEvent(new CustomEvent("order-email-updated", {
            //        detail: { orderId: updatedOrderId }
            //    }));

            //}
        });

        connection.on("orderupdated", async (updatedOrderId) => {
            try {
                const currentOrderId = selectedOrderRef.current?.id;
                if (!updatedOrderId) return;

                const updatedOrder = await fetchOrder(updatedOrderId);
                if (!updatedOrder) {
                    console.warn("No updated order found.");
                    return;
                }

                setOrders(prev =>
                    prev.map(o => o.id === updatedOrderId ? updatedOrder : o)
                );

                if (updatedOrderId == currentOrderId) {
                    setSelectedOrder({ ...updatedOrder });
                    setOrder({ ...updatedOrder });
                    window.dispatchEvent(new CustomEvent("order-email-updated", {
                        detail: { orderId: updatedOrderId }
                    }));
                }

            } catch (error) {
                console.error("Failed to process OrderUpdated:", error);
            }
        });




        return () => {
            connection.stop();
        };

    }, []); // 🔁 Triggers only when selectedOrder is defined

    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (isDirty) {
                e.preventDefault();
                e.returnValue = ''; // Standard way to trigger a browser confirmation
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isDirty]);

    useEffect(() => {
        if (!selectedOrder) return;

        selectedOrderRef.current = selectedOrder;

        const hasNoDetails =
            !selectedOrder.orderDetails || selectedOrder.orderDetails.length === 0;

        const defaultState = detailStates.find(state => state.defaultForNew);

        if (hasNoDetails) {
            //const newDetail = createDefaultDetail(selectedOrder.id ?? "", defaultState?.id);
            if (!selectedOrder?.id) return;
            if (!defaultState?.id) return;
            const newDetail = createDefaultDetail(selectedOrder.id, defaultState?.id, 1);
            setOrderDetails([newDetail]);
        } else {
            // Update order details with the selected order's details
            if (!isDirty) {
                setOrderDetails(selectedOrder.orderDetails ?? []);
            }   
        }

    }, [selectedOrder, detailStates]);

    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            if (isDirty) {
                event.preventDefault();
                setNextPath(location.pathname); // store where they wanted to go
                setOpenDialog(true); // open custom dialog
                window.history.pushState(null, '', location.pathname); // prevent real navigation
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [isDirty, location]);

    usePrompt(t("You have unsaved changes"), isDirty);

    useEffect(() => {
        if (!orderId) return;

        fetchOrder(orderId); // always fetch full data from backend
        fetchSurveys(orderId);

        // CLEAR selected detail if no orderDetailId in URL
        //if (!orderDetailId) {
        //    setSelectedOrderDetail(null);
        //}
    }, [orderId, orderDetailId]);

    useEffect(() => {
        if (!orderDetailId || orderDetails.length === 0) return;

        const foundDetail = orderDetails.find(d => d.id === orderDetailId);
        if (foundDetail) {
            setVisibleDetailLine(foundDetail.lineNumber);
        } else {
            setVisibleDetailLine(null);
        }
    }, [orderDetails, orderDetailId]);

    useEffect(() => {
        const savedOrders = localStorage.getItem("ordersList");
        const savedPage = localStorage.getItem("orderPage");
        const savedHasMore = localStorage.getItem("hasMoreOrders");

        if (savedOrders && savedPage) {
            const parsed = JSON.parse(savedOrders);
            if (parsed.timestamp && parsed.data) {
                const ageMinutes = (Date.now() - parsed.timestamp) / 1000 / 60;
                if (ageMinutes <= 5) {
                    setOrders(parsed.data);
                    setOrderPage(parseInt(savedPage));
                    setHasMoreOrders(savedHasMore === "true");
                }
            }
        }

        // Always fetch fresh
        //fetchOrders(0, view === "grid");
        if (showStatistics) {
            fetchOrdersStatistics();
        }

        // On unmount, clear old cache
        return () => {
            localStorage.removeItem("ordersList");
            localStorage.removeItem("orderPage");
            localStorage.removeItem("hasMoreOrders");
        };
    }, []);

    useEffect(() => {
        if (!orderId && !selectedOrder && orders.length > 0) {
            //const firstOrder = orders[0];
            //if (firstOrder) {
            //    navigate(`/orderdetailspage/${firstOrder.id}?view=${currentView}`, { replace: true });
            //}
            navigate(`/orderdetailspage/?view=${currentView}`, { replace: true });
        }
    }, [orders, orderId, selectedOrder, navigate]);

    const fetchServices = async () => {
        //setLoading(true);

        try {
            
            const response = await axiosExt.get<Service[]>(`${API_BASE_URL}/services`, {
                headers: { "Authorization": `Bearer ${token}` },
            });
            setServices(response.data);
        } catch (error) {
            console.error("Error fetching services:", error);
        }
        finally {
            //setLoading(false);
        }
    };

    const fetchTaxTypeMappings = async () => {
        //setLoading(true);

        try {

            const response = await axiosExt.get<Service[]>(`${API_BASE_URL}/taxtypemappings`, {
                headers: { "Authorization": `Bearer ${token}` },
            });
            setTaxTypeMappings(response.data);
        } catch (error) {
            console.error("Error fetching services:", error);
        }
        finally {
            //setLoading(false);
        }
    };

    const addOrderDetail = () => {
        const newState = detailStates.find(state => state.defaultForNew === true)

        setOrderDetails(prev => {
            const nextLineNumber = prev.length + 1;
            const newDetail: OrderDetail = {
                id: crypto.randomUUID(),
                orderId: order?.id ?? "",
                declarantCustomerId: null,
                lineNumber: nextLineNumber,
                customerNumber: "",
                containerNumber: "",
                customsReferenceNumber: "",
                ata: "",
                atc: "",
                mrn: "",
                etaDate: null,
                etaIntervalStart: null,
                etaIntervalEnd: null,
                sentToCustoms: false,
                positionsNumber: 0,
                documentsAttached: false,
                stateId: newState?.id ?? null,
                notes: "",
                missingInfo: "",
                orderDetailsTaxAssessments: null,
                isValidated: false,
                invoiced:false,
                draftServiceInvoiceCreated: false,
                draftServiceInvoiceValidated: false,
                invoiceSent: false,
                invoiceSentAt: null,
                accountingServiceInvoiceId: null,
                accountingServiceInvoiceUrl: null,  
            };

            return [...prev, newDetail];
        });

        setVisibleDetailLine(_ => {
            // automatically switch to new line
            return (orderDetails.length ?? 0) + 1;
        });
    };

    //const removeOrderDetail = (index: number) => {
    //    const updatedDetails = orderDetails.filter((_, i) => i !== index);

    //    // Reorder line numbers after removing an item
    //    const reorderedDetails = updatedDetails.map((detail, i) => ({
    //        ...detail,
    //        lineNumber: i + 1, // Renumber after deletion
    //    }));

    //    setOrderDetails(reorderedDetails);
    //};

    const removeOrderDetail = (index: number) => {
        const detailToRemove = orderDetails[index];
        if (!detailToRemove) return;

        const detailToRemoveId = detailToRemove.id;

        const reorderedDetails = orderDetails
            .filter((_, i) => i !== index)
            .map((detail, i) => ({
                ...detail,
                lineNumber: i + 1,
            }));

        setOrderDetails(reorderedDetails);

        setSelectedOrder(prev =>
            prev
                ? {
                    ...prev,
                    orderDetails: reorderedDetails,
                    orderServices:
                        prev.orderServices?.filter(
                            service => service.orderDetailId !== detailToRemoveId
                        ) ?? [],
                    orderDetailsTaxAssessments:
                        prev.orderDetailsTaxAssessments?.filter(
                            assessment => assessment.orderDetailId !== detailToRemoveId
                        ) ?? [],
                }
                : prev
        );

        if (visibleDetailLine === detailToRemove.lineNumber) {
            setVisibleDetailLine(null);
        }

        setIsDirty(true);
    };


    const handleOrderDetailChange = (
        index: number,
        field: keyof OrderDetail,
        value: OrderDetail[keyof OrderDetail]
    ) => {
        const updatedDetails = [...orderDetails];
        const updatedDetail = { ...updatedDetails[index], [field]: value };

        if (field === "customerNumber") {
            updatedDetail.customsReferenceNumber = `${selectedOrder?.internalNumber ?? ""} ${value}`.toUpperCase();
        }

        updatedDetails[index] = updatedDetail;
        setOrderDetails(updatedDetails);
        setIsDirty(true);
    };


    const handleOrderClick = async (orderClickedId: string) => {
        if (!orderClickedId) return;

        if (isDirty) {
            // Store the intended destination and prompt user
            setNextPath(`/orderdetailspage/${orderClickedId}`);
            setOpenDialog(true);
            return;
        }

        //setOrderDetailsLoading(true);

        try {
            // 1. Optimistically update left sidebar immediately
            /*setOrders(prevOrders =>
                prevOrders.map(o =>
                    o.id === orderId ? { ...o, hasUnreadEmails: false } : o
                )
            );*/
            setVisibleDetailLine(null);
            navigate(`/orderdetailspage/${orderClickedId}?view=${currentView}`, { replace: true });
            //await fetchOrder(orderId);

            
        } catch (error) {
            console.error("Error loading order:", error);
        } finally {
            //setOrderDetailsLoading(false);
        }
    };

    const handleOrderDetailClick = (orderDetail: OrderDetail) => {
        //setSelectedOrderDetail(orderDetail);
        navigate(`/orderdetailspage/${orderDetail.orderId}/${orderDetail.id}?view=${currentView}`);

    };

    const recalculateCustomsRef = (orderNumber: string, detail: OrderDetail): string => {
        return `${orderNumber} ${detail.customerNumber}`.toUpperCase().substring(0, 22);
    };

    function convertToFieldType<K extends EditableOrderField>(
        field: K,
        rawValue: string
    ): OrderDetail[K] {
        if (field === "positionsNumber") {
            const parsed = parseInt(rawValue, 10);
            return (isNaN(parsed) ? 0 : parsed) as OrderDetail[K];
        }

        return rawValue as OrderDetail[K];
    }

    const handleEditorValueAssign = <K extends EditableOrderField>(
        field: K,
        rawValue: string
    ) => {
        const value: OrderDetail[K] = convertToFieldType(field, rawValue);

        setOrderDetails(prev => {
            const updated = [...prev];
            const index = updated.findIndex(d => !d[field]);

            if (index === -1) {
                const defaultNewStateId = detailStates.find(ds => ds.defaultForNew)?.id ?? detailStates[0]?.id ?? "";
                const newDetail = createDefaultDetail(orderId ?? "", defaultNewStateId, updated.length + 1);
                newDetail[field] = value; 

                if (field === "customerNumber" && typeof value === "string") {
                    newDetail.customsReferenceNumber = recalculateCustomsRef(selectedOrder?.internalNumber ?? "", newDetail);
                }

                return [...updated, newDetail];
            }

            updated[index] = {
                ...updated[index],
                [field]: value,
            };

            if (field === "customerNumber" && typeof value === "string") {
                updated[index].customsReferenceNumber = recalculateCustomsRef(selectedOrder?.internalNumber ?? "", updated[index]);
            }

            return updated;
        });

        setIsDirty(true);
    };




    const updateCustomerNumber = (index: number, value: string) => {
        setOrderDetails(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                customerNumber: value,
                customsReferenceNumber: recalculateCustomsRef(selectedOrder?.internalNumber ?? "", {
                    ...updated[index],
                    customerNumber: value
                }), 
            };
            return updated;
        });
        setIsDirty(true);
    };


    const fetchOrderStates = async () => {
        //setLoading(true);

        try {
            
            const response = await axiosExt.get<OrderState[]>(`${API_BASE_URL}/orderStates/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setOrderStates(response.data);
            setMergedStateId(orderStates.find(s => s.isMerged)?.id ?? undefined); // Get the ID
        } catch (error) {
            console.error("Error fetching order states:", error);
        } finally {
            //setLoading(false);
        }
    }

    const fetchDetailStates = async () => {
        //setLoading(true);

        try {
            
            const response = await axiosExt.get<DetailState[]>(`${API_BASE_URL}/detailStates/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setDetailStates(response.data);
        } catch (error) {
            console.error("Error fetching detail states:", error);
        } finally {
            //setLoading(false);
        }
    }

    const fetchUsers = async () => {
        //setLoading(true);

        try {
            
            const response = await axiosExt.get<User[]>(`${API_BASE_URL}/users/roles/admin-support`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }
            console.log("3 Setting users to:", response.data);
            setUsers(response.data);
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            //setLoading(false);
        }
    }

    const fetchCustomers = async () => {
        //setLoading(true);
        

        try {
            const response = await axiosExt.get<Customer[]>(`${API_BASE_URL}/customers`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }

            );

            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }
            const sortedCustomers = [...response.data].sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            setCustomers(sortedCustomers);
        } catch (error) {
            console.error("Error fetching customers:", error);
        }
        finally {
            //setLoading(false);
        }
    };

    const fetchUnassignedContacts = async () => {
        //setLoading(true); // Start loading

        

        try {
            const response = await axiosExt.get<Contact[]>(`${API_BASE_URL}/contacts?unassignedOnly=true`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }

            );

            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setUnassignedContacts(response.data);
        } catch (error) {
            console.error("Error fetching contacts:", error);
        } finally {
            //setLoading(false); // Mark loading as complete
        }
    };

    const fetchContacts = async (customerId: string) => {
        if (!customerId) return;

        //setLoading(true); // Start loading

        

        try {
            const searchParam = customerId ? `search=${customerId}` : "";
            const response = await axiosExt.get<Contact[]>(`${API_BASE_URL}/contacts?${searchParam}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }

            );

            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setContacts(response.data);
        } catch (error) {
            console.error("Error fetching contacts:", error);
        } finally {
            //setLoading(false); // Mark loading as complete
        }
    };


    const fetchUser = async () => {
        //setLoading(true);

        try {
            
            //const searchParam = customerId ? `search=${customerId}` : "";
            const response = await axiosExt.get<User>(`${API_BASE_URL}/users/${userId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {

                throw new Error("Unauthorized. Please log in again.");
            }
            setUser(response.data);

        } catch (error) {
            console.error("Error fetching user:", error);
        } finally {
            //setLoading(false);
            /*console.log(order);*/
        }


    };

    const fetchOrder = async (id: string): Promise<Order | null> => {

        //setOrderDetailsLoading(true);
        try {
            

            const response = await axiosExt.get<Order>(`${API_BASE_URL}/orders/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            const updatedOrder: Order = response.data;

            if (id !== orderId) {
                //console.warn(`Skipping update because id ${id} !== current orderId ${orderId}`);
                return updatedOrder;
            }
            
            // Check if order has unread emails
            if (updatedOrder.hasUnreadEmails) {
                // Send update request to backend
                //await axiosExt.put(`${API_BASE_URL}/orders/${id}/mark-as-read`, {}, {
                //    headers: {
                //        "Content-Type": "application/json",
                //        "Authorization": `Bearer ${token}`,
                //    },
                //});
                //// Mark order as read
                //updatedOrder.hasUnreadEmails = false;

                ////Update the orders list to remove "(New)" on the left-side panel
                //setOrders(prevOrders =>
                //    prevOrders.map(o =>
                //        o.id === updatedOrder.id ? { ...o, hasUnreadEmails: false } : o
                //    )
                //);
            }

            if (updatedOrder.mergedToOrderId) {
                const response = await axiosExt.get<Order>(`${API_BASE_URL}/orders/${updatedOrder.mergedToOrderId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
                );
                if (response.status === 401) {

                    throw new Error("Unauthorized. Please log in again.");
                }

                const mergedToOrder: Order = response.data;
                setMergedToOrderNumber(mergedToOrder?.internalNumber || "");
            }

            // Update state with modified order
            if (id === orderId) {
                setSelectedOrder(updatedOrder);
                setOrder(updatedOrder);
                if (!isDirty) {
                    setOrderDetails(updatedOrder.orderDetails || []);
                }
                setHoveredCustomer(customers.find(c => c.id === updatedOrder?.customerId) ?? null);
                //setHoveredDeclarant(customers.find(c => c.id === updatedOrder?.declarantCustomerId) ?? null);
                fetchReminders(orderId);
                // Fetch emails and attachments
                /*try {
                    const emailRes = await axiosExt.get<Email[]>(`${API_BASE_URL}/orders/${id}/emails-with-attachments`, {
                        headers: {
                            "Authorization": `Bearer ${token}`,
                        },
                    });
                    setEmails(emailRes.data);
                } catch (emailError) {
                    console.error("Failed to load emails for order:", emailError);
                }*/

                // to load orders and order details properly in case user moves from order details to order
                if (!updatedOrder.orderDetails || updatedOrder.orderDetails.length === 0) {
                    const defaultState = detailStates.find(state => state.defaultForNew);
                    const newDetail: OrderDetail = {
                        id: crypto.randomUUID(),
                        orderId: updatedOrder.id,
                        declarantCustomerId:null,
                        lineNumber: 1,
                        customerNumber: "",
                        containerNumber: "",
                        customsReferenceNumber: "",
                        ata: "",
                        atc: "",
                        mrn:"",
                        etaDate: null,
                        etaIntervalStart: null,
                        etaIntervalEnd: null,
                        sentToCustoms: false,
                        positionsNumber: 0,
                        documentsAttached: false,
                        stateId: defaultState?.id || "",
                        notes: "",
                        missingInfo: "",
                        orderDetailsTaxAssessments: null,
                        isValidated: false,
                        draftServiceInvoiceCreated: false,
                        draftServiceInvoiceValidated: false,
                        invoiced: false,
                        invoiceSent: false,
                        invoiceSentAt: null,
                        accountingServiceInvoiceId: null,
                        accountingServiceInvoiceUrl: null,  
                    };
                    setOrderDetails([newDetail]);
                    updatedOrder.orderDetails = [newDetail]; 
                    setSelectedOrder(updatedOrder);
                } else {
                    setOrderDetails(updatedOrder.orderDetails);
                }

                //if (orderDetailId != null) {
                //    setSelectedOrderDetail(updatedOrder.orderDetails?.find(orderDetail => orderDetail.id === orderDetailId) ?? null);
                //};

            } else {
                console.warn(`Ignored outdated fetchOrder for id=${id}, expected=${orderId}`);
            }

            setTempOrderInvoices(updatedOrder?.orderInvoices ?? []);

            if (updatedOrder.customerId) {
                if (contacts?.[0]?.customerId !== updatedOrder?.customerId) {

                    await fetchContacts(updatedOrder.customerId);
                }
            } else {
                setContacts([]); // Optional: clear stale contacts
                //setLoading(false); // ✅ Force it to false so EmailConversation renders
            }

            /*if (!updatedOrder.orderDetails || updatedOrder.orderDetails.length === 0) {
                const defaultState = detailStates.find(state => state.defaultForNew);
                const newDetail: OrderDetail = {
                    id: crypto.randomUUID(),
                    orderId: updatedOrder.id,
                    lineNumber: 1,
                    customerNumber: "",
                    containerNumber: "",
                    customsReferenceNumber: "",
                    ata: "",
                    etaDate: null,
                    etaIntervalStart: null,
                    etaIntervalEnd: null,
                    sentToCustoms: false,
                    positionsNumber: 0,
                    documentsAttached: false,
                    stateId: defaultState?.id || "",
                    notes: "",
                };
                setOrderDetails([newDetail]);
            } else {
                setOrderDetails(updatedOrder.orderDetails);
            }
            //fetchOrders(0, updatedOrder);
            //fetchOrders(0);
            //TODO mark the order and emails as read

            if (!selectedOrder) {
                setSelectedOrder(updatedOrder);
                setOrder(updatedOrder);
            }*/

            return updatedOrder;

        } catch (error) {
            console.error("Error fetching order:", error);
            return null;
        } finally {
            //setOrderDetailsLoading(false);
        }
    };

    const fetchCustomerOrders = async () => {
        //setLoading(true);
        if (!selectedOrder?.customerId) {
            try {
                
                const response = await axiosExt.get<Order[]>(`${API_BASE_URL}/orders/mergeable`, {
                    headers: { "Authorization": `Bearer ${token}` },
                    params: {
                        customerId: null, // optional, omit if not needed
                    }
                });

                // Exclude the current order from the list
                setCustomerOrders(response.data.filter(o => o.id !== selectedOrder?.id));
            } catch (error) {
                console.log("No orders to merge into:", error);
            }
            finally {
                //setLoading(true);
            }

        }

        else {
            try {
                
                const response = await axiosExt.get<Order[]>(`${API_BASE_URL}/orders/mergeable`, {
                    headers: { "Authorization": `Bearer ${token}` },
                    params: {
                        customerId: selectedOrder?.customerId, // optional, omit if not needed
                    }
                });

                // Exclude the current order from the list
                setCustomerOrders(response.data.filter(o => o.id !== selectedOrder?.id));
            } catch (error) {
                console.log("No orders to merge into:", error);
            }
            finally {
                //setLoading(false);
            }
        }
    };

    //const createServiceInvoice = async (orderId:string, detailId: string) => {
    //    setInvoiceBusy(true);

    //    try {
    //        const token = localStorage.getItem("token");

    //        //check customer has accounting id, if not show an error

    //        await axiosExt.post(
    //            `${API_BASE_URL}/orders/${orderId}/create-invoice-for-services/${detailId}`,
    //            {},
    //            {
    //                headers: {
    //                    Authorization: `Bearer ${token}`,
    //                },
    //            }
    //        );

    //        enqueueSnackbar("Service draft invoice created.", { variant: "success" });

    //        // optional but recommended
    //        // await refetchOrder();
    //        // await refetchInvoices();

    //    } catch (error: any) {
    //        console.error("Failed to create draft invoice", error);

    //        enqueueSnackbar(
    //            error?.response?.data ?? "Failed to create draft invoice.",
    //            { variant: "error" }
    //        );
    //    }
    //    finally {
    //        setInvoiceBusy(false);
    //    }
    //};

    const addService = (detailId: string) => {
        if (!services || services.length === 0) return;

        setSelectedOrder((prev): Order | null => {
            if (!prev) return prev;

            const existingServiceIds = new Set(
                (prev.orderServices ?? [])
                    .filter(s => s.orderDetailId === detailId)
                    .map(s => s.serviceId)
                    .filter((id): id is string => !!id)
            );

            const nextService = services.find(
                s => s.id && !existingServiceIds.has(s.id)
            );

            if (!nextService) {
                console.warn("All services already added for this detail");
                return prev;
            }

            const newOrderService: OrderService = {
                serviceId: nextService.id!,   // non-null asserted
                orderDetailId: detailId,
                orderId: prev.id!,
                quantity: 1,
                additionalUnits:0,
                customPrice: 0,
                assignedUserId: null,
                isCompleted: false,
            };

            return {
                ...prev,
                orderServices: [
                    ...(prev.orderServices ?? []),
                    newOrderService,
                ],
            };
        });

        setIsDirty(true);
    };


    const updateService = (
        detailId: string,
        serviceId: string,
        patch: Partial<OrderService>
    ) => {
        setSelectedOrder(prev => {
            if (!prev) return prev;

            return {
                ...prev,
                orderServices: prev.orderServices?.map(s =>
                    s.serviceId === serviceId &&
                        s.orderDetailId === detailId
                        ? { ...s, ...patch }
                        : s
                ) ?? [],
            };
        });

        setIsDirty(true);
    };

    const deleteService = (detailId: string,serviceId: string) => {
        setSelectedOrder(prev => {
            if (!prev) return prev;

            return {
                ...prev,
                orderServices:
                    prev.orderServices?.filter(
                        s =>
                            !(
                                s.serviceId === serviceId &&
                                s.orderDetailId === detailId
                            )
                    ) ?? [],
            };
        });

        setIsDirty(true);
    };



    const fetchFilteredOrders = async () => {
        // Clear cache
        localStorage.removeItem("ordersList");
        localStorage.removeItem("orderPage");
        localStorage.removeItem("hasMoreOrders");

        // Reset state
        setOrders([]);
        setOrderPage(0);
        setHasMoreOrders(true);

        // Save latest values immediately
        const filters = {
            filterCustomer,
            filterAssignedTo,
            filterState,
            filterCreatedOn,
            filterLastEmailReceivedAt,
            filterInvoiceStatus,
            sortField,
            sortOrder,
            customFilterField,
            customFilterValue, // ✅ This is now up to date because it's invoked after the latest input
        };
        localStorage.setItem("orderFilters", JSON.stringify(filters));

        try {
            setOrders([]);
            await fetchOrders(0, currentView === "grid");
            if (showStatistics) {
                await fetchOrdersStatistics();
            }

            // Automatically select first order after filtering
            const cached = loadCache<Order[]>("ordersList", 5);  // you already use this helper
            if (cached && cached.length > 0) {
                const first = cached[0];
                navigate(`/orderdetailspage/${first.id}?view=${currentView}`, { replace: true });
            }
        } catch (error) {
            console.error("Error fetching filtered orders:", error);
        }
    };

    const handleMergeOrder = async () => {
        if (!selectedMergeOrder || !selectedOrder) return;

        try {
            
            const response = await axiosExt.put(
                `${API_BASE_URL}/orders/${selectedOrder.id}/merge`,
                {
                    mergedToOrderId: selectedMergeOrder.id,
                },
                { headers: { "Authorization": `Bearer ${token}` } }
            );

            if (response.status == 401) {
                throw new Error("Unauthorized. Please log in again.");

            }
            setMergedToOrderNumber(selectedMergeOrder.internalNumber ?? undefined);

            setMergeDialogOpen(false);
            await fetchOrder(selectedMergeOrder.id);
            alert("Order merged successfully!");

            // Refresh orders
            // Get full order info from backend
            const fullOrderResponse = await axiosExt.get(`${API_BASE_URL}/orders/${selectedOrder.id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const fullOrder = fullOrderResponse.data;

            setMergedToOrderNumber(selectedMergeOrder.internalNumber ?? "");
            setSelectedOrder(fullOrder);

            // Update sidebar
            setOrders(prev =>
                prev.map(o => (o.id === fullOrder.id ? fullOrder : o))
            );

            // Refresh filtered sidebar (optional)
            fetchFilteredOrders();

        } catch (error) {
            console.error("Error merging order:", error);
            alert("Failed to merge order.");
        }
    };

    const copyToClipboard = (value: string) => {
        navigator.clipboard.writeText(value);
        //alert("Copied to clipboard!");
    };

    const fallbackStateId =
        detailStates.find(s => s.defaultForNew)?.id ?? detailStates[0]?.id ?? "";

    const getDetailsForSave = (order: Order) => {
        const baseDetails = order.id === selectedOrder?.id
            ? orderDetails
            : (order.orderDetails ?? []);

        return [...baseDetails]
            .sort((a, b) => (a.lineNumber ?? 0) - (b.lineNumber ?? 0))
            .map((detail, index) => {
                const stateId = detail.stateId ?? detail.stateId ?? null;

                return {
                    ...detail,
                    lineNumber: index + 1,
                    orderId: order.id || "",
                    id: detail.id,
                    stateId: stateId, // ✅ this guarantees it exists
                };
            });
    };

    const saveInvoiceChanges = async () => {
        if (!selectedOrder) return;

        
        if (!token) return;

        const existingInvoiceIds = new Set((selectedOrder.orderInvoices ?? []).map(oi => oi.invoiceId));
        const newInvoiceIds = new Set(tempOrderInvoices.map(oi => oi.invoiceId));

        const toLink = [...newInvoiceIds].filter(id => !existingInvoiceIds.has(id));
        const toUnlink = [...existingInvoiceIds].filter(id => !newInvoiceIds.has(id));

        try {
            for (const id of toLink) {
                //await axiosExt.post(`${API_BASE_URL}/orders/${selectedOrder.id}/linkInvoice`, id, {
                //    headers: {
                //        "Authorization": `Bearer ${token}`,
                //        "Content-Type": "application/json",
                //    },
                //});
                const linkInfo = tempOrderInvoices.find(oi => oi.invoiceId === id);
                if (!linkInfo || !linkInfo.invoice) continue;

                const payload = {
                    invoiceId: id,
                    kind: linkInfo.invoice.kind,
                    taxAssessmentId: linkInfo.invoice.kind === "Tax" ? linkInfo.invoice.orderDetailsTaxAssessmentId ?? null : null,
                    orderDetailId: linkInfo.orderDetailId
                };

                await axiosExt.post(`${API_BASE_URL}/orders/${selectedOrder.id}/linkInvoiceWithMetadata`, payload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                });
            }

            for (const id of toUnlink) {
                    await axiosExt.delete(`${API_BASE_URL}/orders/${selectedOrder.id}/unlinkInvoice/${id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
        } catch (err) {
            console.error("Failed to sync invoice links", err);
            throw err;
        }
    };

    useEffect(() => {
        if (selectedOrder) {
            selectedOrderRef.current = selectedOrder;
        }
    }, [selectedOrder]);

    const handleSave = async (
        overrideOrder?: Order,
        options?: { close?: boolean }
    ): Promise<Order | void> => {
        
        let orderToSave = overrideOrder ?? selectedOrderRef.current;
        if (!orderToSave) return;

        if (orderToSave.orderServices?.some(r =>
            !r.serviceId || r.serviceId.trim() === "" ||
            (!r.quantity || r.quantity <= 0)
        )) {
            // UI feedback
            alert("A service row was added but not filled (missing service or quantity). Please remove it or complete it.");
            return;
        }

        try {
            // Build details from order
            let sortedDetails = getDetailsForSave(orderToSave);

            // Just before building payload inside handleSave

            // Trim spaces for all string fields in order details
            sortedDetails = sortedDetails.map(d => ({
                ...d,
                customerNumber: d.customerNumber?.trim() || "",
                containerNumber: d.containerNumber?.trim() || "",
                customsReferenceNumber: d.customsReferenceNumber?.trim() || "",
                ata: d.ata?.trim() || "",
                atc: d.atc?.trim() || "",
                mrn: d.mrn?.trim() || "",
                notes: d.notes?.trim() || "",
            }));

            for (const assessment of selectedOrder?.orderDetailsTaxAssessments ?? []) {
                const rowsTotal = (assessment.taxRows ?? []).reduce(
                    (sum, r) => sum + parseFloat(String(r.amount || 0)),
                    0
                );

                if (assessment.taxRows?.some(r =>
                    (!r.taxTypeMappingId || r.taxTypeMappingId.trim() === "")
                )) {
                    alert("A tax row has no tax type.");
                    return;
                }

                if (assessment.taxRows?.some(r =>
                    (!r.amount || Number(r.amount) <= 0)
                )) {
                    alert("A tax row has no tax amount.");
                    return;
                }

                if (Math.abs(rowsTotal - (assessment.taxAmount ?? 0)) > 0.01) {
                    enqueueSnackbar(
                        `Tax amount (${assessment.taxAmount.toFixed(
                            2
                        )}) differs from total of tax rows (${rowsTotal.toFixed(2)}).`,
                        { variant: "error" }
                    );
                }
            }


            // Closing logic
            if (options?.close) {
                const closedDetailState = detailStates.find(s => s.isClosed);
                const closedOrderState = orderStates.find(s => s.isClosed);

                if (!closedDetailState || !closedOrderState) {
                    enqueueSnackbar(t("No closed state is defined."), { variant: "error" });
                    return;
                }

                // Set all details to closed
                sortedDetails = sortedDetails.map(d => ({
                    ...d,
                    stateId: closedDetailState.id,
                }));

                // Set order to closed
                orderToSave = {
                    ...orderToSave,
                    stateId: closedOrderState.id,
                };
            }

            // Build services
            //const orderServices = (orderToSave.orderServices ?? []).map(os => ({
            //    serviceId: os.serviceId,
            //    ...(orderToSave!.id ? { orderId: orderToSave!.id } : {}),
            //    assignedUserId: os.assignedUserId || null,
            //    isCompleted: os.isCompleted ?? false,
            //    quantity: os.quantity ?? 0,
            //    orderDetailId: os.orderDetailId || null,
            //}));

            // Exclude server-generated timestamps
            const { createdDateTime, lastEmailReceivedAt, ...orderWithoutTimestamps } = orderToSave;

            // Build payload
            const payload = {
                ...orderWithoutTimestamps,
                orderDetails: sortedDetails,
                orderServices: orderToSave?.orderServices,
                orderDetailsTaxAssessments: orderToSave.orderDetailsTaxAssessments ?? [],
                serviceIds: undefined,
                orderInvoices: [],
            };

            // Normalize nullable fields
            if (!payload?.stateId || payload.stateId === "") payload.stateId = null;
            if (!payload?.orderTypeId || payload.orderTypeId === "") payload.orderTypeId = null;

            if (!orderToSave.id) {
                // Create new order
                const { id, ...createPayload } = payload;
                const response = await axiosExt.post(`${API_BASE_URL}/orders`, createPayload, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                setOrders(prev => [...prev, response.data]);
                setOrderDetails(sortedDetails);
                await saveInvoiceChanges();
                setInvoiceBusy(false);
                enqueueSnackbar(t("Order created."), { variant: "success" });
                return response.data;
            } else {
                // Update existing order
                await axiosExt.put(`${API_BASE_URL}/orders/${orderToSave.id}`, payload, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                const updated = { ...orderToSave, orderDetails: sortedDetails };

                setOrders(prev => prev.map(o => (o.id === updated.id ? updated : o)));
                setOrderDetails(sortedDetails);
                await saveInvoiceChanges();
                setIsDirty(false);
                setInvoiceBusy(false);
                window.removeEventListener("beforeunload", handleBeforeUnload);

                // Refresh from API
                await fetchOrder(updated.id);

                const message = options?.close
                    ? t("Order closed and saved.")
                    : t("Data has been saved properly.");

                enqueueSnackbar(message, { variant: "success" });
                return updated;
            }
        } catch (error: any) {
            console.error("Error saving order:", error);

            const message = extractErrorMessage(error);
            alert (message);  // if using UI error banner
        }
    };



    //const handleSave = async (overrideOrder?: Order, skipRefetch = false): Promise<Order | void> => {
    //    
    //    const orderToSave = overrideOrder ?? selectedOrderRef.current;

    //    if (!orderToSave) return;

    //    try {
    //        // ✅ Compute details once
    //        const sortedDetails = getDetailsForSave(orderToSave);

    //        // Prepare orderServices
    //        const orderServices = (orderToSave.orderServices ?? []).map(os => ({
    //            serviceId: os.serviceId,
    //            ...(orderToSave.id ? { orderId: orderToSave.id } : {}),
    //            assignedUserId: os.assignedUserId || null,
    //            isCompleted: os.isCompleted ?? false,
    //            quantity: os.quantity ?? 0,
    //        }));

    //        const {
    //            createdDateTime,
    //            lastEmailReceivedAt,
    //            ...orderWithoutTimestamps
    //        } = orderToSave;
    //        void createdDateTime;
    //        void lastEmailReceivedAt;
            

    //        // Build payload
    //        const payload = {
    //            ...orderWithoutTimestamps,
    //            orderDetails: sortedDetails,
    //            orderServices,
    //            orderDetailsTaxAssessments: orderToSave.orderDetailsTaxAssessments ?? [],
    //            serviceIds: undefined,
    //            orderInvoices: [],
    //        };

    //        if (!payload?.stateId || payload.stateId === "") payload.stateId = null;
    //        if (!payload?.orderTypeId || payload.orderTypeId === "") payload.orderTypeId = null;



    //        // Save
    //        if (!orderToSave.id) {
    //            const { id, ...createPayload } = payload;
    //            console.log(id);
    //            const response = await axiosExt.post(`${API_BASE_URL}/orders`, createPayload, {
    //                headers: { Authorization: `Bearer ${token}` },
    //            });
    //            setOrders(prev => [...prev, response.data]);
    //            setOrderDetails(sortedDetails); // 
    //            await saveInvoiceChanges();
    //            enqueueSnackbar(t("Order created."), { variant: "success" });
    //            return response.data;
    //        } else {
    //            await axiosExt.put(`${API_BASE_URL}/orders/${orderToSave.id}`, payload, {
    //                headers: { Authorization: `Bearer ${token}` },
    //            });

    //            const updated = {
    //                ...orderToSave,
    //                orderDetails: sortedDetails
    //            };

    //            setOrders(prev => prev.map(o => (o.id === updated.id ? updated : o)));
    //            setOrderDetails(sortedDetails);
    //            await saveInvoiceChanges();
    //            setIsDirty(false);
    //            window.removeEventListener('beforeunload', handleBeforeUnload);

    //            if (!skipRefetch) {
    //                await fetchOrder(updated.id);
    //            }

    //            enqueueSnackbar(t("Data has been saved properly."), { variant: "success" });
    //            return updated;
    //        }
    //    } catch (error) {
    //        console.error("Error saving order:", error);
    //        alert("Error saving order.");
    //    }
    //};

    //const handleClose = async () => {
    //    if (!selectedOrder) return;

    //    // Find closed state for orders
    //    const closedOrderState = orderStates.find(s => s.isClosed);
    //    // Find closed state for details
    //    const closedDetailState = detailStates.find(s => s.isClosed);

    //    if (!closedOrderState || !closedDetailState) {
    //        enqueueSnackbar(t("No closed state is defined."), { variant: "error" });
    //        return;
    //    }

    //    // Build updated details
    //    const closedDetails = orderDetails.map(d => ({
    //        ...d,
    //        stateId: closedDetailState.id
    //    }));

    //    // Update state so handleSave sees the closed details
    //    setOrderDetails(closedDetails);

    //    const updatedOrder = {
    //        ...selectedOrder,
    //        stateId: closedOrderState.id,
    //        orderDetails: closedDetails
    //    };

    //    await handleSave(updatedOrder);
    //    enqueueSnackbar(t("Order closed and saved."), { variant: "success" });
    //};


    //const handleSave = async () => {
 
    //    

    //    const orderServices = (selectedOrder?.orderServices ?? []).map(os => ({
    //        serviceId: os.serviceId,
    //        ...(selectedOrder?.id ? { orderId: selectedOrder.id } : {}) // ✅ Only include orderId if updating
    //    }));


    //    if (selectedOrder) {
    //        try {
    //            // Step 1: Sort orderDetails by lineNumber first
    //            const sortedDetails = [...orderDetails].sort((a, b) => (a.lineNumber ?? 0) - (b.lineNumber ?? 0));

    //            // Step 2: Reassign line numbers sequentially after sorting
    //            const reorderedDetails = sortedDetails.map((detail, index) => ({
    //                ...detail,
    //                lineNumber: index + 1, // Ensure line numbers are in order
    //                id: detail.id,
    //                orderId: selectedOrder?.id || null
    //            }));

    //            const payload = {
    //                ...selectedOrder,
    //                orderServices: orderServices,  // OrderServices without empty orderId
    //                serviceIds: undefined,  //Remove unnecessary serviceIds field
    //                orderDetails: reorderedDetails
    //            };

    //            if (!payload?.stateId || payload.stateId === "") {
    //                payload.stateId = null;
    //            }
    //            if (!payload?.orderTypeId || payload.orderTypeId === "") {
    //                payload.orderTypeId = null;
    //            }
    //            if (selectedOrder.id == null || selectedOrder.id === '') {
    //                if (!selectedOrder.id) {
    //                    payload.id = crypto.randomUUID();
    //                }
    //                // Add new order
    //                const response = await axiosExt.post(`${API_BASE_URL}/orders`, payload, {
    //                    headers: {
    //                        Authorization: `Bearer ${token}`,
    //                    },
    //                });
    //                setOrders([...orders, response.data]);
    //            } else {
    //                // Update existing order
    //                await axiosExt.put(`${API_BASE_URL}/orders/${selectedOrder.id}`, payload, {
    //                    headers: {
    //                        Authorization: `Bearer ${token}`,
    //                    },
    //                });
    //                setOrders(
    //                    orders.map((c) =>
    //                        c.id === selectedOrder.id ? selectedOrder : c
    //                    )
    //                );
    //            }

    //            const fixedDetails = reorderedDetails.map(detail => ({
    //                ...detail,
    //                orderId: detail.orderId ?? ""  // Convert null to empty string
    //            }));

    //            setOrderDetails(fixedDetails);// Update state to reflect corrected line numbers

    //            //fetchOrders(0);  // Update order list

    //            const updatedOrders = orders.map((o) =>
    //                o.id === selectedOrder.id
    //                    ? {
    //                        ...(selectedOrder as Order),
    //                        orderDetails: reorderedDetails.map(detail => ({
    //                            ...detail,
    //                            orderId: detail.orderId ?? "", // ensure no nulls
    //                        })),
    //                    }
    //                    : o
    //            );
    //            setOrders(updatedOrders);

    //            fetchOrder();

    //            setIsDirty(false);
    //            //alert("Data has been saved properly.")
    //            enqueueSnackbar(t("Data has been saved properly."), { variant: "success" });
    //        } catch (error) {
    //            console.error("Error saving order:", error);
    //            alert("Error saving order.")
    //        }
    //    }
    //};

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleChange = (_: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> | SelectChangeEvent<number> | SelectChangeEvent<number> | SelectChangeEvent<string[]> | Event) => {
        //setFormData({ ...formData, [e.target.name]: e.target.value });
        setIsDirty(true);
        
    };

    const confirmNavigation = () => {
        setOpenDialog(false);
        setIsDirty(false);
        window.removeEventListener('beforeunload', handleBeforeUnload);
        if (nextPath) {
            navigate(nextPath);
        }
    };

    useEffect(() => {
        setInvoiceBusy(isDirty);
    }, [isDirty]);


if (ordersLoading)
        return <Typography>{t("Loading orders...")}</Typography>;

    return (
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
                <Menu
                    anchorEl={sortMenuAnchor}
                    open={openSortMenu}
                    onClose={handleCloseSortMenu}
                    container={document.body}    // force outside sidebar
                    disablePortal={false}        // allow portal
                    slotProps={{
                        paper: {
                            sx: { zIndex: 4000 }     // higher than sidebar
                        },
                        root: {
                            sx: { zIndex: 4000 }     // Popover container itself
                        }
                    }}
                    PaperProps={{
                        sx: {
                            zIndex: 4000,
                            position: "relative"
                        }
                    }}
                >
                    {sortOptions.map(opt =>
                        sortOrders.map(order => (
                            <MenuItem
                                key={`${opt.field}-${order.value}`}
                                onClick={() => handleSortChange(opt.field, order.value)}
                            >
                                <ListItemIcon>
                                    {(sortField === opt.field && sortOrder === order.value) && <CheckIcon fontSize="small" />}
                                </ListItemIcon>
                                <ListItemText>
                                    {`${opt.label} – ${order.label}`}
                                </ListItemText>
                            </MenuItem>
                        ))
                    )}
                </Menu>
            
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>{t("You have unsaved changes")}</DialogTitle>
                <DialogContent>{t("Unsaved changes warning")}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>{t("no")}</Button>
                    <Button onClick={confirmNavigation}>{t("yes")}</Button>
                </DialogActions>
            </Dialog>

            {/*Show a banner if other users are inside*/}
            {/*{viewers.length > 0 && (*/}

            {/*    <Box sx={{ p: 1, bgcolor: "orange", color: "white", borderRadius: 1, mb: 1 }}>*/}
            {/*        {t("Warning")}: {viewers.filter(v => v !== user?.userName).join(", ") || "someone else"} {t("is viewing this order. Your changes will overwrite theirs.")}*/}
            {/*    </Box>*/}
            {/*)}*/}

            {mergeDialogOpen && (
                <Box
                    sx={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "50vw",
                        height: "50vh",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        borderRadius: 2,
                        p: 3,
                        zIndex: 1300,
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    {/* Header with current order number */}
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {t("Merge order")} {selectedOrder?.internalNumber} {t(" into order")}
                        </Typography>
                    </Box>

                    {/* Search input */}
                    <TextField
                        placeholder={t("Search by order number")}
                        value={mergeSearchText}
                        onChange={(e) => setMergeSearchText(e.target.value)}
                        size="small"
                        fullWidth
                        sx={{ mb: 2 }}
                    />

                    {/* Scrollable list of merge targets */}
                    <Box sx={{ flexGrow: 1, overflowY: "auto", border: "1px solid #ccc", borderRadius: 1 }}>
                        {filteredMergeOptions.map((o) => (
                            <Box
                                key={o.id}
                                onClick={() => setSelectedMergeOrder(o)}
                                sx={{
                                    px: 2,
                                    py: 1,
                                    cursor: "pointer",
                                    backgroundColor: selectedMergeOrder?.id === o.id ? "#d0f0ff" : "transparent",
                                    borderBottom: "1px solid #eee",
                                    '&:hover': { backgroundColor: "#f5f5f5" }
                                }}
                            >
                                <Typography variant="body2">
                                    {o.internalNumber} - {customers.find(c => c.id === o.customerId)?.name ?? "Unknown"} - {o.initialEmailSubject }
                                    {selectedMergeOrder?.id === o.id && (
                                        <span style={{ fontWeight: "bold", marginLeft: 8 }}>✓</span>
                                    )}
                                </Typography>
                            </Box>
                        ))}
                        {filteredMergeOptions.length === 0 && (
                            <Typography variant="body2" sx={{ px: 2, py: 1 }}>
                                {t("No matching orders found")}
                            </Typography>
                        )}
                    </Box>

                    {/* Action buttons */}
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 1 }}>
                        <Button onClick={() => setMergeDialogOpen(false)} color="error">{t("Cancel")}</Button>
                        <Button
                            onClick={handleMergeOrder}
                            variant="contained"
                            disabled={!selectedMergeOrder}
                        >
                            {t("Merge")}
                        </Button>
                    </Box>
                </Box>
            )}


            <Layout>
                <Box sx={{ display: "flex", height: "calc(100vh - 64px)", overflow: "hidden", width: "100%" }}>
                    {/* Column 1: Orders List */}
                    {!showSidebar && (
                        <IconButton
                            onClick={() => { setShowSidebar(true); setHoverSidebar(false); } }
                            onMouseEnter={() => setHoverSidebar(true)}
                            sx={{
                                position: "fixed",
                                top: 60,
                                left: 0,
                                zIndex: 2500,
                                bgcolor: "#fff",
                                borderColor: "divider",
                                boxShadow: 1,
                                border:1,
                                width: 24,   
                                height: 24,  
                                p: 0.25,     
                                "&:hover": {
                                    bgcolor: "#fff",
                                },
                            }}
                        >
                            <ChevronRightIcon />
                        </IconButton>
                    )}
                    {(showSidebar || hoverSidebar) && (
                        <Box width={showSidebar ? "20%" : "300px"} display="flex" flexDirection="column"
                            sx={{
                                borderRight: showSidebar ? "1px solid #ccc" : "none",
                                position: showSidebar ? "relative" : "absolute",
                                left: 0,
                                height: "calc(100vh - 64px)",
                                zIndex: 1500,
                                boxShadow: showSidebar ? "none" : 4, // shadow when overlaying
                                transition: "all 0.3s ease",
                                bgcolor: "white",
                            }}
                            onMouseLeave={() => setHoverSidebar(false)}
                            
                        >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}  >
                                <Box display="flex" alignItems="center" justifyContent="flex-start" mb={1} ml={1} gap={1} >

                                    <Typography variant="h5">{t("Orders")}</Typography>
                                    {view === "list" ? (
                                        <Tooltip title={t("Switch to Grid View")}>
                                            <IconButton
                                                onClick={() => handleViewToggle("grid")}
                                                size="small"
                                                sx={{ padding: "0px", marginLeft: "2px", color: "var(--color-blue)" }} // Blue
                                            >
                                                <ViewListIcon />
                                            </IconButton>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip title={t("Switch to List View")}>
                                            <IconButton
                                                onClick={() => handleViewToggle("list")}
                                                size="small"
                                                sx={{ padding: "0px", marginLeft: "2px", color: "var(--color-blue)" }} // Blue
                                            >
                                                <GridViewIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}

                                    <Tooltip title={t("Filters")}>
                                        <IconButton
                                            size="small"
                                            sx={{
                                                padding: "0px",
                                                marginLeft: "2px",
                                                color: showFilters ? "var(--color-green)" : "inherit" // Green when active
                                            }}
                                            onClick={() => toggleBoolean("showFilters")}
                                        >
                                            <FilterAltIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title={t("Save current filters as default")}>
                                        <IconButton
                                            onClick={handleSaveDefaultFilters}
                                            size="small"
                                            sx={{
                                                padding: "0px",
                                                marginLeft: "2px",
                                                color: showFilters ? "var(--color-teal)" : "inherit" // Cyan/Teal
                                            }}
                                        >
                                            <SaveIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Sort Options">
                                        <IconButton
                                            size="small"
                                            onClick={handleSortButtonClick}
                                            sx={{
                                                padding: "0px",
                                                marginLeft: "2px",
                                                color: "var(--color-amber)" // Amber
                                            }}
                                        >
                                            <SortIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title={t("Statistics")}>
                                        <IconButton
                                            size="small"
                                            sx={{
                                                padding: "0px",
                                                marginLeft: "2px",
                                                color: showStatistics ? "var(--color-purple)" : "inherit" // Purple when active
                                            }}
                                            onClick={() => toggleBoolean("showStatistics")}
                                        >
                                            <ChartIcon />
                                        </IconButton>
                                    </Tooltip>

                                    {/* X button in the corner */}
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            setShowSidebar(false);
                                            setHoverSidebar(false);
                                        }}
                                        sx={{
                                            padding: "0px",
                                            marginLeft: "2px",
                                            color: showStatistics ? "error" : "inherit" // Purple when active
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>


                                </Box>
                            </Box>


                            <Box sx={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto", overflowX: "clip", width: "100%", paddingTop: "0px" }}>
                                {(showStatistics || showFilters) && (
                                    <Box borderBottom={1} borderColor="gray" width="100%" sx={{ paddingTop: "0px", marginBottom: "0px" }} >
                                        {showStatistics && (
                                            <Box sx={{ paddingTop: "0px", paddingBottom: "10px" }}>
                                                <BarChart
                                                    margin={{ top: 10, bottom: 20, left: 30, right: 30 }}
                                                    height={200}
                                                    xAxis={[{
                                                        data: [...statisticData]
                                                            .sort((a, b) => a.sortOrder - b.sortOrder)   // sort by SortOrder
                                                            .map((d) => d.stateName),
                                                        scaleType: 'band',
                                                        colorMap: {
                                                            type: 'ordinal',
                                                            values: [...statisticData]
                                                                .sort((a, b) => a.sortOrder - b.sortOrder) //keep same order
                                                                .map((d) => d.stateName),
                                                            colors: [...statisticData]
                                                                .sort((a, b) => a.sortOrder - b.sortOrder)
                                                                .map((d) => d.stateColor),
                                                        },
                                                    }]}
                                                    series={[{ data: statisticData.map((d) => d.orderCount) }]}
                                                />
                                            </Box>
                                        )}
                                        {showFilters && (
                                            <Box sx={{ paddingTop: "0px", paddingBottom: "5px", zIndex: 2010, ml:1 }}>
                                                <Grid container spacing={1}>
                                                    {/* Left Column */}
                                                    <Grid item xs={12} sm={6} >
                                                        <FormControl fullWidth sx={{ mt: 1 }}>
                                                            <InputLabel id="custom_filter_field_label">{t("Custom Filter Field")}</InputLabel>
                                                            <Select
                                                                labelId="custom_filter_field_label"
                                                                label={t("Custom Filter Field")}
                                                                value={customFilterField}
                                                                onChange={(e) => setCustomFilterField(e.target.value)}
                                                                MenuProps={{
                                                                    sx: {
                                                                        zIndex: 2000, // higher than sidebar
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value="ataNumber">{t("ATA Number")}</MenuItem>
                                                                <MenuItem value="atc">{t("ATC")}</MenuItem>
                                                                <MenuItem value="containerNumber">{t("Container Number")}</MenuItem>
                                                                <MenuItem value="customerReference">{t("Customer Reference Number")}</MenuItem>
                                                                <MenuItem value="customsReferenceNumber">{t("Customs Reference Number")}</MenuItem>
                                                                <MenuItem value="InitialEmailSubject">{t("Email Subject Contains")}</MenuItem>
                                                                <MenuItem value="invoiceNumber">{t("Invoice Number")}</MenuItem>
                                                                <MenuItem value="mrn">{t("MRN")}</MenuItem>
                                                                <MenuItem value="orderNumber">{t("Order Number")}</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                            <Autocomplete sx={{ marginTop: 0, width:"100%"}}
                                                                options={[{ id: "all_customers", name: t("All Customers") }, ...customers]}
                                                                getOptionLabel={(c) => c.name || ""}
                                                                value={
                                                                    filterCustomer
                                                                        ? [...customers, { id: "all_customers", name: t("All Customers") }].find(
                                                                            (c) => c.id === filterCustomer
                                                                        ) || null
                                                                        : null
                                                                }
                                                                onChange={(_, newValue) => setFilterCustomer(newValue?.id || "")}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label={t("Customer")}
                                                                        fullWidth
                                                                    />
                                                                )}
                                                                filterOptions={(options, { inputValue }) =>
                                                                    options.filter((o) =>
                                                                        o.name?.toLowerCase().includes(inputValue.toLowerCase())
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                                slotProps={{
                                                                    popper: {
                                                                        sx: { zIndex: 3000 }, // 🔝 forces dropdown above sidebar
                                                                    },
                                                                }}
                                                            />

                                                        <FormControl fullWidth sx={{ mt: 1 }}>
                                                            <InputLabel id="assigned_to_filter_label">{t("Assigned To")}</InputLabel>
                                                            <Select
                                                                value={filterAssignedTo}
                                                                onChange={(e) => setFilterAssignedTo(e.target.value as string[])}
                                                                labelId="assigned_to_filter_label"
                                                                label={t("Assigned To")}
                                                                multiple
                                                                renderValue={(selected) =>
                                                                    Array.isArray(selected) && selected.length > 0 ? `${selected.length} selected` : ''
                                                                }
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        style: {
                                                                            maxHeight: 300,
                                                                        },
                                                                    },
                                                                    sx: {
                                                                        zIndex: 2020, // higher than sidebar
                                                                    }
                                                                }}
                                                            >
                                                                <Box sx={{ px: 2, py: 1, display: "flex", gap: 2 }}>
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{ cursor: "pointer", color: "primary.main", textDecoration: "underline" }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();

                                                                            const allIds = users
                                                                                .map(u => u.id)
                                                                                .filter((id): id is string => typeof id === "string" && id !== "");
                                                                            const newValue = [...allIds, "not_assigned"];
                                                                            setFilterAssignedTo(newValue);
                                                                        }}

                                                                    >
                                                                        Select All
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{ cursor: "pointer", color: "primary.main", textDecoration: "underline" }}
                                                                        onClick={() => setFilterAssignedTo([])}
                                                                    >
                                                                        Unselect All
                                                                    </Typography>
                                                                </Box>
                                                                <MenuItem value="not_assigned">
                                                                    <Checkbox checked={filterAssignedTo.includes("not_assigned")} />
                                                                    <ListItemText primary={t("Not assigned")} />
                                                                </MenuItem>
                                                                {[...users]
                                                                    .sort((a, b) => a.userName.localeCompare(b.userName))
                                                                    .map((user) => (
                                                                        <MenuItem key={user.id ?? "unknown"} value={user.id ?? ""}>
                                                                            <Checkbox checked={typeof user.id === "string" && filterAssignedTo.includes(user.id)} />
                                                                            <ListItemText
                                                                                primary={user.userName}
                                                                                primaryTypographyProps={{
                                                                                    noWrap: true,
                                                                                    sx: {
                                                                                        overflow: "hidden",
                                                                                        textOverflow: "ellipsis",
                                                                                        whiteSpace: "nowrap",
                                                                                    },
                                                                                }}
                                                                            />
                                                                        </MenuItem>
                                                                    ))}
                                                            </Select>
                                                        </FormControl>


                                                        <FormControl fullWidth sx={{ mt: 1 }}>
                                                            <InputLabel id="state_filter_label">{t("State")}</InputLabel>
                                                            <Select
                                                                labelId="state_filter_label"
                                                                label={t("State")}
                                                                multiple
                                                                value={filterState}
                                                                onChange={(e) => setFilterState(e.target.value as string[])}
                                                                renderValue={(selected) =>
                                                                    orderStates
                                                                        .filter((state) => state.id && selected.includes(state.id))
                                                                        .map((state) => state.name)
                                                                        .join(", ")
                                                                }
                                                                MenuProps={{
                                                                    sx: {
                                                                        zIndex: 2020, // higher than sidebar
                                                                    }
                                                                }}
                                                            >
                                                                {[...orderStates]
                                                                    .sort((a, b) => {
                                                                        if (a.sortOrder !== b.sortOrder) {
                                                                            return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
                                                                        }
                                                                        return a.name.localeCompare(b.name);
                                                                    })
                                                                    .map((state) => (
                                                                    <MenuItem key={state.id ?? "unknown"} value={state.id ?? ""}>
                                                                        <Checkbox checked={typeof state.id === "string" && filterState.includes(state.id)} />
                                                                        <ListItemText primary={state.name} />
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                        <Box sx={{ marginTop: 1, textAlign: "center"}}>
                                                            <Button
                                                                onClick={fetchFilteredOrders}
                                                                disabled={ordersLoading}
                                                                variant="contained"
                                                                color="primary"
                                                                sx={{ width: "100%" }}
                                                            >
                                                                {ordersLoading ? t("Loading...") : t("APPLY FILTERS")}
                                                            </Button>
                                                        </Box>

                                                    </Grid>

                                                    {/* Right Column */}
                                                    <Grid item xs={12} sm={6} paddingLeft="0px" paddingRight="5px">
                                                        {/*<FormControl fullWidth >*/}
                                                        {/*    <InputLabel id="sortorder-label">{t("Sort Order")}</InputLabel>*/}
                                                        {/*    <Select*/}
                                                        {/*        labelId="sortorder-label"*/}
                                                        {/*        label={t("Sort Order")}*/}
                                                        {/*        value={sortOrder}*/}
                                                        {/*        onChange={(e) => setSortOrder(e.target.value as "asc" | "desc")}*/}
                                                        {/*    >*/}
                                                        {/*        <MenuItem value="asc">{t("Ascending")}</MenuItem>*/}
                                                        {/*        <MenuItem value="desc">{t("Descending")}</MenuItem>*/}
                                                        {/*    </Select>*/}
                                                        {/*</FormControl>*/}
                                                        <TextField
                                                            fullWidth
                                                            label={t("Custom Filter Value")}
                                                            value={customFilterValue}
                                                            onChange={(e) => setCustomFilterValue(e.target.value)}
                                                            sx={{ mt: 1 }}
                                                        />
                                                        <FormControl fullWidth sx={{ mt: 1 }}>
                                                            <InputLabel id="created_on_filter_label">{t("Created On")}</InputLabel>
                                                            <Select value={filterCreatedOn} onChange={(e) => setFilterCreatedOn(e.target.value)}
                                                                labelId="created_on_filter_label"
                                                                label={t("Created On")}
                                                                MenuProps={{
                                                                    sx: {
                                                                        zIndex: 2020, // higher than sidebar
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value="all">{t("All")}</MenuItem>
                                                                <MenuItem value="today">{t("Today")}</MenuItem>
                                                                <MenuItem value="yesterday">{t("Yesterday")}</MenuItem>
                                                                <MenuItem value="this_week" >{t("This Week")}</MenuItem>
                                                                <MenuItem value="last_week" >{t("Last Week")}</MenuItem>
                                                                <MenuItem value="this_month" >{t("This Month")}</MenuItem>
                                                                <MenuItem value="last_month" >{t("Last Month")}</MenuItem>
                                                                <MenuItem value="last_30_days" >{t("Last 30 Days")}</MenuItem>
                                                                <MenuItem value="last_60_days" >{t("Last 60 Days")}</MenuItem>
                                                                <MenuItem value="last_90_days" >{t("Last 90 Days")}</MenuItem>
                                                            </Select>
                                                        </FormControl>

                                                        <FormControl fullWidth sx={{ mt: 1 }}>
                                                            <InputLabel id="last_email_received_at_filter_label">{t("Last Email Received At")}</InputLabel>
                                                            <Select value={filterLastEmailReceivedAt} onChange={(e) => setFilterLastEmailReceivedAt(e.target.value)}
                                                                labelId="last_email_received_at_filter_label"
                                                                label={t("Last Email Received At")}
                                                                MenuProps={{
                                                                    sx: {
                                                                        zIndex: 2020, // higher than sidebar
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value="all">{t("All")}</MenuItem>
                                                                <MenuItem value="today">{t("Today")}</MenuItem>
                                                                <MenuItem value="yesterday">{t("Yesterday")}</MenuItem>
                                                                {/*<MenuItem value="tomorrow">{t("Tomorrow")}</MenuItem>*/}
                                                                <MenuItem value="this_week">{t("This Week")}</MenuItem>
                                                                <MenuItem value="last_week">{t("Last Week")}</MenuItem>
                                                                {/*<MenuItem value="next_week">{t("Next Week")}</MenuItem>*/}
                                                                <MenuItem value="this_month">{t("This Month")}</MenuItem>
                                                                <MenuItem value="last_month">{t("Last Month")}</MenuItem>
                                                                <MenuItem value="last_30_days" >{t("Last 30 Days")}</MenuItem>
                                                                <MenuItem value="last_60_days" >{t("Last 60 Days")}</MenuItem>
                                                                <MenuItem value="last_90_days" >{t("Last 90 Days")}</MenuItem>
                                                                {/*<MenuItem value="next_30_days" >{t("Next 30 Days")}</MenuItem>*/}
                                                                {/*<MenuItem value="next_60_days" >{t("Next 60 Days")}</MenuItem>*/}
                                                            </Select>
                                                        </FormControl>

                                                        <FormControl fullWidth sx={{ mt: 1 }}>
                                                            <InputLabel id="invoice_status">{t("Invoice Status")}</InputLabel>
                                                            <Select value={filterInvoiceStatus} onChange={(e) => setFilterInvoiceStatus(e.target.value)}
                                                                labelId="invoice_status"
                                                                label={t("Invoice Status")}
                                                                MenuProps={{
                                                                    sx: {
                                                                        zIndex: 2020, // higher than sidebar
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value="all">{t("All")}</MenuItem>
                                                                <MenuItem value="toinvoice">{t("To invoice")}</MenuItem>
                                                                <MenuItem value="invoiced">{t("Invoiced")}</MenuItem>
                                                                <MenuItem value="invoicednotpaid">{t("Invoiced & not paid")}</MenuItem>
                                                                <MenuItem value="invoicedpaid">{t("Invoiced & paid")}</MenuItem>
                                                            </Select>
                                                        </FormControl>

                                                        {/* Apply Filters Button */}
                                                        <Box sx={{ marginTop: 1, textAlign: "center"}}>
                                                            <Button
                                                                variant="outlined"
                                                                onClick={handleRestoreDefaultFilters}
                                                                sx={{ width: "100%" }}
                                                            >
                                                                {t("Default")}
                                                            </Button>
                                                        </Box>

                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        )}
                                    </Box>
                                )}


                                {view !== "grid" && [...orders]
                                    .map((o, index) => {
                                        const orderState = orderStates.find((state) => state.id === o.stateId);
                                        const customer = customers.find((c) => c.id === o.customerId);
                                        return (
                                            <Box key={o.id}
                                                sx={{
                                                    backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5', borderTop: "1px solid #e0e0e0",
                                                    mt: "0px", mb: "0px", ml: "0px", pl: "0px", pr: "0px", pt: "2px", pb: "2px",

                                                }}
                                            >
                                                <Button
                                                    fullWidth
                                                    variant="text"
                                                    onClick={() => handleOrderClick(o.id ?? "")}
                                                    sx={{
                                                        bgcolor: index % 2 === 0 ? 'white' : '#f5f5f5', // alternating background
                                                        fontWeight: selectedOrder?.id === o.id ? "bold" : "normal", // Make selected bold
                                                        border: selectedOrder?.id === o.id ? "2px solid #007FFF" : "1px solid transparent", // subtle border
                                                        color: "black",
                                                        padding: "4px",
                                                        borderRadius: "4px",
                                                        textAlign: "left",
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                        alignItems: "center",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        "&:hover": {
                                                            bgcolor: index % 2 === 0 ? 'white' : '#f5f5f5',
                                                        },
                                                    }}
                                                >


                                                    <Box
                                                        sx={{
                                                            width: "85px",  // fixed width to ensure consistency
                                                            minWidth: "85px",
                                                            maxWidth: "85px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "flex-start",
                                                            gap: "4px",
                                                            backgroundColor: orderState?.bgColorRGB || "transparent",
                                                            color: orderState?.colorRGB || "inherit",
                                                            padding: "2px 4px",
                                                            borderRadius: "2px",
                                                            marginRight: "5px",
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            fontWeight="bold"
                                                            sx={{
                                                                width: "40px", // Fix width for order number
                                                                display: "inline-block",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            {o.internalNumber}
                                                        </Typography>
                                                        {o.hasUnreadEmails ? (
                                                            <>
                                                                <MailIcon fontSize="small" sx={{ width: 15, height: 20 }} />{o.unreadEmailsNumber}
                                                            </>
                                                        ) : (
                                                            <Box sx={{ width: 2, height: 20 }} />
                                                        )}
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            backgroundColor: getPaymentColor(o),
                                                            color: "white",
                                                            borderRadius: "50%",
                                                            width: "24px",
                                                            height: "24px",
                                                            minWidth: "24px",
                                                            minHeight: "24px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: "14px",
                                                            fontWeight: "bold",
                                                            marginRight: "5px",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        <Tooltip key={o.id} title={t(getPaymentCaption(o))} placement="right">
                                                            <Typography>$</Typography>
                                                        </Tooltip>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            backgroundColor:
                                                                o.priority === "Critical" ? "#b71c1c" :
                                                                    o.priority === "High" ? "#e53935" :
                                                                        o.priority === "Medium" ? "#fb8c00" :
                                                                            "#43a047", // Low = green
                                                            color: "white",
                                                            borderRadius: "4px",
                                                            px: 1,
                                                            py: 0.25,
                                                            fontSize: "0.75rem",
                                                            fontWeight: "bold",
                                                            marginRight: "5px",
                                                            flexShrink: 0,
                                                            minWidth: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        !
                                                    </Box>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            color: "black",
                                                            fontWeight: 500,
                                                            marginRight: "8px",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {customer?.name}:
                                                    </Typography>
                                                    <Tooltip key={o.id} title={o.initialEmailSubject} placement="right">
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: "black",
                                                                fontSize: "0.85em",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {o.initialEmailSubjectShorten}
                                                        </Typography>
                                                    </Tooltip>
                                                </Button>

                                                {/* Order Details */}
                                                <Box sx={{ paddingLeft: "10px" }}>
                                                    {[...(o.orderDetails || [])]
                                                        .sort((d1, d2) => d1.lineNumber - d2.lineNumber)
                                                        .map((detail) => {
                                                            const detailState = detailStates.find((state) => state.id === detail.stateId);
                                                            return (
                                                                <Button
                                                                    key={detail.id}
                                                                    onClick={() => handleOrderDetailClick(detail)}
                                                                    sx={{
                                                                        bgcolor: detailState?.bgColorRGB || "transparent",
                                                                        color: detailState?.colorRGB || "inherit",
                                                                        paddingY: "2px",         // Reduce top/bottom padding
                                                                        paddingX: "6px",         // tighten left/right
                                                                        fontSize: "0.75rem",     // Smaller font
                                                                        minHeight: "24px",       // Minimum height
                                                                        lineHeight: "1rem",      // Compact line height
                                                                        borderRadius: "4px",
                                                                        marginRight: "5px",
                                                                        marginBottom: "4px",
                                                                        border: `1px solid ${detailState?.bgColorRGB || "gray"}`,
                                                                        "&:hover": {
                                                                            bgcolor: detailState?.bgColorRGB || "transparent",
                                                                            color: detailState?.colorRGB || "inherit",
                                                                        }
                                                                    }}
                                                                >
                                                                    {detail.lineNumber} - {detail.customerNumber}
                                                                </Button>

                                                            );
                                                        })}
                                                </Box>
                                            </Box>
                                        );

                                    })
                                }
                                {view !== "grid" && hasMoreOrders && (
                                    <Box textAlign="center" mt={2}
                                        sx={{ position: 'sticky', bottom: 0, background: '#fff', py: 2 }}
                                    >
                                        <Button
                                            variant="contained"
                                            onClick={() => {
                                                const nextPage = orderPage + 1;
                                                //setOrderPage(nextPage);
                                                fetchOrders(nextPage);
                                            }}
                                        >
                                            {t("Load More")}
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    )}
                    {view === "list" ? (
                        <Box sx={{ display: "flex", flexGrow: 1, width: showSidebar ? "80%" : "100%", height: "100%" }} marginTop="0px">
                             {/* Order Form */}
                                    <Box sx={{
                                        width: `calc(${100 - emailWidth}%)`, // or use `flexGrow` if needed
                                        overflowY: "auto",
                                        transition: "width 0.3s ease",
                                        paddingLeft: "10px",
                                        paddingRight: "10px",
                                        borderRight: "1px solid lightgray"
                                    }}
                                    >
                                        {selectedOrder && (
                                        <Box display="flex" alignItems="center" gap={1}>
                                        <Typography variant="h6"
                                            sx={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                flexGrow: 1,        // take up remaining space
                                                minWidth: 0, 
                                            }}
                                        >
                                                {selectedOrder?.internalNumber} – {selectedOrder?.initialEmailSubjectShorten || selectedOrder?.initialEmailSubject}
                                        </Typography>
                                        <Box display="flex" alignItems="center" gap={0.5}>
                                            <Tooltip title={selectedOrder?.initialEmailSubject || ""}>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        setTempShortenSubject(selectedOrder?.initialEmailSubjectShorten || "");
                                                        setShowEditSubjectDialog(true);
                                                    }}
                                                    sx={{p: 0.25,m: 0,}}
                                                >
                                                    <ContentCutIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={t(selectedOrder?.priority || "Medium")}>
                                                <IconButton
                                                    size="small"
                                                    onClick={handlePriorityClick}
                                                    sx={{
                                                        color:
                                                            selectedOrder?.priority === "Critical" ? "#b71c1c" :
                                                                selectedOrder?.priority === "High" ? "#e53935" :
                                                                    selectedOrder?.priority === "Medium" ? "#fb8c00" :
                                                                        "#43a047" // Low = green
                                                        ,p: 0.25,m: 0,
                                                    }}
                                                >
                                                    <PriorityHighIcon />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip title={t("Reminders")}>
                                                <IconButton
                                                    size="small"
                                                    color={reminders.length > 0 ? "primary" : "default"} // highlight if reminders exist
                                                    onClick={() => setReminderListDialogOpen(true)}     // open dialog with list
                                                    sx={{ p: 0.25, m: 0, }}
                                                >
                                                    <Badge
                                                        badgeContent={reminders.length > 0 ? reminders.length : undefined}
                                                        color="error"
                                                    >
                                                        <NotificationsActiveIcon />
                                                    </Badge>
                                                </IconButton>
                                            </Tooltip>
                                       
                                            {avgRating && (
                                                <Tooltip title={t("Show survey results")}>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{ p: 0.25,m: 0 }}
                                                        onClick={() => setSurveyDialogOpen(true)}
                                                    >
                                                        ⭐ {avgRating}
                                                    </Button>
                                                </Tooltip>
                                            )}
                                        

                                            <Menu
                                                anchorEl={priorityAnchorEl}
                                                open={Boolean(priorityAnchorEl)}
                                                onClose={handlePriorityClose}
                                            >
                                                {(["Low", "Medium", "High", "Critical"] as OrderPriority[]).map((p) => (
                                                    <MenuItem
                                                        key={p}
                                                        onClick={() => handlePriorityChange(p)}
                                                        sx={{
                                                            color:
                                                                p === "Critical"
                                                                    ? "#b71c1c" // dark red
                                                                    : p === "High"
                                                                        ? "#e53935" // red
                                                                        : p === "Medium"
                                                                            ? "#fb8c00" // orange
                                                                            : "#43a047", // green
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {t(p)}
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </Box>

    
                                    </Box>

                                        )}

                                        <Grid container spacing={0} columnSpacing={"10px"}>
                                            <Grid item xs={fieldGridSize}>
                                                <FormControl sx={{ flex: 1 }} margin="dense" fullWidth >
                                                    <Autocomplete<Customer>
                                                        options={customers}
                                                        getOptionLabel={(c) => c.name || ""}
                                                        value={customers.find((c) => c.id === selectedOrder?.customerId) || null}
                                                        onChange={(_, newValue) => {
                                                            updateSelectedOrder({ customerId: newValue?.id ?? "" });
                                                            if (newValue?.id) fetchContacts(newValue.id);
                                                            //if (newValue?.notes) {
                                                            //    showCustomerNotes(newValue.notes);
                                                            //}
                                                            setIsDirty(true);
                                                        }}
                                                        size="small"
                                                        sx={{ mt: -1 }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label={t("Customer")}
                                                                margin="dense"
                                                                fullWidth
                                                                size="small"  
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    startAdornment: (
                                                                        <>
                                                                            {customerToShow && (
                                                                                <Tooltip
                                                                                    title={
                                                                                        <div>
                                                                                            <strong>{t("Notes")}:</strong> {customerToShow.notes}
                                                                                        </div>
                                                                                    }
                                                                                    arrow
                                                                                    placement="right"
                                                                                >
                                                                                    <IconButton edge="start" size="small">
                                                                                        <InfoOutlinedIcon fontSize="small" />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            )}
                                                                            {params.InputProps.startAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                        filterOptions={(options, { inputValue }) =>
                                                            options.filter((o) =>
                                                                o.name?.toLowerCase().includes(inputValue.toLowerCase())
                                                            )
                                                        }
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        slotProps={{
                                                            popper: {
                                                                sx: { zIndex: 3000 }, // 🔝 keeps dropdown above dialogs/sidebars
                                                            },
                                                        }}
                                                    />

                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={fieldGridSize}>
                                                <FormControl sx={{ flex: 1 }} margin="dense" fullWidth>
                                                    <InputLabel id="orderstate-label">{t("State")}</InputLabel>
                                                    <Select
                                                        labelId="orderstate-label"
                                                        label={t("State")}
                                                        value={selectedOrder?.stateId || ""}
                                                        onChange={(e) => {
                                                            updateSelectedOrder({ stateId: e.target.value });
                                                            handleChange(e);
                                                        }
                                                        }
                                                    >
                                                    {[...orderStates]
                                                    .sort((a, b) => {
                                                        if (a.sortOrder !== b.sortOrder) {
                                                            return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
                                                        }
                                                        return a.name.localeCompare(b.name);
                                                    })
                                                    .map((orderState) => (
                                                            <MenuItem key={orderState.id} value={orderState.id || ""}>
                                                                {orderState.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            
                                          {/*<Grid item xs={fieldGridSize}>*/}
                                          {/*      <FormControl sx={{ flex: 1 }} margin="dense" fullWidth variant="outlined">*/}
                                          {/*          <Autocomplete<Customer>*/}
                                          {/*              options={customers}*/}
                                          {/*              getOptionLabel={(c) => c.name || ""}*/}
                                          {/*              value={customers.find((c) => c.id === selectedOrder?.declarantCustomerId) || null}*/}
                                          {/*              onChange={(_, newValue) => {*/}
                                          {/*                  updateSelectedOrder({ declarantCustomerId: newValue?.id ?? "" });*/}
                                          {/*                  if (newValue?.id) fetchContacts(newValue.id);*/}
                                          {/*                  setIsDirty(true);*/}
                                          {/*                  if (newValue?.notes) {*/}
                                          {/*                      enqueueSnackbar(`${t("Notes")}: ${newValue.notes}`, {*/}
                                          {/*                          variant: "error",*/}
                                          {/*                          autoHideDuration: 12000, // 12 seconds, adjust as needed*/}
                                          {/*                          action: (snackbarId) => (*/}
                                          {/*                              <IconButton*/}
                                          {/*                                  size="small"*/}
                                          {/*                                  aria-label="close"*/}
                                          {/*                                  color="inherit"*/}
                                          {/*                                  onClick={() => closeSnackbar(snackbarId)}*/}
                                          {/*                              >*/}
                                          {/*                                  <CloseIcon fontSize="small" />*/}
                                          {/*                              </IconButton>*/}
                                          {/*                          ),*/}
                                          {/*                      });*/}
                                          {/*                  }*/}
                                          {/*              }}*/}
                                          {/*              size="small"*/}
                                          {/*              fullWidth*/}
                                          {/*              sx={{ mt: -1 }}   // ⬅️ align vertically with other combos*/}
                                          {/*              renderInput={(params) => (*/}
                                          {/*                  <TextField*/}
                                          {/*                      {...params}*/}
                                          {/*                      label={t("Declarant")}*/}
                                          {/*                      margin="dense"   // ⬅️ match Select vertical spacing*/}
                                          {/*                      size="small"*/}
                                          {/*                      fullWidth*/}
                                          {/*                      InputProps={{*/}
                                          {/*                          ...params.InputProps,*/}
                                          {/*                          startAdornment: (*/}
                                          {/*                              <>*/}
                                          {/*                                  {declarantCustomerToShow && (*/}
                                          {/*                                      <Tooltip*/}
                                          {/*                                          title={*/}
                                          {/*                                              <div>*/}
                                          {/*                                                  <strong>{t("Notes")}:</strong> {declarantCustomerToShow.notes}*/}
                                          {/*                                              </div>*/}
                                          {/*                                          }*/}
                                          {/*                                          arrow*/}
                                          {/*                                          placement="right"*/}
                                          {/*                                      >*/}
                                          {/*                                          <IconButton edge="start" size="small">*/}
                                          {/*                                              <InfoOutlinedIcon fontSize="small" />*/}
                                          {/*                                          </IconButton>*/}
                                          {/*                                      </Tooltip>*/}
                                          {/*                                  )}*/}
                                          {/*                                  {params.InputProps.startAdornment}*/}
                                          {/*                              </>*/}
                                          {/*                          ),*/}
                                          {/*                      }}*/}
                                          {/*                  />*/}
                                          {/*              )}*/}
                                          {/*              filterOptions={(options, { inputValue }) =>*/}
                                          {/*                  options.filter((o) =>*/}
                                          {/*                      o.name?.toLowerCase().includes(inputValue.toLowerCase())*/}
                                          {/*                  )*/}
                                          {/*              }*/}
                                          {/*              isOptionEqualToValue={(option, value) => option.id === value.id}*/}
                                          {/*              slotProps={{*/}
                                          {/*                  popper: { sx: { zIndex: 3000 } }, // keep dropdown above sidebar/dialogs*/}
                                          {/*              }}*/}
                                          {/*          />*/}
                                          {/*      </FormControl>*/}
                                          {/*  </Grid>*/}
                                            
                                            <Grid item xs={fieldGridSize}>
                                                <FormControl sx={{ flex: 1 }} margin="dense" fullWidth>
                                                    <InputLabel id="assigned-label">{t("Assigned To")}</InputLabel>
                                                    <Select
                                                labelId="assigned-label"
                                                label={t("Assigned To")}
                                                value={selectedOrder?.assignedToUserId || ""}
                                                onChange={(e) => {
                                                    const newUserId = e.target.value;

                                                    // Update order assigned user
                                                    updateSelectedOrder({ assignedToUserId: newUserId });

                                                    // Cascade to services without assignment
                                                    setSelectedOrder((prev) => {
                                                        if (!prev) return prev;
                                                        return {
                                                            ...prev,
                                                            orderServices: (prev.orderServices ?? []).map((os) => ({
                                                                ...os,
                                                                assignedUserId: os.assignedUserId || newUserId, // only set if not already assigned
                                                            })),
                                                        };
                                                    });

                                                    setIsDirty(true);
                                                }}
                                                    >
                                                        {[...users].sort((a, b) => a.userName.localeCompare(b.userName)).map((user) => (
                                                            <MenuItem key={user.id} value={user.id}>
                                                                {user.userName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                </Grid>
                                                {/*<Grid item xs={fieldGridSize}>*/}
                                                {/*    <FormControl sx={{ flex: 1 }} margin="dense" fullWidth>*/}
                                                {/*        <InputLabel id="type-label">{t("Type")}</InputLabel>*/}
                                                {/*        <Select*/}
                                                {/*            labelId="type-label"*/}
                                                {/*            label={t("Type")}*/}
                                                {/*            value={selectedOrder?.orderTypeId || ""}*/}
                                                {/*            onChange={(e) => {*/}
                                                {/*                updateSelectedOrder({ orderTypeId: e.target.value });*/}
                                                {/*                handleChange(e);*/}
                                                {/*            }*/}
                                                {/*            }*/}
                                                {/*        >*/}
                                                {/*            {[...orderTypes].sort((a, b) => a.name.localeCompare(b.name)).map((orderType) => (*/}
                                                {/*                <MenuItem key={orderType.id ?? ""} value={orderType.id ?? ""}>*/}
                                                {/*                    {orderType.name}*/}
                                                {/*                </MenuItem>*/}
                                                {/*            ))}*/}
                                                {/*        </Select>*/}
                                                {/*    </FormControl>*/}
                                                {/*</Grid>*/}
                                            
                                            {/*<Grid item xs={fieldGridSize}>*/}
                                            {/*    <DatePicker*/}
                                            {/*        label={t("Due Date")}*/}
                                            {/*        value={*/}
                                            {/*            selectedOrder?.dueDate*/}
                                            {/*                ? dayjs(new Date(selectedOrder.dueDate.year, selectedOrder.dueDate.month - 1, selectedOrder.dueDate.day))*/}
                                            {/*                : null*/}
                                            {/*        }*/}

                                            {/*        onChange={(date) => {*/}
                                            {/*            if (date) {*/}
                                            {/*                setSelectedOrder((prev) => {*/}
                                            {/*                    return prev*/}
                                            {/*                        ? {*/}
                                            {/*                            ...prev,*/}
                                            {/*                            dueDate: {*/}
                                            {/*                                year: date.year(),*/}
                                            {/*                                month: date.month() + 1,*/}
                                            {/*                                day: date.date(),*/}
                                            {/*                                dayOfWeek: date.day(),*/}
                                            {/*                            },*/}
                                            {/*                        }*/}
                                            {/*                        : null;*/}
                                            {/*                });*/}
                                            {/*            } else {*/}
                                            {/*                setSelectedOrder((prev) => {*/}
                                            {/*                    return prev ? { ...prev, dueDate: null } : null;*/}
                                            {/*                });*/}
                                            {/*                if (event) {*/}
                                            {/*                    handleChange(event);*/}
                                            {/*                }*/}
                                            {/*            }*/}
                                            {/*        }}*/}
                                            {/*        slotProps={{*/}
                                            {/*            textField: { margin: "dense", fullWidth: true }*/}
                                            {/*        }}*/}
                                            {/*    />*/}
                                            {/*</Grid>*/}
                                            
                                            {/*<Grid item xs={fieldGridSize}>*/}
                                            {/*    <TextField*/}
                                            {/*        margin="dense"*/}
                                            {/*        label={t("Invoice Number")}*/}
                                            {/*        fullWidth*/}
                                            {/*        value={selectedOrder?.invoiceNumber || ""}*/}
                                            {/*        onChange={(e) => {*/}
                                            {/*            setSelectedOrder((prev) =>*/}
                                            {/*                prev ? { ...prev, invoiceNumber: e.target.value } : null*/}
                                            {/*            )*/}
                                            {/*            handleChange(e);*/}
                                            {/*        }*/}
                                            {/*        }*/}
                                            {/*    />*/}
                                            {/*</Grid>*/}
                                        
                                            <Grid item xs={fieldGridSize}>
                                                <TextField
                                                    margin="dense"
                                                    label={t("Notes")}
                                                    multiline

                                                    fullWidth
                                                    value={selectedOrder?.notes || ""}
                                                    onChange={(e) => {
                                                        setSelectedOrder((prev) =>
                                                            prev ? { ...prev, notes: e.target.value } : null
                                                        )
                                                        handleChange(e);
                                                    }
                                                    }

                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1, padding: "0px", margin: "0px" }}>
                                                    <FormControlLabel
                                                        sx={{ margin: 0, padding: 0 }}
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                checked={selectedOrder?.prePaid || false}
                                                                onChange={(e) =>
                                                                    setSelectedOrder((prev) =>
                                                                        prev ? { ...prev, prePaid: e.target.checked } : null
                                                                    )
                                                                }
                                                                color="primary"
                                                            />
                                                        }
                                                        label={t("Pre Paid")}
                                                    />
                                                    <FormControlLabel
                                                        sx={{ margin: 0, padding: 0 }}
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                checked={selectedOrder?.invoiced || false}
                                                                onChange={(e) =>
                                                                    setSelectedOrder((prev) =>
                                                                        prev ? { ...prev, invoiced: e.target.checked } : null
                                                                    )
                                                                }
                                                                color="primary"
                                                            />
                                                        }
                                                        label={t("Invoiced")}
                                                    />
                                                    <FormControlLabel
                                                        sx={{ margin: 0, padding: 0 }}
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                checked={selectedOrder?.paid || false}
                                                                onChange={(e) =>
                                                                    setSelectedOrder((prev) =>
                                                                        prev ? { ...prev, paid: e.target.checked } : null
                                                                    )
                                                                }
                                                                color="primary"
                                                            />
                                                        }
                                                        label={t("Paid")}
                                                    />
                                                </Box>
                                            </Grid>


                                            {/*<Grid item xs={fieldGridSize}>*/}
                                            {/*    <TextField*/}
                                            {/*        margin="dense"*/}
                                            {/*        label={t("Shorten Email Subject")}*/}
                                            {/*        fullWidth*/}
                                            {/*        value={selectedOrder?.initialEmailSubjectShorten || ""}*/}
                                            {/*        onChange={(e) => updateSelectedOrder({ initialEmailSubjectShorten: e.target.value })}*/}
                                            {/*    />*/}
                                            {/*</Grid>*/}
                                            {/*<Grid item xs={fieldGridSize}>*/}
                                            {/*    <TextField*/}
                                            {/*        margin="dense"*/}
                                            {/*        label={t("Missing Info")}*/}
                                            {/*        multiline*/}
                                            {/*        fullWidth*/}
                                            {/*        value={selectedOrder?.missingInfo || ""}*/}
                                            {/*        onChange={(e) => {*/}
                                            {/*            setSelectedOrder((prev) =>*/}
                                            {/*                prev ? { ...prev, missingInfo: e.target.value } : null*/}
                                            {/*            )*/}
                                            {/*            handleChange(e);*/}
                                            {/*        }*/}
                                            {/*        }*/}
                                            {/*    />*/}
                                            {/*</Grid>*/}
                                    </Grid>
                                
                                <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1, paddingLeft: "5px", paddingRight: "5px", borderTopWidth: "1px", borderTopStyle: "solid", borderTopColor:"gray", marginTop:"8px" }}>
                                    <Typography variant="h6" sx={{ mb: 0, mt:1 }}>{t("Details")}</Typography>

                                    <Button
                                        size="small"
                                        variant="contained"
                                        sx={{
                                            padding: "2px 8px",
                                            ml: 1, mt:1 ,
                                            gap: 0.5
                                        }}
                                        onClick={addOrderDetail}
                                    >
                                        {t("Add")}
                                    </Button>

                                    {/* Buttons for All and line numbers */}
                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, ml: 1, mt:1 }}>
                                        <Button
                                            key="all"
                                            variant={visibleDetailLine === null ? "contained" : "outlined"}
                                            size="small"
                                            sx={{ minWidth: "36px", padding: "2px 8px" }}
                                            //onClick={() => setVisibleDetailLine(null)}
                                            onClick={() => {
                                                setVisibleDetailLine(null);
                                                navigate(`/orderdetailspage/${orderId}?view=${currentView}`);
                                            }}
                                        >
                                            {t("All")}
                                        </Button>
                                        {orderDetails
                                            .sort((a, b) => a.lineNumber - b.lineNumber)
                                            .map((detail) => {
                                                const selectedStateId =
                                                    detail.stateId && detailStates.some((s) => s.id === detail.stateId)
                                                        ? detail.stateId
                                                        : fallbackStateId;

                                                const tempDetailState = detailStates.find(
                                                    (ds) => ds.id === selectedStateId
                                                );

                                                return (
                                                    <Button
                                                        key={detail.id}
                                                        variant={visibleDetailLine === detail.lineNumber ? "contained" : "outlined"}
                                                        size="small"
                                                        sx={{
                                                            minWidth: "32px",
                                                            padding: "2px 6px",
                                                            color: tempDetailState?.colorRGB ?? "inherit",
                                                            backgroundColor: tempDetailState?.bgColorRGB ?? "transparent",
                                                        }}
                                                        //onClick={() => setVisibleDetailLine(detail.lineNumber)}
                                                        onClick={() => {
                                                            setVisibleDetailLine(detail.lineNumber);
                                                            navigate(`/orderdetailspage/${detail.orderId}/${detail.id}?view=${currentView}`);
                                                        }}
                                                    >
                                                        {detail.lineNumber}
                                                    </Button>
                                                );
                                            })}
                                    </Box>
                                </Box>



                                <Box sx={{ width: "100%"}}>
                                    {orderDetails
                                        .filter((detail) =>
                                            visibleDetailLine === null || detail.lineNumber === visibleDetailLine
                                        )
                                        .sort((a, b) => a.lineNumber - b.lineNumber)
                                        .map((detail) => {
                                                console.log(detail);
                                                const index = orderDetails.findIndex(d => d.id === detail.id); // ← get real index from full array
                                                const detailAssessments = selectedOrder?.orderDetailsTaxAssessments?.filter(
                                                    (a) => a.orderDetailId === detail.id
                                                );

                                                const selectedStateId = detail.stateId && detailStates.some(s => s.id === detail.stateId)
                                                    ? detail.stateId
                                                    : fallbackStateId;
                                                    return (
                                                <Box key={detail.id}>
                                                    <Grid container spacing={0} columnSpacing={"10px"}
                                                        sx={{
                                                            paddingBottom: "10px", paddingTop: "10px",
                                                            borderBottomColor: "gray", borderBottomWidth: "1px", borderBottomStyle: "solid",
                                                        }}
                                                    >
                                                        <Grid item xs={fieldGridSize}>
                                                            <Box display="flex" flex={1} alignItems="center">
                                                                <Button
                                                                    color="error"
                                                                    onClick={() => removeOrderDetail(index)}
                                                                    size="small"
                                                                    variant="text"
                                                                    style={{ minWidth: "auto", padding: "2px", margin: "0 2px" }}
                                                                >
                                                                    <DeleteIcon fontSize="small" />
                                                                </Button>
                                                                <Typography variant="h6" style={{ marginRight:"10px"}} >({detail.lineNumber})</Typography>
                                                                <FormControl sx={{ flex: 1 }} margin="dense" fullWidth>
                                                                    <InputLabel id="state-label">{t("State")}</InputLabel>
                                                                    <Select
                                                                        labelId="state-label"
                                                                        label={t("State")}
                                                                        value={selectedStateId}
                                                                        onChange={(e) =>
                                                                            handleOrderDetailChange(index, "stateId", e.target.value)
                                                                        }
                                                                    >
                                                                        {[...detailStates]
                                                                            .sort((a, b) => {
                                                                                if (a.sortOrder !== b.sortOrder) {
                                                                                    return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
                                                                                }
                                                                                return (a.name ?? "").localeCompare(b.name ?? "");
                                                                            })
                                                                            .map((detailState) => (
                                                                                <MenuItem
                                                                                    key={detailState.id ?? ''}
                                                                                    value={detailState.id ?? ''}
                                                                                >
                                                                                    {detailState.name}
                                                                                </MenuItem>
                                                                            ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={fieldGridSize}>
                                                              <FormControl sx={{ flex: 1 }} margin="dense" fullWidth variant="outlined">
                                                                  <Autocomplete<Customer>
                                                                      options={customers}
                                                                      getOptionLabel={(c) => c.name || ""}
                                                                      value={customers.find((c) => c.id === detail?.declarantCustomerId) || null}
                                                                      onChange={(_, newValue) => {
                                                                          handleOrderDetailChange(index, "declarantCustomerId", newValue?.id ?? null);
                                                                          if (newValue?.id) fetchContacts(newValue.id);
                                                                          setIsDirty(true);
                                                                          if (newValue?.notes) {
                                                                              enqueueSnackbar(`${t("Notes")}: ${newValue.notes}`, {
                                                                                  variant: "error",
                                                                                  autoHideDuration: 12000, // 12 seconds, adjust as needed
                                                                                  action: (snackbarId) => (
                                                                                      <IconButton
                                                                                          size="small"
                                                                                          aria-label="close"
                                                                                          color="inherit"
                                                                                          onClick={() => closeSnackbar(snackbarId)}
                                                                                      >
                                                                                          <CloseIcon fontSize="small" />
                                                                                      </IconButton>
                                                                                  ),
                                                                              });
                                                                          }
                                                                      }}
                                                                      size="small"
                                                                      fullWidth
                                                                      sx={{ mt: -1 }}   // ⬅️ align vertically with other combos
                                                                      renderInput={(params) => (
                                                                          <TextField
                                                                              {...params}
                                                                              label={t("Declarant")}
                                                                              margin="dense"   // ⬅️ match Select vertical spacing
                                                                              size="small"
                                                                              fullWidth
                                                                              InputProps={{
                                                                                  ...params.InputProps,
                                                                                  startAdornment: (
                                                                                      <>
                                                                                              <Tooltip
                                                                                                  title={
                                                                                                      <div>
                                                                                                      <strong>{t("Notes")}:</strong> {customers.find((c) => c.id === detail?.declarantCustomerId)?.notes || ""}
                                                                                                      </div>
                                                                                                  }
                                                                                                  arrow
                                                                                                  placement="right"
                                                                                              >
                                                                                                  <IconButton edge="start" size="small">
                                                                                                      <InfoOutlinedIcon fontSize="small" />
                                                                                                  </IconButton>
                                                                                              </Tooltip>
                                                                                          {params.InputProps.startAdornment}
                                                                                      </>
                                                                                  ),
                                                                              }}
                                                                          />
                                                                      )}
                                                                      filterOptions={(options, { inputValue }) =>
                                                                          options.filter((o) =>
                                                                              o.name?.toLowerCase().includes(inputValue.toLowerCase())
                                                                          )
                                                                      }
                                                                      isOptionEqualToValue={(option, value) => option.id === value.id}
                                                                      slotProps={{
                                                                          popper: { sx: { zIndex: 3000 } }, // keep dropdown above sidebar/dialogs
                                                                      }}
                                                                  />
                                                              </FormControl>
                                                          </Grid>


                                                        <Grid item xs={fieldGridSize}>
                                                            <TextField
                                                                label={t("Customer Reference Number")}
                                                                value={detail.customerNumber || ""}
                                                                margin="dense"
                                                                //onChange={(e) => updateCustomerNumber(index, e.target.value)}
                                                                onChange={(e) => {
                                                                    let val = e.target.value;
                                                                    // Prevent starting with a space
                                                                    if (val.startsWith(" ")) {
                                                                        val = val.trimStart();
                                                                    };
                                                                    updateCustomerNumber(index, val);
                                                                }}

                                                                fullWidth
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={() => copyToClipboard(detail.customerNumber || "")}>
                                                                                <ContentCopyIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={fieldGridSize}>
                                                            <TextField
                                                                label={t("Customs Reference Number")}
                                                                value={detail.customsReferenceNumber || ""}
                                                                onChange={(e) => handleOrderDetailChange(index, "customsReferenceNumber", e.target.value.toUpperCase())}
                                                                fullWidth
                                                                margin="dense"
                                                                inputProps={{ maxLength: 22 }}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={() => copyToClipboard(detail.customsReferenceNumber || "")}>
                                                                                <ContentCopyIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={fieldGridSize}>
                                                            <TextField
                                                                label={t("Container number")}
                                                                value={detail.containerNumber || ""}
                                                                onChange={(e) => handleOrderDetailChange(index, "containerNumber", e.target.value)}
                                                                margin="dense"
                                                                fullWidth
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={() => copyToClipboard(detail.containerNumber || "")}>
                                                                                <ContentCopyIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={fieldGridSize}>
                                                            <TextField
                                                                label={t("ATA")}
                                                                value={detail.ata || ""}
                                                                onChange={(e) => handleOrderDetailChange(index, "ata", e.target.value)}
                                                                fullWidth
                                                                margin="dense"
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={() => copyToClipboard(detail.ata || "")}>
                                                                                <ContentCopyIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={fieldGridSize}>
                                                            <TextField
                                                                label={t("Position number")}
                                                                type="number" margin="dense"
                                                                value={detail.positionsNumber || ""}
                                                                onChange={(e) => handleOrderDetailChange(index, "positionsNumber", e.target.value)}
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        <Grid item xs={fieldGridSize}>
                                                            <TextField
                                                                label={t("ATC")}
                                                                value={detail.atc || ""}
                                                                onChange={(e) => handleOrderDetailChange(index, "atc", e.target.value)}
                                                                fullWidth
                                                                margin="dense"
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={() => copyToClipboard(detail.atc || "")}>
                                                                                <ContentCopyIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        </Grid>
                                                        
                                                        <Grid item xs={fieldGridSize}>
                                                            <TextField
                                                                label={t("Notes")}
                                                                type="text"
                                                                margin="dense"
                                                                value={detail.notes || ""}
                                                                onChange={(e) => handleOrderDetailChange(index, "notes", e.target.value)}
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        <Grid item xs={fieldGridSize}>
                                                            <TextField
                                                                label={t("MRN")}
                                                                value={detail.mrn || ""}
                                                                onChange={(e) => handleOrderDetailChange(index, "mrn", e.target.value)}
                                                                fullWidth
                                                                margin="dense"
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={() => copyToClipboard(detail.mrn || "")}>
                                                                                <ContentCopyIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        </Grid>
                                                        {/*<Grid item xs={fieldGridSize}>*/}
                                                        {/*    <TextField*/}
                                                        {/*        label={t("Missing Info")}*/}
                                                        {/*        type="text"*/}
                                                        {/*        margin="dense"*/}
                                                        {/*        value={detail.missingInfo || ""}*/}
                                                        {/*        onChange={(e) => handleOrderDetailChange(index, "missingInfo", e.target.value)}*/}
                                                        {/*        fullWidth*/}
                                                        {/*    />*/}
                                                                {/*</Grid>*/}
                                                                
                                                        <Grid item xs={fieldGridSize}>
                                                            <DatePicker
                                                                        label={t("ETA Date")}
                                                                        value={
                                                                            detail?.etaDate
                                                                                ? dayjs(new Date(detail.etaDate.year, detail.etaDate.month - 1, detail.etaDate.day))
                                                                                : null
                                                                        }
                                                                        onChange={(date) => {
                                                                            if (date) {
                                                                                handleOrderDetailChange(index, "etaDate", {
                                                                                    year: date.year(),
                                                                                    month: date.month() + 1,
                                                                                    day: date.date(),
                                                                                    dayOfWeek: date.day()
                                                                                });
                                                                            } else {
                                                                                handleOrderDetailChange(index, "etaDate", null);
                                                                            }
                                                                        }}
                                                                        slotProps={{
                                                                            textField: { margin: "dense", fullWidth: true }
                                                                        }}
                                                                    />

                                                        </Grid>
                                                        <Grid item xs={fieldGridSize}>
                                                                <TextField
                                                                        select
                                                                        label={t("Hour")}
                                                                        style={{ width: "60px", marginRight:"5px" }}
                                                                        value={detail?.etaIntervalStart?.hour || 0} // Ensure a fallback value
                                                                        onChange={(e) => {
                                                                            if (e) {
                                                                                handleOrderDetailChange(index, "etaIntervalStart", {
                                                                                    hour: parseInt(e.target.value, 10),
                                                                                    minute: detail.etaIntervalStart?.minute ?? 0,  // Default to 0 if no value
                                                                                    second: detail.etaIntervalStart?.second ?? 0,
                                                                                });
                                                                            } else {
                                                                                handleOrderDetailChange(index, "etaIntervalStart", null);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {hourOptions.map((hour) => (
                                                                            <MenuItem key={hour} value={hour}>
                                                                                {hour.toString().padStart(2, "0")}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </TextField>
                                                                    <TextField
                                                                        select
                                                                        label={t("Minute")}
                                                                        style={{ width: "60px", marginRight:"5px" }}
                                                                        value={detail?.etaIntervalStart?.minute || 0} // Ensure a fallback value
                                                                        onChange={(e) => {
                                                                            if (e) {
                                                                                handleOrderDetailChange(index, "etaIntervalStart", {
                                                                                    hour: detail.etaIntervalStart?.hour ?? 0,
                                                                                    minute: parseInt(e.target.value, 10),  // Default to 0 if no value
                                                                                    second: detail.etaIntervalStart?.second ?? 0,
                                                                                });
                                                                            } else {
                                                                                handleOrderDetailChange(index, "etaIntervalStart", null);
                                                                            }
                                                                        }
                                                                        }
                                                                    >
                                                                        {minuteOptions.map((minute) => (
                                                                            <MenuItem key={minute} value={minute}>
                                                                                {minute.toString().padStart(2, "0")}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </TextField>

                                                                    <TextField
                                                                        select
                                                                        label={t("Hour")}
                                                                        style={{ width: "60px", marginRight:"5px" }}
                                                                        value={detail?.etaIntervalEnd?.hour || 0} // Ensure a fallback value
                                                                        onChange={(e) => {
                                                                            if (e) {
                                                                                handleOrderDetailChange(index, "etaIntervalEnd", {
                                                                                    hour: parseInt(e.target.value, 10),
                                                                                    minute: detail.etaIntervalEnd?.minute ?? 0,  // Default to 0 if no value
                                                                                    second: detail.etaIntervalEnd?.second ?? 0,
                                                                                });
                                                                            } else {
                                                                                handleOrderDetailChange(index, "etaIntervalEnd", null);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {hourOptions.map((hour) => (
                                                                            <MenuItem key={hour} value={hour}>
                                                                                {hour.toString().padStart(2, "0")}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </TextField>
                                                                    <TextField
                                                                        select
                                                                        label={t("Minute")}
                                                                        style={{ width: "60px", marginRight:"0px" }}
                                                                        value={detail?.etaIntervalEnd?.minute || 0} // Ensure a fallback value
                                                                        onChange={(e) => {
                                                                            if (e) {
                                                                                handleOrderDetailChange(index, "etaIntervalEnd", {
                                                                                    hour: detail.etaIntervalEnd?.hour ?? 0,
                                                                                    minute: parseInt(e.target.value, 10),  // Default to 0 if no value
                                                                                    second: detail.etaIntervalEnd?.second ?? 0,
                                                                                });
                                                                            } else {
                                                                                handleOrderDetailChange(index, "etaIntervalEnd", null);
                                                                            }
                                                                        }
                                                                        }
                                                                    >
                                                                        {minuteOptions.map((minute) => (
                                                                            <MenuItem key={minute} value={minute}>
                                                                                {minute.toString().padStart(2, "0")}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </TextField>

                                                        </Grid>
                                                     

                                                        <Grid item xs={12}>
                                                        <>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    justifyContent: "flex-start",
                                                                    backgroundColor: "lightgray",
                                                                    padding: "0px",
                                                                    marginTop: "5px",
                                                                    borderTop: "1px solid #ccc",
                                                                    borderRadius: "8px"
                                                                }}
                                                            >
                                                                <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", paddingLeft: "5px", paddingRight: "5px" }}>
                                                                    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
                                                                        <Typography variant="h6" sx={{ mb: 0 }}>{t("Services")}</Typography>

                                                                        <Button
                                                                            size="small"
                                                                            variant="contained"
                                                                            sx={{
                                                                                paddingY: "2px",  // vertical padding
                                                                                paddingX: "10px",  // horizontal padding
                                                                                minHeight: "24px",
                                                                                fontSize: "0.75rem", // optional: smaller text
                                                                                marginBottom: "8px",
                                                                                marginTop: "8px"
                                                                            }}
                                                                            onClick={() => {
                                                                                addService(detail.id);
                                                                            }}
                                                                        >
                                                                                        {t("Add")}
                                                                        </Button>
                                                                        {!detail.draftServiceInvoiceCreated && (
                                                                            <Button
                                                                                size="small"
                                                                                sx={{
                                                                                    paddingY: "2px",  // vertical padding
                                                                                    paddingX: "10px",  // horizontal padding
                                                                                    minHeight: "24px",
                                                                                    fontSize: "0.75rem", // optional: smaller text
                                                                                    marginBottom: "8px",
                                                                                    marginTop: "8px"
                                                                                }}
                                                                                variant="contained"
                                                                                color="primary"
                                                                                disabled={invoiceBusy}
                                                                                onClick={() => handleCreateDraftServiceInvoice(selectedOrder?.id ?? "", detail.id)}
                                                                            >
                                                                                {t("Create Draft")}
                                                                            </Button>
                                                                        )}

                                                                        {detail.draftServiceInvoiceCreated && !detail.invoiced && (
                                                                            <>
                                                                                <Button
                                                                                    size="small"
                                                                                    sx={{
                                                                                        paddingY: "2px",  // vertical padding
                                                                                        paddingX: "10px",  // horizontal padding
                                                                                        minHeight: "24px",
                                                                                        fontSize: "0.75rem", // optional: smaller text
                                                                                        marginBottom: "8px",
                                                                                        marginTop: "8px"
                                                                                    }}
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    disabled={invoiceBusy}
                                                                                    onClick={() => handleFinalizeServiceInvoice(detail.id)}
                                                                                >
                                                                                    {t("Finalize Draft")}
                                                                                </Button>
                                                                                <Button
                                                                                    size="small"
                                                                                    sx={{
                                                                                        paddingY: "2px",  // vertical padding
                                                                                        paddingX: "10px",  // horizontal padding
                                                                                        minHeight: "24px",
                                                                                        fontSize: "0.75rem", // optional: smaller text
                                                                                        marginBottom: "8px",
                                                                                        marginTop: "8px"
                                                                                    }}
                                                                                    variant="contained"
                                                                                    color="error"
                                                                                    disabled={invoiceBusy}
                                                                                    onClick={() => handleDeleteServiceDraft(detail.id)}
                                                                                >
                                                                                    {t("Delete Draft")}
                                                                                </Button>
                                                                            </>
                                                                        )}

                                                                        {detail.invoiced && detail.id && (
                                                                            <>
                                                                                <Button
                                                                                    size="small"
                                                                                    variant="contained"
                                                                                    color="success"
                                                                                    sx={{
                                                                                        paddingY: "2px",  // vertical padding
                                                                                        paddingX: "10px",  // horizontal padding
                                                                                        minHeight: "24px",
                                                                                        fontSize: "0.75rem", // optional: smaller text
                                                                                        marginBottom: "8px",
                                                                                        marginTop: "8px"
                                                                                    }}
                                                                                    disabled={invoiceBusy}
                                                                                    onClick={() => {
                                                                                        handleViewServiceInvoice(detail.id);
                                                                                    }}
                                                                                >
                                                                                    {t("View Invoice")}
                                                                                </Button>
                                                                                <Button
                                                                                    size="small"
                                                                                    variant="contained"
                                                                                    color="success"
                                                                                    sx={{
                                                                                        paddingY: "2px",  // vertical padding
                                                                                        paddingX: "10px",  // horizontal padding
                                                                                        minHeight: "24px",
                                                                                        fontSize: "0.75rem", // optional: smaller text
                                                                                        marginBottom: "8px",
                                                                                        marginTop: "8px"
                                                                                    }}
                                                                                    disabled={invoiceBusy}
                                                                                    onClick={() => handleSendServiceInvoice(detail.id)}
                                                                                >
                                                                                    {t("Send Invoice")}
                                                                                </Button>
                                                                            </>
                                                                        )}

                                                                        <Tooltip title="Link service invoice">
                                                                            <Button
                                                                                size="small"
                                                                                variant="contained"
                                                                                sx={{
                                                                                    paddingY: "2px",  // vertical padding
                                                                                    paddingX: "10px",  // horizontal padding
                                                                                    minHeight: "24px",
                                                                                    fontSize: "0.75rem", // optional: smaller text
                                                                                    marginBottom: "8px",
                                                                                    marginTop: "8px"
                                                                                }}
                                                                                onClick={() => handleOpenLinkDialog("Services", null, detail.id)} color="primary"
                                                                            >
                                                                                {t("Link Invoice")}
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </Box>
                                                                </Box>
                                                            </Box>


                                                            <Box sx={{
                                                                width: "100%", display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "flex-start",
                                                            }}>
                                                                <Grid container spacing={0} columnSpacing={1}>
                                                                    <Grid item xs={12}>
                                                                        <Box sx={{ mt: 0.5 }}>
                                                                               {selectedOrder?.orderServices
                                                                                        ?.filter(os => os.orderDetailId === detail.id)
                                                                                        .map((os, index) => (
                                                                                <Grid
                                                                                    container
                                                                                    spacing={1}
                                                                                    key={index}
                                                                                    alignItems="center"
                                                                                    sx={{ mb: 1 }}
                                                                                >

                                                                                    {/* Remove button */}
                                                                                    <Grid item xs={0.5}>
                                                                                        <IconButton
                                                                                            color="error"
                                                                                            size="small"
                                                                                            onClick={() =>
                                                                                                deleteService(detail.id, os.serviceId)
                                                                                            }
                                                                                        >
                                                                                            <DeleteIcon fontSize="small" />
                                                                                        </IconButton>
                                                                                    </Grid>
                                                                                    {/* Service dropdown */}
                                                                                    <Grid item xs={4}>
                                                                                        <FormControl fullWidth size="small">
                                                                                            <InputLabel>{t("Service")}</InputLabel>
                                                                                            <Select
                                                                                                value={os.serviceId || ""}
                                                                                                onChange={(e) =>
                                                                                                    updateService(
                                                                                                        detail.id,
                                                                                                        os.serviceId,
                                                                                                        { serviceId: e.target.value }
                                                                                                    )
                                                                                                }                                                                                            >
                                                                                                {services.map((s) => (
                                                                                                    <MenuItem key={s.id ?? ""} value={s.id ?? ""}>
                                                                                                        {s.name}
                                                                                                    </MenuItem>
                                                                                                ))}
                                                                                            </Select>
                                                                                        </FormControl>
                                                                                    </Grid>

                                                                                    {/* Assigned user dropdown */}
                                                                                    <Grid item xs={2.5}>
                                                                                        <FormControl fullWidth size="small">
                                                                                            <InputLabel>{t("Assigned To")}</InputLabel>
                                                                                            <Select
                                                                                                value={os.assignedUserId || ""}
                                                                                                onChange={(e) =>
                                                                                                    updateService(
                                                                                                        detail.id,
                                                                                                        os.serviceId,
                                                                                                        { assignedUserId: e.target.value }
                                                                                                    )
                                                                                                }
                                                                                            >

                                                                                                {users.map((u) => (
                                                                                                    <MenuItem key={u.id} value={u.id}>
                                                                                                        {u.userName}
                                                                                                    </MenuItem>
                                                                                                ))}
                                                                                            </Select>
                                                                                        </FormControl>
                                                                                    </Grid>

                                                                                    {/* Quantity */}
                                                                                    <Grid item xs={1.5}>
                                                                                        <TextField
                                                                                            type="number"
                                                                                            size="small"
                                                                                            label={t("Qty")}
                                                                                            value={os.quantity ?? ""}
                                                                                            onChange={(e) => {
                                                                                                const val = parseInt(e.target.value, 10);
                                                                                                updateService(
                                                                                                    detail.id,
                                                                                                    os.serviceId,
                                                                                                    { quantity: isNaN(val) ? null : val }
                                                                                                );
                                                                                            }}
                                                                                            fullWidth
                                                                                        />
                                                                                    </Grid>

                                                                                    <Grid item xs={1}>
                                                                                        <TextField
                                                                                            type="number"
                                                                                            size="small"
                                                                                            label={t("Addl")}
                                                                                            value={os.additionalUnits ?? ""}
                                                                                            onChange={(e) => {
                                                                                                const val = parseInt(e.target.value, 10);
                                                                                                updateService(
                                                                                                    detail.id,
                                                                                                    os.serviceId,
                                                                                                    { additionalUnits: isNaN(val) ? null : val }
                                                                                                );
                                                                                            }}
                                                                                            fullWidth
                                                                                        />
                                                                                    </Grid>


                                                                                    <Grid item xs={1.5}>
                                                                                        {services.find(s => s.id == os.serviceId)?.customPricingPerOrderDetails && (
                                                                                            <TextField
                                                                                                type="number"
                                                                                                size="small"
                                                                                                label={t("Price")}
                                                                                                value={os.customPrice ?? ""}
                                                                                                disabled={!services.find(s => s.id == os.serviceId)?.customPricingPerOrderDetails}
                                                                                                onChange={(e) => {
                                                                                                    const val = parseFloat(e.target.value);
                                                                                                    updateService(
                                                                                                        detail.id,
                                                                                                        os.serviceId,
                                                                                                        { customPrice: isNaN(val) ? null : val }
                                                                                                    );
                                                                                                }}
                                                                                                fullWidth
                                                                                            />)}
                                                                                    </Grid>

                                                                                    {/* Completed checkbox */}
                                                                                    <Grid item xs={1}>
                                                                                        <FormControlLabel
                                                                                            control={
                                                                                                <Checkbox
                                                                                                    checked={os.isCompleted ?? false}
                                                                                                    onChange={(e) =>
                                                                                                        updateService(
                                                                                                            detail.id,
                                                                                                            os.serviceId,
                                                                                                            { isCompleted: e.target.checked }
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                            }
                                                                                            label={t("Done")}
                                                                                        />
                                                                                    </Grid>


                                                                                </Grid>
                                                                            ))}
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>

                                                                <Box sx={{ width: "100%" }}>
                                                                    <Grid item xs={fieldGridSize}>
                                                                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                                                                            {/*{selectedOrder?.orderInvoices?.map((oi) => (*/}
                                                                            {tempOrderInvoices
                                                                                .filter((oi) => (oi.invoice?.kind === "Services") && (oi.orderDetailId === detail.id))
                                                                                .map((oi) => (
                                                                                    <Chip
                                                                                        key={oi.invoiceId}
                                                                                        label={
                                                                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                                                {oi.invoice?.amount ?? ""}
                                                                                                &nbsp;({oi.invoice?.accountingInvoiceNumber ?? ""})
                                                                                                <IconButton
                                                                                                    size="small"
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation(); // prevent triggering delete
                                                                                                        handleDownloadInvoicePdf(oi.invoiceId, oi.invoice?.accountingInvoiceNumber ?? oi.invoiceId);
                                                                                                    }}
                                                                                                    title="Download PDF"
                                                                                                    sx={{ color: "white" }}
                                                                                                >
                                                                                                    <PictureAsPdf fontSize="small" sx={{ color: "white" }} />
                                                                                                </IconButton>
                                                                                            </Box>
                                                                                        }
                                                                                        color={oi.invoice?.isPaid ? "success" : "error"}
                                                                                        onDelete={() => {
                                                                                            setInvoiceToUnlink(oi.invoiceId);
                                                                                            setConfirmUnlinkOpen(true);
                                                                                        }}
                                                                                        deleteIcon={<Delete />}
                                                                                    />
                                                                                ))}

                                                                        </Box>
                                                                    </Grid>
                                                                </Box>
                                                            </Box>
                                                        </>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                        <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    justifyContent: "flex-start",
                                                                    backgroundColor: "lightgray",
                                                                    padding: "0px",
                                                                    marginTop: "5px",
                                                                    borderRadius: "8px"
                                                                }}
                                                            >
                                                                <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-start", paddingLeft: "5px", paddingRight: "5px" }}>
                                                                    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
                                                                        <Typography variant="h6" sx={{ mb: 0 }}>{t("Taxes")}</Typography>
                                                                                {selectedOrder?.orderDetailsTaxAssessments?.filter((assessment) => assessment.orderDetailId === detail.id).length == 0 && (
                                                                                <Button
                                                                                    size="small"
                                                                                    variant="contained"
                                                                                    sx={{
                                                                                        paddingY: "2px",  // vertical padding
                                                                                        paddingX: "4px",  // horizontal padding
                                                                                        minHeight: "24px",
                                                                                        fontSize: "0.75rem", // optional: smaller text
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        const newId = crypto.randomUUID();
                                                                                        const newAssessment: OrderDetailsTaxAssessment = {
                                                                                            id: newId,
                                                                                            orderId: selectedOrder?.id ?? "", // assign FK
                                                                                            orderDetailId: detail.id,
                                                                                            taxAmount: 0,
                                                                                            attachmentId: "",
                                                                                            invoiceNumber: "",
                                                                                            invoiced: false,
                                                                                            paid: false,
                                                                                            isValidated: false,
                                                                                            draftCreated: false,
                                                                                            draftValidated: false,
                                                                                            sevDeskInvoiceId: null,
                                                                                            sevDeskInvoiceUrl: null,
                                                                                        };

                                                                                        setSelectedOrder((prev) =>
                                                                                            prev
                                                                                                ? {
                                                                                                    ...prev,
                                                                                                    orderDetailsTaxAssessments: [
                                                                                                        ...(prev.orderDetailsTaxAssessments ?? []),
                                                                                                        newAssessment,
                                                                                                    ],
                                                                                                }
                                                                                                : null
                                                                                        );
                                                                                        //setEditingAssessmentId(newId);
                                                                                        //setTaxesDirty(true);
                                                                                        setIsDirty(true);
                                                                                    }}
                                                                                >
                                                                                    {t("Create")}
                                                                                </Button>
                                                                            )}
                                                                    </Box>
                                                                </Box>
                                                            </Box>

                                                        <Box sx={{ width: "100%" }}>
                                                             
                                                            {detailAssessments?.map((assessment) => (
                                                                <Box
                                                                    key={assessment.id}
                                                                    sx={{
                                                                        p: 1,
                                                                    }}
                                                                >
                                                                    {/* Header line: title + Add Row button */}
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: 1,
                                                                        }}
                                                                    >
                                                                        <Typography variant="subtitle2">
                                                                            {t("Tax Assessment")} ({t("Total")}: {assessment.taxAmount.toFixed(2)} €)
                                                                        </Typography>

                                                                        <Button
                                                                            size="small"
                                                                            variant="contained"
                                                                            onClick={() => handleAddTaxRow(assessment.id)}
                                                                            sx={{
                                                                                paddingY: "2px",  // vertical padding
                                                                                paddingX: "10px",  // horizontal padding
                                                                                minHeight: "24px",
                                                                                fontSize: "0.75rem", // optional: smaller text
                                                                                marginBottom: "8px",
                                                                                marginTop: "8px"
                                                                            }}
                                                                        >
                                                                            Add
                                                                        </Button>
                                                                    </Box>

                                                                    {/* Editable Tax Rows */}
                                                                    {(assessment.taxRows ?? []).map((row) => (
                                                                        <Box
                                                                            key={row.id}
                                                                            sx={{
                                                                                display: "flex",
                                                                                gap: 1,
                                                                                alignItems: "center",
                                                                                mb: 0.5,
                                                                            }}
                                                                        >
                                                                            <IconButton
                                                                                color="error"
                                                                                onClick={() => { handleDeleteTaxRow(assessment.id, row.id) } }
                                                                            >
                                                                                <DeleteIcon fontSize="small" />
                                                                            </IconButton>
                                                                            <FormControl size="small" fullWidth>
                                                                                <InputLabel>Tax Type</InputLabel>
                                                                                <Select
                                                                                    value={row.taxTypeMappingId ?? ""}
                                                                                    label="Tax Type"
                                                                                    onChange={(e) => {
                                                                                        //const mapping = taxTypeMappings.find(
                                                                                        //    (m) => m.id === e.target.value
                                                                                        //);

                                                                                        handleTaxRowChange(assessment.id, row.id, "taxTypeMappingId", e.target.value);

                                                                                    {/*    updateRow(row.id, {*/}
                                                                                    {/*        taxTypeMappingId: mapping?.id,*/}     
                                                                                    {/*        taxType: mapping?.customsTaxType ?? ""*/}
                                                                                    {/*    });*/}
                                                                                    }}
                                                                                >
                                                                                    {taxTypeMappings
                                                                                        .filter((m): m is { id: string; customsTaxTypeCode?: string } => m.id != null)
                                                                                        .map(m => (
                                                                                            <MenuItem key={m.id} value={m.id}>
                                                                                                {m.customsTaxTypeCode ?? ""}
                                                                                            </MenuItem>
                                                                                        ))}

                                                                                </Select>
                                                                            </FormControl>

                                                                            <TextField
                                                                                size="small"
                                                                                label={t("Amount")}
                                                                                type="number"
                                                                                sx={{ width: 130 }}
                                                                                value={row.amount || ""}
                                                                                onChange={(e) =>
                                                                                    handleTaxRowChange(assessment.id, row.id, "amount", e.target.value)
                                                                                }
                                                                            />

                                                                        </Box>
                                                                    ))}
                                                                </Box>

                                                            ))}
                                                                        <Grid container spacing={0} columnSpacing={"10px"}>
                                                                            {/* Tax Assessment Box with border and half width */}
                                                                            <Grid item xs={fieldGridSize}>
                                                                                {selectedOrder?.orderDetailsTaxAssessments
                                                                                    ?.filter((assessment) => assessment.orderDetailId === detail.id) // only those linked to this detail
                                                                                    .map((assessment) => {
                                                                                        const taxInvoices = tempOrderInvoices.filter(
                                                                                            (oi) => oi.invoice?.kind === "Tax" && oi.invoice?.orderDetailsTaxAssessmentId === assessment.id
                                                                                        );
                                                                                        console.log("Tax Invoices for Assessment", taxInvoices.length);
                                                                                        //const invoiceTotal = taxInvoices.reduce((sum, oi) => sum + (oi.invoice?.amount ?? 0), 0);
                                                                                        //const isError = invoiceTotal !== (assessment.taxAmount ?? 0);

                                                                                        return (
                                                                                            <Box
                                                                                                sx={{
                                                                                                    position: "relative",
                                                                                                    backgroundColor: "#f9f9f9",
                                                                                                    paddingLeft: "10px",
                                                                                                    paddingTop: "4px",
                                                                                                    paddingBottom: "4px",
                                                                                                    mt: 1,
                                                                                                }}
                                                                                            >
                                                                                                {/* Edit Button */}
                                                                                                {/*<IconButton*/}
                                                                                                {/*    size="small"*/}
                                                                                                {/*    onClick={() => setEditingAssessmentId(assessment.id)}*/}
                                                                                                {/*    sx={{ position: "absolute", top: 4, right: 36 }}*/}
                                                                                                {/*>*/}
                                                                                                {/*    <EditIcon fontSize="small" />*/}
                                                                                                {/*</IconButton>*/}
                                                                                                {/* Delete Icon */}
                                                                                                {/*<IconButton*/}
                                                                                                {/*    size="small"*/}
                                                                                                {/*    onClick={() => {*/}
                                                                                                {/*        if (!selectedOrder) return;*/}
                                                                                                {/*        setSelectedOrder((prev) =>*/}
                                                                                                {/*            prev*/}
                                                                                                {/*                ? {*/}
                                                                                                {/*                    ...prev,*/}
                                                                                                {/*                    orderDetailsTaxAssessments: prev.orderDetailsTaxAssessments?.filter(*/}
                                                                                                {/*                        (a) => a.id !== assessment.id*/}
                                                                                                {/*                    ) ?? [],*/}
                                                                                                {/*                }*/}
                                                                                                {/*                : null*/}
                                                                                                {/*        );*/}
                                                                                                {/*        setIsDirty(true);*/}
                                                                                                {/*    }}*/}
                                                                                                {/*    sx={{ position: "absolute", top: 4, right: 4 }}*/}
                                                                                                {/*>*/}
                                                                                                {/*    <DeleteIcon fontSize="small" color="error" />*/}
                                                                                                {/*</IconButton>*/}
                                                                                                {assessment.attachmentId && (
                                                                                                    <Tooltip title={t("Download Tax Document")}>
                                                                                                        <IconButton
                                                                                                            size="small"
                                                                                                            onClick={() => handleDownloadAttachment(assessment.attachmentId!)}
                                                                                                            sx={{ position: "absolute", top: 4, right: 70 }}
                                                                                                        >
                                                                                                            <PictureAsPdf fontSize="small" />
                                                                                                        </IconButton>
                                                                                                    </Tooltip>
                                                                                                )}
                                                                                                {/* Editable or Static Amount */}
                                                                                                {/*{editingAssessmentId === assessment.id ? (*/}
                                                                                                {/*    <OutlinedInput*/}
                                                                                                {/*        fullWidth*/}
                                                                                                {/*        size="small"*/}
                                                                                                {/*        value={assessment.taxAmount ?? ""}*/}
                                                                                                {/*        onChange={(e) => {*/}
                                                                                                {/*            const newValue = parseFloat(e.target.value);*/}
                                                                                                {/*            if (!selectedOrder) return;*/}

                                                                                                {/*            const updated = selectedOrder.orderDetailsTaxAssessments?.map((a) =>*/}
                                                                                                {/*                a.id === assessment.id ? { ...a, taxAmount: isNaN(newValue) ? 0 : newValue } : a*/}
                                                                                                {/*            );*/}

                                                                                                {/*            setSelectedOrder((prev) => (prev ? { ...prev, orderDetailsTaxAssessments: updated ?? [] } : null));*/}
                                                                                                {/*            setIsDirty(true);*/}
                                                                                                {/*        }}*/}
                                                                                                {/*        onBlur={() => setEditingAssessmentId(null)}*/}
                                                                                                {/*        inputProps={{*/}
                                                                                                {/*            type: "number",*/}
                                                                                                {/*            min: "0",*/}
                                                                                                {/*            step: "0.01",*/}
                                                                                                {/*        }}*/}
                                                                                                {/*    />*/}
                                                                                                {/*) : (*/}
                                                                                                {/*    <Typography*/}
                                                                                                {/*        variant="subtitle1"*/}
                                                                                                {/*        color={isError ? "error" : "text.primary"}*/}
                                                                                                {/*    >*/}
                                                                                                {/*        {t("Tax Assessment")}: {assessment.taxAmount?.toFixed(2) ?? ""}*/}
                                                                                                {/*    </Typography>*/}
                                                                                                {/*)}*/}
                                                                                                <Box sx={{ display: "flex", gap: 1 }}>
                                                                                                    {!assessment.draftValidated && (
                                                                                                        <Button
                                                                                                            size="small"
                                                                                                            variant="contained"
                                                                                                            color="primary"
                                                                                                            disabled={invoiceBusy}
                                                                                                            onClick={() => handleValidateAssessment(selectedOrder.id, assessment.id)}
                                                                                                        >
                                                                                                            {t("Validate tax values")}
                                                                                                        </Button>
                                                                                                    )}

                                                                                                    {assessment.draftValidated && !assessment.draftCreated && (
                                                                                                        <Button
                                                                                                            size="small"
                                                                                                            variant="contained"
                                                                                                            color="primary"
                                                                                                            disabled={invoiceBusy}
                                                                                                            onClick={() => handleCreateDraftTaxInvoice(selectedOrder.id, assessment.id)}
                                                                                                        >
                                                                                                            {t("Create Draft")}
                                                                                                        </Button>
                                                                                                        
                                                                                                    )}

                                                                                                    
                                                                                                        {assessment.draftCreated && !assessment.invoiced && (
                                                                                                        <>
                                                                                                            <Button
                                                                                                                size="medium"
                                                                                                                variant="contained"
                                                                                                                color="primary"
                                                                                                                disabled={invoiceBusy}
                                                                                                                onClick={() => handleViewInvoice(selectedOrder.id, assessment.id)}
                                                                                                            >
                                                                                                                {t("Finalize Draft")}
                                                                                                            </Button>
                                                                                                            <Button
                                                                                                                size="medium"
                                                                                                                variant="contained"
                                                                                                                color="error"
                                                                                                                disabled={invoiceBusy}
                                                                                                                onClick={() => handleDeleteDraft(assessment.id)}
                                                                                                            >
                                                                                                                {t("Delete Draft")}
                                                                                                            </Button>
                                                                                                        </>
                                                                                                    )}

                                                                                                    {assessment.invoiced && (
                                                                                                        <>
                                                                                                            <Button
                                                                                                                size="small"
                                                                                                                variant="contained"
                                                                                                                color="success"
                                                                                                                disabled={invoiceBusy}
                                                                                                                onClick={() => handleViewInvoice(selectedOrder.id, assessment.id)}
                                                                                                            >
                                                                                                                View Invoice
                                                                                                            </Button>
                                                                                                            <Button
                                                                                                                size="small"
                                                                                                                variant="contained"
                                                                                                                color="success"
                                                                                                                disabled={invoiceBusy}
                                                                                                                onClick={() => handleSendInvoice(assessment.id)}
                                                                                                            >
                                                                                                                Send Invoice
                                                                                                            </Button>
                                                                                                        </>
                                                                                                    )}
                                                                                                </Box>
                                                                                            </Box>
                                                                                        );
                                                                                    })}
                                                                            </Grid>

                                                                            {/* Tax Invoice in second column, same row */}
                                                                            <Grid item xs={fieldGridSize}>
                                                                                <Box sx={{ display: "flex", flexWrap: "wrap", mt: 1 }}>
                                                                                    {(() => {
                                                                                        const relatedInvoices = tempOrderInvoices.filter(
                                                                                            (oi) =>
                                                                                                oi.invoice?.kind === "Tax" &&
                                                                                                oi.orderDetailId === detail.id
                                                                                        );

                                                                                        if (relatedInvoices.length > 0) {
                                                                                            return relatedInvoices.map((oi) => (
                                                                                                <Chip
                                                                                                    key={oi.invoiceId}
                                                                                                    label={
                                                                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
                                                                                                            &euro;{oi.invoice?.amount ?? ""} &nbsp;
                                                                                                            ({oi.invoice?.accountingInvoiceNumber ?? ""})
                                                                                                            <IconButton
                                                                                                                size="small"
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleDownloadInvoicePdf(oi.invoiceId, oi.invoice?.accountingInvoiceNumber ?? oi.invoiceId);
                                                                                                                }}
                                                                                                                title="Download PDF"
                                                                                                                sx={{ color: "white" }}
                                                                                                            >
                                                                                                                <PictureAsPdf fontSize="small" sx={{ color: "white" }} />
                                                                                                            </IconButton>
                                                                                                        </Box>
                                                                                                    }
                                                                                                    color={oi.invoice?.isPaid ? "success" : "error"}
                                                                                                    onDelete={() => {
                                                                                                        setInvoiceToUnlink(oi.invoiceId);
                                                                                                        setConfirmUnlinkOpen(true);
                                                                                                    }}
                                                                                                    deleteIcon={<Delete />}
                                                                                                    sx={{ mr: 0.5, mb: 0.5 }}
                                                                                                />
                                                                                            ));
                                                                                        } else {
                                                                                            return (
                                                                                                <Box sx={{ display: "flex", gap: 1 }}>
                                                                                                    <Tooltip title="Link tax invoice">
                                                                                                        <Button
                                                                                                            onClick={() => handleOpenLinkDialog("Tax", null, detail.id)}
                                                                                                            size="small"
                                                                                                            color="primary"
                                                                                                        >
                                                                                                            {t("Link Invoice")}
                                                                                                        </Button>
                                                                                                    </Tooltip>

                                                                                                </Box>
                                                                                            );
                                                                                        }
                                                                                    })()}
                                                                                </Box>
                                                                            </Grid>
                                                                        </Grid>
                                                       </Box>
                                                    </Grid>
                                                </Grid>
                                                </Box>

                                                );
                                            })}
                                    </Box>
                                <Box sx={{ borderTopColor:"gray", borderTopStyle:"solid", borderTopWidth:"2" } }>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ marginTop: "10px" }}
                                            onClick={() => handleSave()}
                                        >
                                            {t("Save")}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ marginLeft: "10px", marginTop: "10px" }}
                                            onClick={() => handleServiceInvoice()}
                                        >
                                            {t("Service Invoice Draft")}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ marginLeft: "10px", marginTop:"10px" }}
                                            onClick={() => handleSave(undefined, { close: true })}
                                        >
                                            {t("Close")}
                                        </Button>
                                        <Button onClick={async () => {
                                            if (!selectedOrder?.id) return;

                                            const confirm = window.confirm(t("Are you sure you want to delete this record?"));
                                            if (!confirm) return;

                                            try {
                                                
                                                await axiosExt.delete(`${API_BASE_URL}/orders/${selectedOrder.id}`, {
                                                    headers: {
                                                        "Authorization": `Bearer ${token}`,
                                                    },
                                                });
                                                enqueueSnackbar(t("Record deleted successfully."), { variant: "success" });
                                                setOrders(prev => prev.filter(o => o.id !== selectedOrder.id));
                                                setSelectedOrder(null);
                                                navigate("/orderdetailspage");
                                            } catch (error) {
                                                console.error("Failed to delete record:", error);
                                                enqueueSnackbar(t("Failed to delete record."), { variant: "error" });
                                            }
                                        }}
                                            variant="contained"
                                            color="error"
                                            style={{ marginLeft: "10px", marginTop: "10px" }}

                                        >
                                            {t("Delete")}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            style={{ marginLeft: "10px", marginTop: "10px" }}
                                            onClick={() => {
                                                fetchCustomerOrders();
                                                setMergeDialogOpen(true);
                                            }}
                                        >
                                            {t("Merge")}
                                        </Button>
                                        {selectedOrder?.stateId === mergedStateId && selectedOrder?.mergedToOrderId && (
                                            <Typography variant="body1">
                                                * {t("Merged into order")}{" "}
                                                <MuiLink component={RouterLink} to={`/orderdetailspage/${selectedOrder.mergedToOrderId}`} style={{ textDecoration: "none", color: "blue" }}>
                                                    {mergedToOrderNumber}
                                                </MuiLink>
                                            </Typography>
                                        )}
                                        
                                    </Box>
                                </Box>
                            {/* Email Panel */}
                            {/* Arrow buttons */}
                            <Box sx={{ position: "absolute", top: 70, right: 0, zIndex: 10 }}>
                                <IconButton onClick={increaseEmailWidth}><ChevronLeftIcon /></IconButton>
                                <IconButton onClick={decreaseEmailWidth}><ChevronRightIcon /></IconButton>
                            </Box>

                                <Box
                                    sx={{
                                        width: `${emailWidth}%`,
                                        overflowY: "auto",
                                        transition: "width 0.3s ease",
                                        padding: 0,
                                    }}
                                    marginTop="0px"
                                >
                                {selectedOrder && user && (
                                    <EmailConversation
                                        selectedOrder={selectedOrder}
                                        currentUser={user}
                                        contacts={contactsForCustomer}
                                        customers={customers}
                                        unassignedContacts={unassignedContacts}
                                        users={users}
                                        onFieldValueSelected={handleEditorValueAssign}
                                        setCustomers={setCustomers}
                                        setContacts={setContacts} 
                                        onUpdateCustomerForOrder={ handleUpdateOrder}
                                        />
                                    )}
                                </Box>
                            </Box>

                    ) : (
                      <Box
                        sx={{
                          flex: 1,
                          minHeight: 0,
                          overflow: "auto",
                          px: 2, // <== spacing between filter and grid (adds left & right padding)
                        }}
                      >
                                <OrderTable
                                    orders={orders}
                                    users={users}
                                    services={services} 
                                    orderStates={orderStates}
                                    customers={customers }
                                    onSaveOrder={async (order) => {
                                        await handleSave(order); // ignore the returned Order
                                    }}
                                    onDeleteOrder={handleDeleteOrder}
                                    onFieldValueSelected={handleEditorValueAssign}
                                />
                      </Box>
                    )}
                </Box>
                <Dialog
                    open={showEditSubjectDialog}
                    onClose={() => setShowEditSubjectDialog(false)}
                    maxWidth={false} // allow custom width
                    PaperProps={{
                        sx: {
                            width: "50vw",   // 50% of screen width
                        },
                    }}
                >
                    <DialogTitle>{t("Edit Shorten Subject")}</DialogTitle>
                    <DialogContent>
                        <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            value={tempShortenSubject}
                            onChange={(e) => setTempShortenSubject(e.target.value)}
                            sx={{ mt: 1 }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowEditSubjectDialog(false)} color="error">{t("Cancel")}</Button>
                        <Button onClick={() => {
                            updateSelectedOrder({ initialEmailSubjectShorten: tempShortenSubject });
                            setShowEditSubjectDialog(false);
                        }}>{t("Save")}</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={linkDialogOpen} onClose={() => setLinkDialogOpen(false)} fullWidth>
                    <DialogTitle>{t("Select Invoice to Link")}</DialogTitle>
                    <DialogContent>
                        <Autocomplete
                            options={availableInvoices}
                            getOptionLabel={(inv) => {
                                const paidStatus = inv.isPaid ? t("Paid") : t("Not Paid");
                                const date = inv.invoiceDate ? ` ${new Date(inv.invoiceDate).toLocaleDateString("en-GB")}` : "";
                                return `${inv.amount?.toFixed(2) ?? ""}€ — ${inv.accountingInvoiceNumber} from${date} (${paidStatus})`;
                            }}
                            onChange={(_, value) => {
                            setSelectedInvoiceId(value?.id ? value.id : null);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label={t("Select")} variant="outlined" fullWidth />
                            )}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                        />

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setLinkDialogOpen(false)} color="error">{t("Cancel")}</Button>
                        <Button variant="contained" onClick = {() => handleLinkInvoice(linkingInvoice2DetailId)} disabled={!selectedInvoiceId}>
                            {t("Link")}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={confirmUnlinkOpen} onClose={() => setConfirmUnlinkOpen(false)}>
                    <DialogTitle>Confirm Unlink</DialogTitle>
                    <DialogContent>
                        <Typography>Are you sure you want to unlink this invoice from the order?</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setConfirmUnlinkOpen(false)} color="error">{t("Cancel")}</Button>
                        <Button
                            color="error"
                            variant="contained"
                            onClick={() => {
                                if (invoiceToUnlink) handleUnlinkInvoice(invoiceToUnlink);
                                setConfirmUnlinkOpen(false);
                                setInvoiceToUnlink(null);
                            }}
                        >
                            {t("Unlink")}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={surveyDialogOpen} onClose={() => setSurveyDialogOpen(false)} fullWidth maxWidth="sm">
                    <DialogTitle>{t("Customer Satisfaction Surveys")}</DialogTitle>
                    <DialogContent>
                        {surveyResults.length === 0 && (
                            <Typography>{t("No surveys available for this order.")}</Typography>
                        )}
                        {surveyResults.map((s, idx) => (
                            <Box key={idx} sx={{ mb: 2, p: 1, borderBottom: "1px solid #eee" }}>
                                <Typography variant="body2">
                                    <strong>{dayjs(s.submittedAt).format("YYYY-MM-DD")}</strong> — {s.contactName || t("Unknown Contact")}
                                </Typography>
                                <Typography variant="body2">⭐ {s.score}</Typography>
                                {s.comment && <Typography variant="body2" sx={{ mt: 0.5 }}>{s.comment}</Typography>}
                            </Box>
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setSurveyDialogOpen(false)}>{t("Close")}</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={reminderDialogOpen} onClose={() => setReminderDialogOpen(false)}>
                    <DialogTitle>{editingReminder ? t("Edit Reminder") : t("Add Reminder")}</DialogTitle>
                    <DialogContent>
                        <DateTimePicker
                            label={t("Reminder Time")}
                            value={reminderDate}
                            onChange={(date) => setReminderDate(date)}
                        />
                        <TextField
                            label={t("Note")}
                            fullWidth
                            value={reminderNote}
                            onChange={(e) => setReminderNote(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setReminderDialogOpen(false)}>{t("Cancel")}</Button>
                        <Button onClick={saveReminder}>{t("Save")}</Button>
                    </DialogActions>
                </Dialog>

                {activeReminder && (
                    <Dialog open={true}>
                        <DialogTitle>{t("Reminder for Order")} {activeReminder.order?.internalNumber}</DialogTitle>
                        <DialogContent>
                            <Typography>{activeReminder.note}</Typography>
                        </DialogContent>
                        <DialogActions>
                            {[5, 10, 15, 30, 60].map((m) => (
                                <Button key={m} onClick={() => snoozeReminder(activeReminder.id, m)}>
                                    {t("Snooze")} {m}m
                                </Button>
                            ))}
                            <Button onClick={() => dismissReminder(activeReminder.id)} color="error">
                                {t("Dismiss")}
                            </Button>
                            <Button onClick={() => navigate(`/orderdetailspage/${activeReminder.orderId}`)}>
                                {t("View Order")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}

                <Dialog
                    open={reminderListDialogOpen}
                    onClose={() => setReminderListDialogOpen(false)}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>{t("Reminders for this Order")}</DialogTitle>
                    <DialogContent dividers>
                        {reminders.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">
                                {t("No reminders set.")}
                            </Typography>
                        ) : (
                            reminders.map((r) => (
                                <Box
                                    key={r.id}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    sx={{ mb: 1 }}
                                >
                                    <Typography>
                                        {formatUtcToLocal(r.reminderDateTimeUtc)} – {r.note}
                                    </Typography>
                                    <Box>
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                setEditingReminder(r);
                                                setReminderDate(dayjs(formatUtcToLocal(r.reminderDateTimeUtc))); // convert to local time
                                                setReminderNote(r.note || "");
                                                setReminderDialogOpen(true);
                                            }}
                                        >
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={async () => {
                                                
                                                await axiosExt.delete(`${API_BASE_URL}/orderreminders/${r.id}`, {
                                                    headers: { Authorization: `Bearer ${token}` },
                                                });
                                                fetchReminders(selectedOrder!.id);
                                            }}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setEditingReminder(null);
                                setReminderDate(dayjs());
                                setReminderNote("");
                                setReminderDialogOpen(true);
                            }}
                        >
                            {t("Add Reminder")}
                        </Button>
                        <Button onClick={() => setReminderListDialogOpen(false)}>{t("Close")}</Button>
                    </DialogActions>
                </Dialog>

            </Layout>
            </LocalizationProvider>     
    );
};

export default OrderDetailPage;
